import { baseApi as api } from "./base";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getIntercomJwt: build.query<GetIntercomJwtApiResponse, GetIntercomJwtApiArg>({
      query: () => ({ url: `/intercom/intercom-jwt` }),
    }),
    getConversationV2: build.query<GetConversationV2ApiResponse, GetConversationV2ApiArg>({
      query: (queryArg) => ({ url: `/intercom/conversation/v2/${queryArg.id}` }),
    }),
    getTags: build.query<GetTagsApiResponse, GetTagsApiArg>({
      query: () => ({ url: `/intercom/tags` }),
    }),
    getClientConversationHistory: build.query<
      GetClientConversationHistoryApiResponse,
      GetClientConversationHistoryApiArg
    >({
      query: () => ({ url: `/intercom/conversation-history` }),
    }),
    replyToConversation: build.mutation<ReplyToConversationApiResponse, ReplyToConversationApiArg>({
      query: (queryArg) => ({
        url: `/intercom/conversation/reply`,
        method: "POST",
        body: queryArg.conversationReplyDto,
      }),
    }),
    replyToConversationImageUpload: build.mutation<
      ReplyToConversationImageUploadApiResponse,
      ReplyToConversationImageUploadApiArg
    >({
      query: (queryArg) => ({
        url: `/intercom/conversation/reply/file`,
        method: "POST",
        body: queryArg.conversationReplyImageUploadDto,
      }),
    }),
    createConversation: build.mutation<CreateConversationApiResponse, CreateConversationApiArg>({
      query: (queryArg) => ({
        url: `/intercom/conversation/create`,
        method: "POST",
        body: queryArg.intercomCreateConversationDto,
      }),
    }),
    getUserId: build.mutation<GetUserIdApiResponse, GetUserIdApiArg>({
      query: () => ({ url: `/intercom/user`, method: "POST" }),
    }),
    createMonoovaAccount: build.mutation<
      CreateMonoovaAccountApiResponse,
      CreateMonoovaAccountApiArg
    >({
      query: () => ({ url: `/monoova/createAccount`, method: "POST" }),
    }),
    getMonoovaAccountDetails: build.query<
      GetMonoovaAccountDetailsApiResponse,
      GetMonoovaAccountDetailsApiArg
    >({
      query: () => ({ url: `/monoova/account` }),
    }),
    getUserIdByMonoovaAccountNumber: build.query<
      GetUserIdByMonoovaAccountNumberApiResponse,
      GetUserIdByMonoovaAccountNumberApiArg
    >({
      query: (queryArg) => ({ url: `/monoova/user/${queryArg.bankAccountNumber}` }),
    }),
    identifyUser: build.mutation<IdentifyUserApiResponse, IdentifyUserApiArg>({
      query: (queryArg) => ({
        url: `/knock/identifyUser`,
        method: "POST",
        body: queryArg.identifyUser,
      }),
    }),
    retrieveUser: build.query<RetrieveUserApiResponse, RetrieveUserApiArg>({
      query: () => ({ url: `/knock/retrieveUser` }),
    }),
    setPreferences: build.mutation<SetPreferencesApiResponse, SetPreferencesApiArg>({
      query: (queryArg) => ({
        url: `/knock/setPreferences`,
        method: "POST",
        body: queryArg.setPreferences,
      }),
    }),
    getPreferences: build.query<GetPreferencesApiResponse, GetPreferencesApiArg>({
      query: () => ({ url: `/knock/getPreferences` }),
    }),
    triggerKnockWorkflow: build.mutation<
      TriggerKnockWorkflowApiResponse,
      TriggerKnockWorkflowApiArg
    >({
      query: (queryArg) => ({
        url: `/knock/triggerKnockWorkflow`,
        method: "POST",
        body: queryArg.triggerKnockWorkflow,
      }),
    }),
    triggerKnockWorkflowV2: build.mutation<
      TriggerKnockWorkflowV2ApiResponse,
      TriggerKnockWorkflowV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/knock/triggerKnockWorkflowV2`,
        method: "POST",
        body: queryArg.triggerKnockWorkflow,
      }),
    }),
    setChannelData: build.mutation<SetChannelDataApiResponse, SetChannelDataApiArg>({
      query: (queryArg) => ({
        url: `/knock/setChannelData`,
        method: "POST",
        body: queryArg.setChannelData,
      }),
    }),
    setWorkflowPreference: build.mutation<
      SetWorkflowPreferenceApiResponse,
      SetWorkflowPreferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/knock/workflowPreference`,
        method: "POST",
        body: queryArg.setWorkflowPreferenceDto,
      }),
    }),
    verifyAddressDataZoo: build.mutation<
      VerifyAddressDataZooApiResponse,
      VerifyAddressDataZooApiArg
    >({
      query: (queryArg) => ({
        url: `/datazoo/verify-address`,
        method: "POST",
        body: queryArg.iDataZooVerification,
      }),
    }),
    verifyBulkDatazooAddress: build.mutation<
      VerifyBulkDatazooAddressApiResponse,
      VerifyBulkDatazooAddressApiArg
    >({
      query: () => ({ url: `/datazoo/verify-bulk-address`, method: "POST" }),
    }),
    getTaxAccount: build.query<GetTaxAccountApiResponse, GetTaxAccountApiArg>({
      query: () => ({ url: `/tax/account` }),
    }),
    updateTaxAccount: build.mutation<UpdateTaxAccountApiResponse, UpdateTaxAccountApiArg>({
      query: (queryArg) => ({
        url: `/tax/account`,
        method: "PATCH",
        body: queryArg.taxBitUpdateAccountDto,
      }),
    }),
    getReleasedTaxDocuments: build.query<
      GetReleasedTaxDocumentsApiResponse,
      GetReleasedTaxDocumentsApiArg
    >({
      query: (queryArg) => ({
        url: `/tax/documents`,
        params: { include_historical: queryArg.includeHistorical },
      }),
    }),
    getTaxTransactions: build.query<GetTaxTransactionsApiResponse, GetTaxTransactionsApiArg>({
      query: (queryArg) => ({
        url: `/tax/transactions`,
        params: {
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
          page_size: queryArg.pageSize,
          continuation_key: queryArg.continuationKey,
        },
      }),
    }),
    createTaxTransferLots: build.mutation<
      CreateTaxTransferLotsApiResponse,
      CreateTaxTransferLotsApiArg
    >({
      query: (queryArg) => ({
        url: `/tax/transfer-lots/transactions/${queryArg.transactionId}`,
        method: "POST",
        body: queryArg.taxBitCreateTransferLotsDto,
      }),
    }),
    getTaxTransferLots: build.query<GetTaxTransferLotsApiResponse, GetTaxTransferLotsApiArg>({
      query: (queryArg) => ({ url: `/tax/transfer-lots/transactions/${queryArg.transactionId}` }),
    }),
    deleteTaxTransferLots: build.mutation<
      DeleteTaxTransferLotsApiResponse,
      DeleteTaxTransferLotsApiArg
    >({
      query: (queryArg) => ({
        url: `/tax/transfer-lots/transactions/${queryArg.transactionId}`,
        method: "DELETE",
      }),
    }),
    getTaxDocumentationToken: build.query<
      GetTaxDocumentationTokenApiResponse,
      GetTaxDocumentationTokenApiArg
    >({
      query: () => ({ url: `/tax/documentation/token` }),
    }),
    getTaxDocumentationStatus: build.query<
      GetTaxDocumentationStatusApiResponse,
      GetTaxDocumentationStatusApiArg
    >({
      query: () => ({ url: `/tax/documentation/status` }),
    }),
    createAccount: build.mutation<CreateAccountApiResponse, CreateAccountApiArg>({
      query: (queryArg) => ({
        url: `/account/createAccount`,
        method: "POST",
        body: queryArg.createAccountDto,
      }),
    }),
    legacyCreateAccount: build.mutation<LegacyCreateAccountApiResponse, LegacyCreateAccountApiArg>({
      query: (queryArg) => ({
        url: `/account/legacyCreateAccount`,
        method: "POST",
        body: queryArg.legacyCreateAccountDto,
      }),
    }),
    getMultiAccountUsers: build.query<GetMultiAccountUsersApiResponse, GetMultiAccountUsersApiArg>({
      query: () => ({ url: `/account/users` }),
    }),
    setSelectedUser: build.mutation<SetSelectedUserApiResponse, SetSelectedUserApiArg>({
      query: (queryArg) => ({
        url: `/account/setSelectedUser`,
        method: "PATCH",
        body: queryArg.customerIdDto,
      }),
    }),
    setDefaultUser: build.mutation<SetDefaultUserApiResponse, SetDefaultUserApiArg>({
      query: (queryArg) => ({
        url: `/account/setDefaultUser`,
        method: "PATCH",
        body: queryArg.customerIdDto,
      }),
    }),
    acceptTerms: build.mutation<AcceptTermsApiResponse, AcceptTermsApiArg>({
      query: () => ({ url: `/account/acceptTerms`, method: "PATCH" }),
    }),
    acceptWelcomeModal: build.mutation<AcceptWelcomeModalApiResponse, AcceptWelcomeModalApiArg>({
      query: () => ({ url: `/account/acceptWelcomeModal`, method: "PATCH" }),
    }),
    acceptTrEducationModal: build.mutation<
      AcceptTrEducationModalApiResponse,
      AcceptTrEducationModalApiArg
    >({
      query: () => ({ url: `/account/acceptTrEducationModal`, method: "PATCH" }),
    }),
    handleResetPassword: build.mutation<HandleResetPasswordApiResponse, HandleResetPasswordApiArg>({
      query: (queryArg) => ({
        url: `/account/handleResetPassword`,
        method: "POST",
        body: queryArg.resetPasswordDto,
      }),
    }),
    forgotPassword: build.mutation<ForgotPasswordApiResponse, ForgotPasswordApiArg>({
      query: (queryArg) => ({
        url: `/account/forgotPassword`,
        method: "POST",
        body: queryArg.forgotPasswordRequestDto,
      }),
    }),
    sendSmsotp: build.mutation<SendSmsotpApiResponse, SendSmsotpApiArg>({
      query: (queryArg) => ({
        url: `/account/sendSMSOTP`,
        method: "POST",
        body: queryArg.sendSmsotpDto,
      }),
    }),
    verifySmsotp: build.mutation<VerifySmsotpApiResponse, VerifySmsotpApiArg>({
      query: (queryArg) => ({
        url: `/account/verifySMSOTP`,
        method: "POST",
        body: queryArg.verifySmsotpDto,
      }),
    }),
    lockAccount: build.mutation<LockAccountApiResponse, LockAccountApiArg>({
      query: (queryArg) => ({
        url: `/account/lock-account`,
        method: "PATCH",
        body: queryArg.lockAccountDto,
      }),
    }),
    createPendingAccount: build.mutation<
      CreatePendingAccountApiResponse,
      CreatePendingAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/account/create-pending-account`,
        method: "POST",
        body: queryArg.createPendingAccountDto,
      }),
    }),
    submitPhoneNumber: build.mutation<SubmitPhoneNumberApiResponse, SubmitPhoneNumberApiArg>({
      query: (queryArg) => ({
        url: `/account/submit-phone-number`,
        method: "POST",
        body: queryArg.submitPendingAccountPhoneNumberDto,
      }),
    }),
    verifyPhoneNumber: build.mutation<VerifyPhoneNumberApiResponse, VerifyPhoneNumberApiArg>({
      query: (queryArg) => ({
        url: `/account/verify-phone-number`,
        method: "POST",
        body: queryArg.verifyPendingAccountPhoneNumberDto,
      }),
    }),
    getLatestContactChange: build.query<
      GetLatestContactChangeApiResponse,
      GetLatestContactChangeApiArg
    >({
      query: () => ({ url: `/contact-change/latest` }),
    }),
    createContactChange: build.mutation<CreateContactChangeApiResponse, CreateContactChangeApiArg>({
      query: (queryArg) => ({
        url: `/contact-change/create`,
        method: "POST",
        body: queryArg.createContactChangeReqDto,
      }),
    }),
    checkPassword: build.mutation<CheckPasswordApiResponse, CheckPasswordApiArg>({
      query: (queryArg) => ({
        url: `/contact-change/password/verify`,
        method: "POST",
        body: queryArg.passwordDto,
      }),
    }),
    verifySecondaryAuthCode: build.mutation<
      VerifySecondaryAuthCodeApiResponse,
      VerifySecondaryAuthCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/contact-change/secondary-value/verify`,
        method: "POST",
        body: queryArg.mfaCodeDto,
      }),
    }),
    resendSecondaryAuthCode: build.mutation<
      ResendSecondaryAuthCodeApiResponse,
      ResendSecondaryAuthCodeApiArg
    >({
      query: () => ({ url: `/contact-change/secondary-value/resend`, method: "POST" }),
    }),
    processRequestedValues: build.mutation<
      ProcessRequestedValuesApiResponse,
      ProcessRequestedValuesApiArg
    >({
      query: (queryArg) => ({
        url: `/contact-change/requested-value/process`,
        method: "POST",
        body: queryArg.processRequestedValuesReqDto,
      }),
    }),
    verifyRequestedValueCode: build.mutation<
      VerifyRequestedValueCodeApiResponse,
      VerifyRequestedValueCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/contact-change/requested-value/verify`,
        method: "POST",
        body: queryArg.mfaCodeDto,
      }),
    }),
    resendRequestedAuthCode: build.mutation<
      ResendRequestedAuthCodeApiResponse,
      ResendRequestedAuthCodeApiArg
    >({
      query: () => ({ url: `/contact-change/requested-value/resend`, method: "POST" }),
    }),
    check2FaCode: build.mutation<Check2FaCodeApiResponse, Check2FaCodeApiArg>({
      query: (queryArg) => ({
        url: `/contact-change/2fa/verify`,
        method: "POST",
        body: queryArg.mfaCodeDto,
      }),
    }),
    initiateMfa: build.mutation<InitiateMfaApiResponse, InitiateMfaApiArg>({
      query: () => ({ url: `/contact-change/mfa-checks/initiate`, method: "POST" }),
    }),
    clearMfa: build.mutation<ClearMfaApiResponse, ClearMfaApiArg>({
      query: () => ({ url: `/contact-change/mfa-checks/clear`, method: "POST" }),
    }),
    submitContactChange: build.mutation<SubmitContactChangeApiResponse, SubmitContactChangeApiArg>({
      query: () => ({ url: `/contact-change/submit`, method: "POST" }),
    }),
    cancelContactChange: build.mutation<CancelContactChangeApiResponse, CancelContactChangeApiArg>({
      query: () => ({ url: `/contact-change/cancel`, method: "POST" }),
    }),
    updateOnfidoSteps: build.mutation<UpdateOnfidoStepsApiResponse, UpdateOnfidoStepsApiArg>({
      query: () => ({ url: `/contact-change/status/update`, method: "POST" }),
    }),
    login: build.mutation<LoginApiResponse, LoginApiArg>({
      query: (queryArg) => ({ url: `/auth/login`, method: "POST", body: queryArg.loginDto }),
    }),
    loginV2: build.mutation<LoginV2ApiResponse, LoginV2ApiArg>({
      query: (queryArg) => ({ url: `/auth/loginv2`, method: "POST", body: queryArg.loginDtoV2 }),
    }),
    loginAdminPortal: build.mutation<LoginAdminPortalApiResponse, LoginAdminPortalApiArg>({
      query: (queryArg) => ({
        url: `/auth/adminPortal`,
        method: "POST",
        body: queryArg.loginAdminDto,
      }),
    }),
    loginNative: build.mutation<LoginNativeApiResponse, LoginNativeApiArg>({
      query: (queryArg) => ({ url: `/auth/loginNative`, method: "POST", body: queryArg.loginDto }),
    }),
    refreshSession: build.mutation<RefreshSessionApiResponse, RefreshSessionApiArg>({
      query: (queryArg) => ({
        url: `/auth/refreshSession`,
        method: "POST",
        body: queryArg.refreshSessionDto,
      }),
    }),
    refreshSessionV1: build.mutation<RefreshSessionV1ApiResponse, RefreshSessionV1ApiArg>({
      query: (queryArg) => ({
        url: `/auth/refreshSessionV1`,
        method: "POST",
        body: queryArg.refreshSessionDto,
      }),
    }),
    endSession: build.mutation<EndSessionApiResponse, EndSessionApiArg>({
      query: () => ({ url: `/auth/endSession`, method: "POST" }),
    }),
    tokenExchange: build.mutation<TokenExchangeApiResponse, TokenExchangeApiArg>({
      query: (queryArg) => ({
        url: `/auth/tokenExchange`,
        method: "POST",
        body: queryArg.tokenExchangeDto,
      }),
    }),
    verifyActionToken: build.mutation<VerifyActionTokenApiResponse, VerifyActionTokenApiArg>({
      query: (queryArg) => ({
        url: `/auth/actionToken`,
        method: "POST",
        body: queryArg.actionTokenReqDto,
      }),
    }),
    verifyTransactionRisk: build.mutation<
      VerifyTransactionRiskApiResponse,
      VerifyTransactionRiskApiArg
    >({
      query: (queryArg) => ({
        url: `/auth/transactionRisk`,
        method: "POST",
        body: queryArg.transactionRiskReqDto,
      }),
    }),
    loginRecord: build.mutation<LoginRecordApiResponse, LoginRecordApiArg>({
      query: (queryArg) => ({
        url: `/auth/loginRecord`,
        method: "POST",
        body: queryArg.loginRecordDto,
      }),
    }),
    riskRecord: build.mutation<RiskRecordApiResponse, RiskRecordApiArg>({
      query: (queryArg) => ({
        url: `/auth/riskRecord`,
        method: "POST",
        body: queryArg.riskFailureRecordDto,
      }),
    }),
    magicLink: build.mutation<MagicLinkApiResponse, MagicLinkApiArg>({
      query: (queryArg) => ({
        url: `/auth/magicLink`,
        method: "POST",
        body: queryArg.magicLinkDto,
      }),
    }),
    changePassword: build.mutation<ChangePasswordApiResponse, ChangePasswordApiArg>({
      query: (queryArg) => ({
        url: `/auth/change-password`,
        method: "POST",
        body: queryArg.changePasswordDto,
      }),
    }),
    getWebAuthnCredentials: build.query<
      GetWebAuthnCredentialsApiResponse,
      GetWebAuthnCredentialsApiArg
    >({
      query: () => ({ url: `/auth/get-webauthn-credentials` }),
    }),
    postWebAuthnCredentials: build.mutation<
      PostWebAuthnCredentialsApiResponse,
      PostWebAuthnCredentialsApiArg
    >({
      query: (queryArg) => ({
        url: `/auth/register-webauthn-credentials`,
        method: "POST",
        body: queryArg.webAuthnCredentialsDto,
      }),
    }),
    updateWebAuthnCredentials: build.mutation<
      UpdateWebAuthnCredentialsApiResponse,
      UpdateWebAuthnCredentialsApiArg
    >({
      query: (queryArg) => ({
        url: `/auth/update-webauthn-credentials`,
        method: "POST",
        body: queryArg.updateWebAuthnCredentialsDto,
      }),
    }),
    deleteWebAuthnCredentials: build.mutation<
      DeleteWebAuthnCredentialsApiResponse,
      DeleteWebAuthnCredentialsApiArg
    >({
      query: (queryArg) => ({
        url: `/auth/delete-webauthn-credentials`,
        method: "POST",
        body: queryArg.webAuthnDeleteCredentialsDto,
      }),
    }),
    webauthnTokenExchange: build.mutation<
      WebauthnTokenExchangeApiResponse,
      WebauthnTokenExchangeApiArg
    >({
      query: (queryArg) => ({
        url: `/auth/webauthnTokenExchange`,
        method: "POST",
        body: queryArg.webAuthnCredentialsDto,
      }),
    }),
    createSms2Fa: build.query<CreateSms2FaApiResponse, CreateSms2FaApiArg>({
      query: () => ({ url: `/mfa/createSMS2FA` }),
    }),
    verifySms2Fa: build.mutation<VerifySms2FaApiResponse, VerifySms2FaApiArg>({
      query: (queryArg) => ({
        url: `/mfa/verifySMS2FA`,
        method: "POST",
        body: queryArg.twoFactorDto,
      }),
    }),
    create2Fa: build.query<Create2FaApiResponse, Create2FaApiArg>({
      query: () => ({ url: `/mfa/create2FA` }),
    }),
    verify2Fa: build.mutation<Verify2FaApiResponse, Verify2FaApiArg>({
      query: (queryArg) => ({ url: `/mfa/verify2FA`, method: "POST", body: queryArg.twoFactorDto }),
    }),
    deactivate2Fa: build.mutation<Deactivate2FaApiResponse, Deactivate2FaApiArg>({
      query: (queryArg) => ({
        url: `/mfa/deactivate2FA`,
        method: "POST",
        body: queryArg.twoFactorDto,
      }),
    }),
    sendEmailCode: build.mutation<SendEmailCodeApiResponse, SendEmailCodeApiArg>({
      query: (queryArg) => ({
        url: `/mfa/send-email`,
        method: "POST",
        body: queryArg.twoFaEmailVerificationDto,
      }),
    }),
    check2FaEmailCode: build.mutation<Check2FaEmailCodeApiResponse, Check2FaEmailCodeApiArg>({
      query: (queryArg) => ({
        url: `/mfa/check-2fa-email-code`,
        method: "POST",
        body: queryArg.twoFaVerificationDto,
      }),
    }),
    handleContactUsForm: build.mutation<HandleContactUsFormApiResponse, HandleContactUsFormApiArg>({
      query: (queryArg) => ({
        url: `/onboarding/handleContactUs`,
        method: "POST",
        body: queryArg.contactUsFormReqDto,
      }),
    }),
    createApplicant: build.query<CreateApplicantApiResponse, CreateApplicantApiArg>({
      query: (queryArg) => ({ url: `/onboarding/kyc/create`, params: { reason: queryArg.reason } }),
    }),
    updateReKycSteps: build.query<UpdateReKycStepsApiResponse, UpdateReKycStepsApiArg>({
      query: () => ({ url: `/onboarding/kyc/update-rekyc-steps` }),
    }),
    validateSecureBiometrics: build.query<
      ValidateSecureBiometricsApiResponse,
      ValidateSecureBiometricsApiArg
    >({
      query: (queryArg) => ({
        url: `/onboarding/kyc/validate-secure-biometrics`,
        params: { code: queryArg.code },
      }),
    }),
    addApplicantToOngoingMonitoring: build.mutation<
      AddApplicantToOngoingMonitoringApiResponse,
      AddApplicantToOngoingMonitoringApiArg
    >({
      query: (queryArg) => ({
        url: `/onboarding/kyc/createOngoingMonitoring`,
        method: "POST",
        body: queryArg.createOngoingMonitoringDto,
      }),
    }),
    slackAppActionHandler: build.mutation<
      SlackAppActionHandlerApiResponse,
      SlackAppActionHandlerApiArg
    >({
      query: () => ({ url: `/onboarding/slack-app-action-handler`, method: "POST" }),
    }),
    updateKycSteps: build.mutation<UpdateKycStepsApiResponse, UpdateKycStepsApiArg>({
      query: (queryArg) => ({
        url: `/onboarding/kyc/steps`,
        method: "POST",
        body: queryArg.updateKycStepsDto,
      }),
    }),
    getUserDetails: build.query<GetUserDetailsApiResponse, GetUserDetailsApiArg>({
      query: () => ({ url: `/onboarding/kyc/getUserDetails` }),
    }),
    handlePotentialPep: build.mutation<HandlePotentialPepApiResponse, HandlePotentialPepApiArg>({
      query: (queryArg) => ({
        url: `/onboarding/webhook/potentialPEP`,
        method: "POST",
        body: queryArg.onfidoPayload,
      }),
    }),
    lookUpAddressFromInput: build.query<
      LookUpAddressFromInputApiResponse,
      LookUpAddressFromInputApiArg
    >({
      query: (queryArg) => ({ url: `/onboarding/address-lookup/${queryArg.input}` }),
    }),
    getPlaceDetail: build.mutation<GetPlaceDetailApiResponse, GetPlaceDetailApiArg>({
      query: (queryArg) => ({
        url: `/onboarding/place-detail`,
        method: "POST",
        body: queryArg.getPlaceDetailsDto,
      }),
    }),
    getSalesforceAccounts: build.query<
      GetSalesforceAccountsApiResponse,
      GetSalesforceAccountsApiArg
    >({
      query: (queryArg) => ({
        url: `/onboarding/get-salesforce-accounts`,
        params: {
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          success: queryArg.success,
        },
      }),
    }),
    createSalesForceAccount: build.mutation<
      CreateSalesForceAccountApiResponse,
      CreateSalesForceAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/onboarding/create-salesforce-account`,
        method: "POST",
        body: queryArg.createSfAccountPayloadDto,
      }),
    }),
    processOnboardingQueues: build.mutation<
      ProcessOnboardingQueuesApiResponse,
      ProcessOnboardingQueuesApiArg
    >({
      query: (queryArg) => ({
        url: `/onboarding/process-onboarding-queues`,
        method: "POST",
        body: queryArg.dataZooQueuePayload,
      }),
    }),
    rekycSalesForceOpportunity: build.mutation<
      RekycSalesForceOpportunityApiResponse,
      RekycSalesForceOpportunityApiArg
    >({
      query: (queryArg) => ({
        url: `/onboarding/rekyc`,
        method: "POST",
        body: queryArg.reKycSfOpportunityPayloadDto,
      }),
    }),
    uploadFile: build.mutation<UploadFileApiResponse, UploadFileApiArg>({
      query: (queryArg) => ({ url: `/onboarding/upload`, method: "POST", body: queryArg.formData }),
    }),
    deleteFile: build.mutation<DeleteFileApiResponse, DeleteFileApiArg>({
      query: (queryArg) => ({
        url: `/onboarding/delete-file`,
        method: "DELETE",
        params: { contentVersionId: queryArg.contentVersionId, code: queryArg.code },
      }),
    }),
    encodeMessage: build.mutation<EncodeMessageApiResponse, EncodeMessageApiArg>({
      query: (queryArg) => ({
        url: `/onboarding/encode-message`,
        method: "POST",
        body: queryArg.encodeMessageDto,
        headers: { "x-api-key": queryArg["x-api-key"] },
      }),
    }),
    validateSecureUploadToken: build.mutation<
      ValidateSecureUploadTokenApiResponse,
      ValidateSecureUploadTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/onboarding/validate-secure-upload-token`,
        method: "POST",
        body: queryArg.decodeMessageDto,
      }),
    }),
    handleSecureFileUpload: build.mutation<
      HandleSecureFileUploadApiResponse,
      HandleSecureFileUploadApiArg
    >({
      query: (queryArg) => ({
        url: `/onboarding/handle-secure-upload-form`,
        method: "POST",
        body: queryArg.secureFileUploadDto,
      }),
    }),
    handleOnfidoWorkflow: build.mutation<
      HandleOnfidoWorkflowApiResponse,
      HandleOnfidoWorkflowApiArg
    >({
      query: (queryArg) => ({
        url: `/onboarding/webhook/workflow`,
        method: "POST",
        body: queryArg.onfidoWorkflowPayload,
      }),
    }),
    handleTimelineFile: build.mutation<HandleTimelineFileApiResponse, HandleTimelineFileApiArg>({
      query: (queryArg) => ({
        url: `/onboarding/webhook/handle-timeline-file`,
        method: "POST",
        body: queryArg.onfidoTimelineFileWebhook,
      }),
    }),
    checkIndividualTradingAccountByEmail: build.query<
      CheckIndividualTradingAccountByEmailApiResponse,
      CheckIndividualTradingAccountByEmailApiArg
    >({
      query: () => ({ url: `/onboarding/individual-trading-account-check` }),
    }),
    getPreviousSubmissionByEmail: build.query<
      GetPreviousSubmissionByEmailApiResponse,
      GetPreviousSubmissionByEmailApiArg
    >({
      query: () => ({ url: `/onboarding/previous-submission` }),
    }),
    isKycExpiredByEmail: build.query<IsKycExpiredByEmailApiResponse, IsKycExpiredByEmailApiArg>({
      query: () => ({ url: `/onboarding/is-kyc-expired` }),
    }),
    isDocumentExpired: build.query<IsDocumentExpiredApiResponse, IsDocumentExpiredApiArg>({
      query: () => ({ url: `/onboarding/is-document-expired` }),
    }),
    handleUnsubscribePreferences: build.mutation<
      HandleUnsubscribePreferencesApiResponse,
      HandleUnsubscribePreferencesApiArg
    >({
      query: (queryArg) => ({
        url: `/onboarding/sendgrid/webhook/email-preferences`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    addContactToMarketingList: build.mutation<
      AddContactToMarketingListApiResponse,
      AddContactToMarketingListApiArg
    >({
      query: (queryArg) => ({
        url: `/onboarding/sendgrid/add-contact-to-marketing-list`,
        method: "POST",
        body: queryArg.sendgridContactToListDto,
      }),
    }),
    extractWorkflowDocProp: build.query<
      ExtractWorkflowDocPropApiResponse,
      ExtractWorkflowDocPropApiArg
    >({
      query: () => ({ url: `/onboarding/extractWorkflowDocProp` }),
    }),
    getOccupationList: build.query<GetOccupationListApiResponse, GetOccupationListApiArg>({
      query: () => ({ url: `/onboarding/occupation-list` }),
    }),
    getIndustriesList: build.query<GetIndustriesListApiResponse, GetIndustriesListApiArg>({
      query: () => ({ url: `/onboarding/industries-list` }),
    }),
    createDynamicFileUploadLink: build.query<
      CreateDynamicFileUploadLinkApiResponse,
      CreateDynamicFileUploadLinkApiArg
    >({
      query: (queryArg) => ({
        url: `/onboarding/create-dynamic-upload-link`,
        params: { reason: queryArg.reason },
      }),
    }),
    dvsDisclosure: build.mutation<DvsDisclosureApiResponse, DvsDisclosureApiArg>({
      query: (queryArg) => ({
        url: `/onboarding/dvs-disclosure`,
        method: "POST",
        body: queryArg.dvsDisclosurePayloadDto,
      }),
    }),
    onfidoBiometricsConsent: build.mutation<
      OnfidoBiometricsConsentApiResponse,
      OnfidoBiometricsConsentApiArg
    >({
      query: (queryArg) => ({
        url: `/onboarding/onfido-biometrics-consent`,
        method: "POST",
        body: queryArg.onfidoBiometricsConsentPayloadDto,
      }),
    }),
    notifyBrokerCall: build.mutation<NotifyBrokerCallApiResponse, NotifyBrokerCallApiArg>({
      query: (queryArg) => ({
        url: `/sf/notify-broker-call`,
        method: "POST",
        body: queryArg.notifyBrokerCallDto,
      }),
    }),
    updateSsnEin: build.mutation<UpdateSsnEinApiResponse, UpdateSsnEinApiArg>({
      query: (queryArg) => ({
        url: `/sf/update-ssn-ein`,
        method: "PATCH",
        body: queryArg.updateSsnEinDto,
      }),
    }),
    getRiskScoreConfig: build.query<GetRiskScoreConfigApiResponse, GetRiskScoreConfigApiArg>({
      query: () => ({ url: `/sf/risk-score-config` }),
    }),
    createAccessToken: build.mutation<CreateAccessTokenApiResponse, CreateAccessTokenApiArg>({
      query: (queryArg) => ({
        url: `/sumsub/create-access-token`,
        method: "POST",
        body: queryArg.iCreateSumsubApplicantDto,
      }),
    }),
    webhook: build.mutation<WebhookApiResponse, WebhookApiArg>({
      query: () => ({ url: `/sumsub/webhook`, method: "POST" }),
    }),
    getApplicantStatus: build.query<GetApplicantStatusApiResponse, GetApplicantStatusApiArg>({
      query: () => ({ url: `/sumsub/get-applicant-status` }),
    }),
    getTrustfullScoreViaReq: build.query<
      GetTrustfullScoreViaReqApiResponse,
      GetTrustfullScoreViaReqApiArg
    >({
      query: () => ({ url: `/automatedKycJourney/updateTrustfullStatus` }),
    }),
    generateAssessmentLink: build.mutation<
      GenerateAssessmentLinkApiResponse,
      GenerateAssessmentLinkApiArg
    >({
      query: (queryArg) => ({
        url: `/onboarding/uk/assessment/generate-link`,
        method: "POST",
        body: queryArg.generateUkAssessmentLinkDto,
      }),
    }),
    validateAssessmentToken: build.mutation<
      ValidateAssessmentTokenApiResponse,
      ValidateAssessmentTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/onboarding/uk/public/assessment/validate-token`,
        method: "POST",
        body: queryArg.validateUkAssessmentTokenDto,
      }),
    }),
    getPublicAssessmentQuestions: build.mutation<
      GetPublicAssessmentQuestionsApiResponse,
      GetPublicAssessmentQuestionsApiArg
    >({
      query: (queryArg) => ({
        url: `/onboarding/uk/public/assessment/questions`,
        method: "POST",
        body: queryArg.validateUkAssessmentTokenDto,
      }),
    }),
    submitPublicAssessment: build.mutation<
      SubmitPublicAssessmentApiResponse,
      SubmitPublicAssessmentApiArg
    >({
      query: (queryArg) => ({
        url: `/onboarding/uk/public/assessment/submit`,
        method: "POST",
        body: queryArg.submitPublicUkAssessmentDto,
      }),
    }),
    getUkOnboardingStatus: build.query<
      GetUkOnboardingStatusApiResponse,
      GetUkOnboardingStatusApiArg
    >({
      query: () => ({ url: `/onboarding/uk/status` }),
    }),
    markRiskSummaryViewed: build.mutation<
      MarkRiskSummaryViewedApiResponse,
      MarkRiskSummaryViewedApiArg
    >({
      query: () => ({ url: `/onboarding/uk/risk-summary/viewed`, method: "POST" }),
    }),
    submitUkAccountType: build.mutation<SubmitUkAccountTypeApiResponse, SubmitUkAccountTypeApiArg>({
      query: (queryArg) => ({
        url: `/onboarding/uk/account-type`,
        method: "POST",
        body: queryArg.submitUkAccountTypeDto,
      }),
    }),
    restartUkOnboarding: build.mutation<RestartUkOnboardingApiResponse, RestartUkOnboardingApiArg>({
      query: () => ({ url: `/onboarding/uk/restart`, method: "POST" }),
    }),
    submitInvestorType: build.mutation<SubmitInvestorTypeApiResponse, SubmitInvestorTypeApiArg>({
      query: (queryArg) => ({
        url: `/onboarding/uk/investor-type`,
        method: "POST",
        body: queryArg.submitInvestorTypeDto,
      }),
    }),
    submitRestrictedInvestorStatement: build.mutation<
      SubmitRestrictedInvestorStatementApiResponse,
      SubmitRestrictedInvestorStatementApiArg
    >({
      query: (queryArg) => ({
        url: `/onboarding/uk/restricted-statement`,
        method: "POST",
        body: queryArg.submitRestrictedInvestorStatementDto,
      }),
    }),
    submitHnwInvestorStatement: build.mutation<
      SubmitHnwInvestorStatementApiResponse,
      SubmitHnwInvestorStatementApiArg
    >({
      query: (queryArg) => ({
        url: `/onboarding/uk/hnw-statement`,
        method: "POST",
        body: queryArg.submitHnwInvestorStatementDto,
      }),
    }),
    getAssessmentQuestions: build.query<
      GetAssessmentQuestionsApiResponse,
      GetAssessmentQuestionsApiArg
    >({
      query: () => ({ url: `/onboarding/uk/assessment/questions` }),
    }),
    submitAssessment: build.mutation<SubmitAssessmentApiResponse, SubmitAssessmentApiArg>({
      query: (queryArg) => ({
        url: `/onboarding/uk/assessment/submit`,
        method: "POST",
        body: queryArg.submitAssessmentDto,
      }),
    }),
    getAssessmentStatus: build.query<GetAssessmentStatusApiResponse, GetAssessmentStatusApiArg>({
      query: () => ({ url: `/onboarding/uk/assessment/status` }),
    }),
    getCoolingOffStatus: build.query<GetCoolingOffStatusApiResponse, GetCoolingOffStatusApiArg>({
      query: () => ({ url: `/onboarding/uk/cooling-off/status` }),
    }),
    confirmAccount: build.mutation<ConfirmAccountApiResponse, ConfirmAccountApiArg>({
      query: () => ({ url: `/onboarding/uk/confirm`, method: "POST" }),
    }),
    declineAccount: build.mutation<DeclineAccountApiResponse, DeclineAccountApiArg>({
      query: () => ({ url: `/onboarding/uk/decline`, method: "POST" }),
    }),
    getFundTrades: build.query<GetFundTradesApiResponse, GetFundTradesApiArg>({
      query: (queryArg) => ({
        url: `/external/fund/trades`,
        params: { fromDate: queryArg.fromDate, toDate: queryArg.toDate },
      }),
    }),
    getFundFlows: build.query<GetFundFlowsApiResponse, GetFundFlowsApiArg>({
      query: (queryArg) => ({
        url: `/external/fund/flows`,
        params: { fromDate: queryArg.fromDate, toDate: queryArg.toDate },
      }),
    }),
    getFundPositions: build.query<GetFundPositionsApiResponse, GetFundPositionsApiArg>({
      query: (queryArg) => ({ url: `/external/fund/positions`, params: { date: queryArg.date } }),
    }),
    getAllPublic: build.query<GetAllPublicApiResponse, GetAllPublicApiArg>({
      query: () => ({ url: `/announcements/public` }),
    }),
    getAll: build.query<GetAllApiResponse, GetAllApiArg>({
      query: (queryArg) => ({
        url: `/announcements`,
        params: { past: queryArg.past, present: queryArg.present, future: queryArg.future },
      }),
    }),
    create: build.mutation<CreateApiResponse, CreateApiArg>({
      query: (queryArg) => ({
        url: `/announcements`,
        method: "POST",
        body: queryArg.publicAnnouncement,
      }),
    }),
    update: build.mutation<UpdateApiResponse, UpdateApiArg>({
      query: (queryArg) => ({
        url: `/announcements/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.updateAnnouncementDto,
      }),
    }),
    deleteAnnouncementsById: build.mutation<
      DeleteAnnouncementsByIdApiResponse,
      DeleteAnnouncementsByIdApiArg
    >({
      query: (queryArg) => ({ url: `/announcements/${queryArg.id}`, method: "DELETE" }),
    }),
    getLinkAnalytics: build.query<GetLinkAnalyticsApiResponse, GetLinkAnalyticsApiArg>({
      query: (queryArg) => ({ url: `/announcements/analytics/${queryArg.id}` }),
    }),
    getAllPermissionGroups: build.query<
      GetAllPermissionGroupsApiResponse,
      GetAllPermissionGroupsApiArg
    >({
      query: () => ({ url: `/account-management/roles` }),
    }),
    addAccountPermission: build.mutation<
      AddAccountPermissionApiResponse,
      AddAccountPermissionApiArg
    >({
      query: (queryArg) => ({
        url: `/account-management/roles/addPermission`,
        method: "POST",
        body: queryArg.addPermission,
      }),
    }),
    getTransmitUserGroup: build.query<GetTransmitUserGroupApiResponse, GetTransmitUserGroupApiArg>({
      query: (queryArg) => ({
        url: `/account-management/roles/transmitUserGroup/${queryArg.userId}`,
      }),
    }),
    removePermission: build.mutation<RemovePermissionApiResponse, RemovePermissionApiArg>({
      query: (queryArg) => ({
        url: `/account-management/roles/removePermission`,
        method: "DELETE",
        body: queryArg.removePermission,
      }),
    }),
    editUserPermissions: build.mutation<EditUserPermissionsApiResponse, EditUserPermissionsApiArg>({
      query: (queryArg) => ({
        url: `/account-management/roles/editUserPermissions`,
        method: "POST",
        body: queryArg.editPermissionsDto,
      }),
    }),
    getTransmitUserByEmail: build.query<
      GetTransmitUserByEmailApiResponse,
      GetTransmitUserByEmailApiArg
    >({
      query: (queryArg) => ({ url: `/account-management/roles/transmitUser/${queryArg.email}` }),
    }),
    getUserByCustomerId: build.query<GetUserByCustomerIdApiResponse, GetUserByCustomerIdApiArg>({
      query: (queryArg) => ({ url: `/account-management/roles/user/${queryArg.customerId}` }),
    }),
    getPing: build.query<GetPingApiResponse, GetPingApiArg>({
      query: () => ({ url: `/account-management/ping` }),
    }),
    getUserCount: build.query<GetUserCountApiResponse, GetUserCountApiArg>({
      query: () => ({ url: `/account-management/count` }),
    }),
    countActiveUsers: build.query<CountActiveUsersApiResponse, CountActiveUsersApiArg>({
      query: () => ({ url: `/account-management/countActive` }),
    }),
    getUserAccountCountLast30Days: build.query<
      GetUserAccountCountLast30DaysApiResponse,
      GetUserAccountCountLast30DaysApiArg
    >({
      query: () => ({ url: `/account-management/newUsersCount` }),
    }),
    getUserLoginChart: build.query<GetUserLoginChartApiResponse, GetUserLoginChartApiArg>({
      query: () => ({ url: `/account-management/userDailyCreated` }),
    }),
    handleAccountStatus: build.mutation<HandleAccountStatusApiResponse, HandleAccountStatusApiArg>({
      query: (queryArg) => ({
        url: `/account-management/disableUser`,
        method: "POST",
        body: queryArg.disableUserDto,
      }),
    }),
    disable2Fa: build.mutation<Disable2FaApiResponse, Disable2FaApiArg>({
      query: (queryArg) => ({
        url: `/account-management/roles/disable2FA/${queryArg.email}`,
        method: "PUT",
      }),
    }),
    disablePasskey: build.mutation<DisablePasskeyApiResponse, DisablePasskeyApiArg>({
      query: (queryArg) => ({
        url: `/account-management/roles/disablePasskey/${queryArg.email}`,
        method: "PUT",
      }),
    }),
    editAutomatedTradesDisabled: build.mutation<
      EditAutomatedTradesDisabledApiResponse,
      EditAutomatedTradesDisabledApiArg
    >({
      query: (queryArg) => ({
        url: `/account-management/automatedTrades`,
        method: "PUT",
        body: queryArg.editAutomatedTradesDisabledDto,
      }),
    }),
    updateFeatures: build.mutation<UpdateFeaturesApiResponse, UpdateFeaturesApiArg>({
      query: (queryArg) => ({
        url: `/account-management/features`,
        method: "POST",
        body: queryArg.updateAccountFeatureDto,
      }),
    }),
    getAllFeatures: build.query<GetAllFeaturesApiResponse, GetAllFeaturesApiArg>({
      query: () => ({ url: `/account-management/features` }),
    }),
    setIsEmployee: build.mutation<SetIsEmployeeApiResponse, SetIsEmployeeApiArg>({
      query: (queryArg) => ({
        url: `/account-management/roles/set-is-employee/${queryArg.email}`,
        method: "PUT",
        body: queryArg.setEmployeeDto,
      }),
    }),
    getContactChanges: build.query<GetContactChangesApiResponse, GetContactChangesApiArg>({
      query: (queryArg) => ({
        url: `/admin/contact-changes`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          email: queryArg.email,
          customerId: queryArg.customerId,
        },
      }),
    }),
    updateContactChangeStatus: build.mutation<
      UpdateContactChangeStatusApiResponse,
      UpdateContactChangeStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/admin/contact-changes/status`,
        method: "PATCH",
        params: { id: queryArg.id },
      }),
    }),
    getCustomerLogs: build.mutation<GetCustomerLogsApiResponse, GetCustomerLogsApiArg>({
      query: (queryArg) => ({
        url: `/admin/customer-log`,
        method: "POST",
        body: queryArg.getCustomerActionsDto,
      }),
    }),
    getConfig: build.query<GetConfigApiResponse, GetConfigApiArg>({
      query: () => ({ url: `/system/maintenance/config-file` }),
    }),
    createBatchLogs: build.mutation<CreateBatchLogsApiResponse, CreateBatchLogsApiArg>({
      query: (queryArg) => ({
        url: `/ios/batch`,
        method: "POST",
        body: queryArg.batchLogRequestDto,
      }),
    }),
    list: build.query<ListApiResponse, ListApiArg>({
      query: () => ({ url: `/admin/feature-flags` }),
    }),
    upsert: build.mutation<UpsertApiResponse, UpsertApiArg>({
      query: (queryArg) => ({
        url: `/admin/feature-flags/${queryArg.key}`,
        method: "PUT",
        body: queryArg.featureFlagUpsertDto,
      }),
    }),
    putAdminFeatureFlagsByKeyOverride: build.mutation<
      PutAdminFeatureFlagsByKeyOverrideApiResponse,
      PutAdminFeatureFlagsByKeyOverrideApiArg
    >({
      query: (queryArg) => ({
        url: `/admin/feature-flags/${queryArg.key}/override`,
        method: "PUT",
        body: queryArg.featureFlagOverrideDto,
      }),
    }),
    listTransfers: build.query<ListTransfersApiResponse, ListTransfersApiArg>({
      query: (queryArg) => ({
        url: `/admin/travel-rule/transfers`,
        params: {
          userId: queryArg.userId,
          customerId: queryArg.customerId,
          entity: queryArg.entity,
          status: queryArg.status,
          decision: queryArg.decision,
          dateFrom: queryArg.dateFrom,
          dateTo: queryArg.dateTo,
          vaspCounterparty: queryArg.vaspCounterparty,
          notabeneTxId: queryArg.notabeneTxId,
          fireblocksTxId: queryArg.fireblocksTxId,
          blockchainTxHash: queryArg.blockchainTxHash,
          internalRef: queryArg.internalRef,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getTransferDetail: build.query<GetTransferDetailApiResponse, GetTransferDetailApiArg>({
      query: (queryArg) => ({ url: `/admin/travel-rule/transfers/${queryArg.notabeneTxId}` }),
    }),
    getAuditChain: build.query<GetAuditChainApiResponse, GetAuditChainApiArg>({
      query: (queryArg) => ({ url: `/admin/travel-rule/audit/${queryArg.notabeneTxId}` }),
    }),
    forceAuthorize: build.mutation<ForceAuthorizeApiResponse, ForceAuthorizeApiArg>({
      query: (queryArg) => ({
        url: `/admin/travel-rule/transfers/${queryArg.notabeneTxId}/force-authorize`,
        method: "POST",
        body: queryArg.manualOverrideDto,
      }),
    }),
    releaseHold: build.mutation<ReleaseHoldApiResponse, ReleaseHoldApiArg>({
      query: (queryArg) => ({
        url: `/admin/travel-rule/deposits/${queryArg.internalCtId}/release-hold`,
        method: "POST",
        body: queryArg.manualOverrideDto,
      }),
    }),
    forceDecline: build.mutation<ForceDeclineApiResponse, ForceDeclineApiArg>({
      query: (queryArg) => ({
        url: `/admin/travel-rule/transfers/${queryArg.notabeneTxId}/force-decline`,
        method: "POST",
        body: queryArg.manualOverrideDto,
      }),
    }),
    rescreen: build.mutation<RescreenApiResponse, RescreenApiArg>({
      query: (queryArg) => ({
        url: `/admin/travel-rule/transfers/${queryArg.notabeneTxId}/rescreen`,
        method: "POST",
      }),
    }),
    getCryptoCurrencies: build.query<GetCryptoCurrenciesApiResponse, GetCryptoCurrenciesApiArg>({
      query: () => ({ url: `/crypto/all` }),
    }),
    getCryptoAll: build.query<GetCryptoAllApiResponse, GetCryptoAllApiArg>({
      query: (queryArg) => ({
        url: `/crypto/allCoins`,
        params: { quote: queryArg.quote, filterByToken: queryArg.filterByToken },
      }),
    }),
    getCryptoAllTickers: build.query<GetCryptoAllTickersApiResponse, GetCryptoAllTickersApiArg>({
      query: () => ({ url: `/crypto/allCoinsTickers` }),
    }),
    getTrendingCryptoCurrencies: build.query<
      GetTrendingCryptoCurrenciesApiResponse,
      GetTrendingCryptoCurrenciesApiArg
    >({
      query: (queryArg) => ({
        url: `/crypto/trending`,
        params: { pricingData: queryArg.pricingData, limit: queryArg.limit, quote: queryArg.quote },
      }),
    }),
    getCryptoSectors: build.query<GetCryptoSectorsApiResponse, GetCryptoSectorsApiArg>({
      query: () => ({ url: `/crypto/sectors` }),
    }),
    getCoinPageData: build.query<GetCoinPageDataApiResponse, GetCoinPageDataApiArg>({
      query: (queryArg) => ({
        url: `/crypto/data/${queryArg.token}`,
        params: { baseCurrency: queryArg.baseCurrency },
      }),
    }),
    getCoinPageChart: build.query<GetCoinPageChartApiResponse, GetCoinPageChartApiArg>({
      query: (queryArg) => ({
        url: `/crypto/chart/${queryArg.token}`,
        params: { interval: queryArg.interval },
      }),
    }),
    getTokenChartData: build.query<GetTokenChartDataApiResponse, GetTokenChartDataApiArg>({
      query: (queryArg) => ({
        url: `/crypto/chartTokenData/${queryArg.token}`,
        params: {
          interval: queryArg.interval,
          startDate: queryArg.startDate,
          quote: queryArg.quote,
        },
      }),
    }),
    getCandleChartData: build.query<GetCandleChartDataApiResponse, GetCandleChartDataApiArg>({
      query: (queryArg) => ({
        url: `/crypto/candleChart/${queryArg.token}`,
        params: { interval: queryArg.interval },
      }),
    }),
    getTopRanked: build.query<GetTopRankedApiResponse, GetTopRankedApiArg>({
      query: () => ({ url: `/crypto/ranked` }),
    }),
    incrementCoinVisit: build.mutation<IncrementCoinVisitApiResponse, IncrementCoinVisitApiArg>({
      query: (queryArg) => ({
        url: `/crypto/increment-coin-visits`,
        method: "POST",
        body: queryArg.coinVisitsDto,
      }),
    }),
    getFiatCurrencies: build.query<GetFiatCurrenciesApiResponse, GetFiatCurrenciesApiArg>({
      query: (queryArg) => ({
        url: `/forex/all`,
        params: { quote: queryArg.quote, filterByToken: queryArg.filterByToken },
      }),
    }),
    getLiveForex: build.query<GetLiveForexApiResponse, GetLiveForexApiArg>({
      query: () => ({ url: `/forex/live` }),
    }),
    getFiatAndStableCoins: build.query<
      GetFiatAndStableCoinsApiResponse,
      GetFiatAndStableCoinsApiArg
    >({
      query: () => ({ url: `/forex/stablecoins` }),
    }),
    getMarketTokensList: build.query<GetMarketTokensListApiResponse, GetMarketTokensListApiArg>({
      query: (queryArg) => ({
        url: `/market/tokensList`,
        params: {
          limit: queryArg.limit,
          page: queryArg.page,
          sector: queryArg.sector,
          searchQuery: queryArg.searchQuery,
          type: queryArg["type"],
        },
      }),
    }),
    getMarketPageCards: build.query<GetMarketPageCardsApiResponse, GetMarketPageCardsApiArg>({
      query: () => ({ url: `/market/tokensOverview` }),
    }),
    getBiggestMovers: build.query<GetBiggestMoversApiResponse, GetBiggestMoversApiArg>({
      query: (queryArg) => ({
        url: `/market/biggestMovers`,
        params: { customerHeld: queryArg.customerHeld },
      }),
    }),
    getBestPerformingAsset: build.query<
      GetBestPerformingAssetApiResponse,
      GetBestPerformingAssetApiArg
    >({
      query: (queryArg) => ({
        url: `/market/bestPerformingAsset`,
        params: { interval: queryArg.interval },
      }),
    }),
    getNewlyListed: build.query<GetNewlyListedApiResponse, GetNewlyListedApiArg>({
      query: () => ({ url: `/market/newlyListed` }),
    }),
    getMarketData: build.query<GetMarketDataApiResponse, GetMarketDataApiArg>({
      query: () => ({ url: `/market/overall` }),
    }),
    getTreeMap: build.query<GetTreeMapApiResponse, GetTreeMapApiArg>({
      query: () => ({ url: `/market/sectorsChart` }),
    }),
    getTokenCryptoNews: build.query<GetTokenCryptoNewsApiResponse, GetTokenCryptoNewsApiArg>({
      query: (queryArg) => ({ url: `/news/token/${queryArg.token}` }),
    }),
    getDashboardCryptoNews: build.query<
      GetDashboardCryptoNewsApiResponse,
      GetDashboardCryptoNewsApiArg
    >({
      query: () => ({ url: `/news/user` }),
    }),
    updateCoinNote: build.mutation<UpdateCoinNoteApiResponse, UpdateCoinNoteApiArg>({
      query: (queryArg) => ({ url: `/coin/note`, method: "POST", body: queryArg.updateCoinDto }),
    }),
    getCoinNote: build.query<GetCoinNoteApiResponse, GetCoinNoteApiArg>({
      query: (queryArg) => ({ url: `/coin/note/${queryArg.ticker}` }),
    }),
    getUserCurrencyTransactions: build.query<
      GetUserCurrencyTransactionsApiResponse,
      GetUserCurrencyTransactionsApiArg
    >({
      query: (queryArg) => ({
        url: `/currency-transactions/user`,
        params: {
          limit: queryArg.limit,
          page: queryArg.page,
          baseCurrency: queryArg.baseCurrency,
          device: queryArg.device,
          timezone: queryArg.timezone,
          txType: queryArg.txType,
          statuses: queryArg.statuses,
          currency: queryArg.currency,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          startTxSize: queryArg.startTxSize,
          endTxSize: queryArg.endTxSize,
          userId: queryArg.userId,
        },
      }),
    }),
    getUserTransactionStats: build.query<
      GetUserTransactionStatsApiResponse,
      GetUserTransactionStatsApiArg
    >({
      query: (queryArg) => ({
        url: `/currency-transactions/stats`,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getUserRecentTransactions: build.query<
      GetUserRecentTransactionsApiResponse,
      GetUserRecentTransactionsApiArg
    >({
      query: () => ({ url: `/currency-transactions/recent-transactions` }),
    }),
    getUserTokenPageRecentTransactions: build.query<
      GetUserTokenPageRecentTransactionsApiResponse,
      GetUserTokenPageRecentTransactionsApiArg
    >({
      query: (queryArg) => ({
        url: `/currency-transactions/recent/${queryArg.token}`,
        params: { baseCurrency: queryArg.baseCurrency },
      }),
    }),
    getCreatedCt: build.query<GetCreatedCtApiResponse, GetCreatedCtApiArg>({
      query: () => ({ url: `/currency-transactions/created` }),
    }),
    getTargetOrderCt: build.query<GetTargetOrderCtApiResponse, GetTargetOrderCtApiArg>({
      query: (queryArg) => ({
        url: `/currency-transactions/targetOrders`,
        params: {
          limit: queryArg.limit,
          page: queryArg.page,
          sortType: queryArg.sortType,
          filterType: queryArg.filterType,
          tokenCode: queryArg.tokenCode,
          statusFilter: queryArg.statusFilter,
        },
      }),
    }),
    getTargetOrderTokens: build.query<GetTargetOrderTokensApiResponse, GetTargetOrderTokensApiArg>({
      query: () => ({ url: `/currency-transactions/target-order-tokens` }),
    }),
    exportCsv: build.query<ExportCsvApiResponse, ExportCsvApiArg>({
      query: (queryArg) => ({
        url: `/currency-transactions/exportCSV`,
        params: {
          baseCurrency: queryArg.baseCurrency,
          timezone: queryArg.timezone,
          txType: queryArg.txType,
          statuses: queryArg.statuses,
          currency: queryArg.currency,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          startTxSize: queryArg.startTxSize,
          endTxSize: queryArg.endTxSize,
          userId: queryArg.userId,
          koinlyFormat: queryArg.koinlyFormat,
        },
      }),
    }),
    exportCsvKoinly: build.query<ExportCsvKoinlyApiResponse, ExportCsvKoinlyApiArg>({
      query: (queryArg) => ({
        url: `/currency-transactions/exportCSV-koinly`,
        params: {
          baseCurrency: queryArg.baseCurrency,
          timezone: queryArg.timezone,
          txType: queryArg.txType,
          statuses: queryArg.statuses,
          currency: queryArg.currency,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          startTxSize: queryArg.startTxSize,
          endTxSize: queryArg.endTxSize,
          userId: queryArg.userId,
          koinlyFormat: queryArg.koinlyFormat,
        },
      }),
    }),
    exportCsvAdmin: build.query<ExportCsvAdminApiResponse, ExportCsvAdminApiArg>({
      query: (queryArg) => ({
        url: `/currency-transactions/export-CSV-admin`,
        params: {
          baseCurrency: queryArg.baseCurrency,
          timezone: queryArg.timezone,
          txType: queryArg.txType,
          statuses: queryArg.statuses,
          currency: queryArg.currency,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          startTxSize: queryArg.startTxSize,
          endTxSize: queryArg.endTxSize,
          userId: queryArg.userId,
          koinlyFormat: queryArg.koinlyFormat,
        },
      }),
    }),
    getOrderSizeRange: build.query<GetOrderSizeRangeApiResponse, GetOrderSizeRangeApiArg>({
      query: (queryArg) => ({
        url: `/currency-transactions/order-size-range`,
        params: {
          timeRange: queryArg.timeRange,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          numberOfBins: queryArg.numberOfBins,
        },
      }),
    }),
    filterTransactions: build.mutation<FilterTransactionsApiResponse, FilterTransactionsApiArg>({
      query: (queryArg) => ({
        url: `/currency-transactions/filter`,
        method: "POST",
        body: queryArg.transactionsFilterRequestDto,
      }),
    }),
    addNoteToCt: build.mutation<AddNoteToCtApiResponse, AddNoteToCtApiArg>({
      query: (queryArg) => ({
        url: `/currency-transactions/addNote`,
        method: "POST",
        body: queryArg.ctNoteDto,
      }),
    }),
    getPendingWithdrawals: build.query<
      GetPendingWithdrawalsApiResponse,
      GetPendingWithdrawalsApiArg
    >({
      query: () => ({ url: `/currency-transactions/pending-withdrawals` }),
    }),
    setWithdrawalApprovalStatus: build.mutation<
      SetWithdrawalApprovalStatusApiResponse,
      SetWithdrawalApprovalStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/currency-transactions/set-withdrawal-approval-status`,
        method: "POST",
        body: queryArg.setWithdrawalApprovalStatusDto,
      }),
    }),
    getUserDepositAddress: build.query<
      GetUserDepositAddressApiResponse,
      GetUserDepositAddressApiArg
    >({
      query: (queryArg) => ({ url: `/deposit/address/${queryArg.token}` }),
    }),
    processDeposit: build.mutation<ProcessDepositApiResponse, ProcessDepositApiArg>({
      query: (queryArg) => ({
        url: `/deposit/process`,
        method: "POST",
        body: queryArg.processDepositDto,
      }),
    }),
    createStripeVbankTransfer: build.query<
      CreateStripeVbankTransferApiResponse,
      CreateStripeVbankTransferApiArg
    >({
      query: () => ({ url: `/deposit/stripe-vbank-transfer` }),
    }),
    hasExistingStripeAccounts: build.query<
      HasExistingStripeAccountsApiResponse,
      HasExistingStripeAccountsApiArg
    >({
      query: () => ({ url: `/deposit/stripe-has-existing-accounts` }),
    }),
    getWalletPageBalance: build.query<GetWalletPageBalanceApiResponse, GetWalletPageBalanceApiArg>({
      query: (queryArg) => ({
        url: `/holdings/balance`,
        params: { baseCurrency: queryArg.baseCurrency },
      }),
    }),
    getWalletPageHoldings: build.query<
      GetWalletPageHoldingsApiResponse,
      GetWalletPageHoldingsApiArg
    >({
      query: (queryArg) => ({
        url: `/holdings/all`,
        params: { baseCurrency: queryArg.baseCurrency },
      }),
    }),
    getWalletPageHoldingsNew: build.query<
      GetWalletPageHoldingsNewApiResponse,
      GetWalletPageHoldingsNewApiArg
    >({
      query: (queryArg) => ({
        url: `/holdings/all/v2`,
        params: { baseCurrency: queryArg.baseCurrency },
      }),
    }),
    getBestPerformingHoldings: build.query<
      GetBestPerformingHoldingsApiResponse,
      GetBestPerformingHoldingsApiArg
    >({
      query: () => ({ url: `/holdings/best-performing-asset` }),
    }),
    getUserHeldCurrencies: build.query<
      GetUserHeldCurrenciesApiResponse,
      GetUserHeldCurrenciesApiArg
    >({
      query: () => ({ url: `/holdings/heldCurrencies` }),
    }),
    getUserRunningBalanceChart: build.query<
      GetUserRunningBalanceChartApiResponse,
      GetUserRunningBalanceChartApiArg
    >({
      query: (queryArg) => ({
        url: `/holdings/runningBalanceChart`,
        params: { interval: queryArg.interval, numberOfCurrencies: queryArg.numberOfCurrencies },
      }),
    }),
    getAllUserRunningBalanceCharts: build.query<
      GetAllUserRunningBalanceChartsApiResponse,
      GetAllUserRunningBalanceChartsApiArg
    >({
      query: () => ({ url: `/holdings/runningBalanceChartsAll` }),
    }),
    getUserFiatHoldings: build.query<GetUserFiatHoldingsApiResponse, GetUserFiatHoldingsApiArg>({
      query: () => ({ url: `/holdings/fiat` }),
    }),
    getReferrals: build.query<GetReferralsApiResponse, GetReferralsApiArg>({
      query: () => ({ url: `/refer-friend/details` }),
    }),
    getReferralRewards: build.query<GetReferralRewardsApiResponse, GetReferralRewardsApiArg>({
      query: () => ({ url: `/refer-friend/rewards` }),
    }),
    getReferralMontlyRewards: build.query<
      GetReferralMontlyRewardsApiResponse,
      GetReferralMontlyRewardsApiArg
    >({
      query: (queryArg) => ({
        url: `/refer-friend/montly-rewards`,
        params: { timeFrame: queryArg.timeFrame },
      }),
    }),
    createReferralUrl: build.query<CreateReferralUrlApiResponse, CreateReferralUrlApiArg>({
      query: () => ({ url: `/refer-friend/createReferralUrl` }),
    }),
    updateLinkShareAnalytics: build.mutation<
      UpdateLinkShareAnalyticsApiResponse,
      UpdateLinkShareAnalyticsApiArg
    >({
      query: (queryArg) => ({
        url: `/refer-friend/shareReferralCode`,
        method: "PATCH",
        body: queryArg.shareLinkDto,
      }),
    }),
    submitReferralCode: build.mutation<SubmitReferralCodeApiResponse, SubmitReferralCodeApiArg>({
      query: (queryArg) => ({
        url: `/refer-friend/submit-referral-code`,
        method: "POST",
        body: queryArg.referralCodeDto,
      }),
    }),
    getReferredByUser: build.query<GetReferredByUserApiResponse, GetReferredByUserApiArg>({
      query: () => ({ url: `/refer-friend/user-referred-by` }),
    }),
    getUserDatav2: build.query<GetUserDatav2ApiResponse, GetUserDatav2ApiArg>({
      query: () => ({ url: `/user/v2` }),
    }),
    getUserSummary: build.query<GetUserSummaryApiResponse, GetUserSummaryApiArg>({
      query: (queryArg) => ({ url: `/user/summary`, params: { timeFrame: queryArg.timeFrame } }),
    }),
    getKycStatus: build.query<GetKycStatusApiResponse, GetKycStatusApiArg>({
      query: () => ({ url: `/user/kycStatus` }),
    }),
    getWatchlist: build.query<GetWatchlistApiResponse, GetWatchlistApiArg>({
      query: (queryArg) => ({ url: `/user/watchlist`, params: { quote: queryArg.quote } }),
    }),
    addWatchlist: build.mutation<AddWatchlistApiResponse, AddWatchlistApiArg>({
      query: (queryArg) => ({
        url: `/user/watchlist`,
        method: "POST",
        params: { token: queryArg.token },
      }),
    }),
    removeWatchlist: build.mutation<RemoveWatchlistApiResponse, RemoveWatchlistApiArg>({
      query: (queryArg) => ({
        url: `/user/watchlist`,
        method: "DELETE",
        params: { token: queryArg.token },
      }),
    }),
    getWatchlistV2: build.query<GetWatchlistV2ApiResponse, GetWatchlistV2ApiArg>({
      query: (queryArg) => ({ url: `/user/watchlist/v2`, params: { quote: queryArg.quote } }),
    }),
    addWatchlistV2: build.mutation<AddWatchlistV2ApiResponse, AddWatchlistV2ApiArg>({
      query: (queryArg) => ({
        url: `/user/watchlist/v2/add`,
        method: "POST",
        body: queryArg.addWatchlistV2Dto,
      }),
    }),
    removeWatchlistV2: build.mutation<RemoveWatchlistV2ApiResponse, RemoveWatchlistV2ApiArg>({
      query: (queryArg) => ({
        url: `/user/watchlist/v2/remove`,
        method: "DELETE",
        body: queryArg.removeWatchlistV2Dto,
      }),
    }),
    acceptStateDisclosure: build.mutation<
      AcceptStateDisclosureApiResponse,
      AcceptStateDisclosureApiArg
    >({
      query: (queryArg) => ({
        url: `/user/disclosures`,
        method: "POST",
        body: queryArg.acceptStateDisclosureDto,
      }),
    }),
    acceptDepositDisclosure: build.mutation<
      AcceptDepositDisclosureApiResponse,
      AcceptDepositDisclosureApiArg
    >({
      query: (queryArg) => ({
        url: `/user/deposit-disclosures`,
        method: "POST",
        body: queryArg.acceptDepositDisclosureDto,
      }),
    }),
    getTodayDisclosureAcceptance: build.query<
      GetTodayDisclosureAcceptanceApiResponse,
      GetTodayDisclosureAcceptanceApiArg
    >({
      query: (queryArg) => ({
        url: `/user/disclosure-acceptances/today`,
        params: { timezone: queryArg.timezone, transactionType: queryArg.transactionType },
      }),
    }),
    prepareWithdrawal: build.mutation<PrepareWithdrawalApiResponse, PrepareWithdrawalApiArg>({
      query: (queryArg) => ({
        url: `/withdrawal/prepare`,
        method: "POST",
        body: queryArg.prepareWithdrawalDto,
      }),
    }),
    checkWithdrawalEmailCode: build.mutation<
      CheckWithdrawalEmailCodeApiResponse,
      CheckWithdrawalEmailCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/withdrawal/check-withdrawal-email-code`,
        method: "POST",
        body: queryArg.withdrawalVerificationDto,
      }),
    }),
    resendWithdrawalEmailCode: build.mutation<
      ResendWithdrawalEmailCodeApiResponse,
      ResendWithdrawalEmailCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/withdrawal/resend-withdrawal-email`,
        method: "POST",
        body: queryArg.sendWithdrawalEmailCodeDto,
      }),
    }),
    checkIsUserLocked: build.query<CheckIsUserLockedApiResponse, CheckIsUserLockedApiArg>({
      query: (queryArg) => ({ url: `/withdrawal/is-user-locked`, params: { fiat: queryArg.fiat } }),
    }),
    processWithdrawal: build.mutation<ProcessWithdrawalApiResponse, ProcessWithdrawalApiArg>({
      query: (queryArg) => ({
        url: `/withdrawal/process`,
        method: "POST",
        body: queryArg.processWithdrawalDto,
      }),
    }),
    processFiatWithdrawal: build.mutation<
      ProcessFiatWithdrawalApiResponse,
      ProcessFiatWithdrawalApiArg
    >({
      query: (queryArg) => ({
        url: `/withdrawal/process-fiat`,
        method: "POST",
        body: queryArg.processFiatWithdrawalDto,
      }),
    }),
    getMinimumWithdrawalAmount: build.mutation<
      GetMinimumWithdrawalAmountApiResponse,
      GetMinimumWithdrawalAmountApiArg
    >({
      query: (queryArg) => ({
        url: `/withdrawal/get-withdrawal-minimum`,
        method: "POST",
        body: queryArg.minimumWithdrawalDto,
      }),
    }),
    getUserCryptoAddresses: build.query<
      GetUserCryptoAddressesApiResponse,
      GetUserCryptoAddressesApiArg
    >({
      query: (queryArg) => ({
        url: `/withdrawal/addresses`,
        params: { onlyVerified: queryArg.onlyVerified },
      }),
    }),
    getUserWithdrawAddress: build.query<
      GetUserWithdrawAddressApiResponse,
      GetUserWithdrawAddressApiArg
    >({
      query: (queryArg) => ({ url: `/withdrawal/address/${queryArg.token}` }),
    }),
    addUserWithdrawAddress: build.mutation<
      AddUserWithdrawAddressApiResponse,
      AddUserWithdrawAddressApiArg
    >({
      query: (queryArg) => ({
        url: `/withdrawal/addAddress`,
        method: "POST",
        body: queryArg.addWithdrawAddressDto,
      }),
    }),
    patchAddressTrFields: build.mutation<
      PatchAddressTrFieldsApiResponse,
      PatchAddressTrFieldsApiArg
    >({
      query: (queryArg) => ({
        url: `/withdrawal/address/${queryArg.address}/tr`,
        method: "PATCH",
        body: queryArg.patchTrFieldsDto,
      }),
    }),
    updateUserWithdrawAddress: build.mutation<
      UpdateUserWithdrawAddressApiResponse,
      UpdateUserWithdrawAddressApiArg
    >({
      query: (queryArg) => ({
        url: `/withdrawal/update-address`,
        method: "PUT",
        body: queryArg.updateAddressDto,
      }),
    }),
    checkEmailCode: build.mutation<CheckEmailCodeApiResponse, CheckEmailCodeApiArg>({
      query: (queryArg) => ({
        url: `/withdrawal/checkEmailCode`,
        method: "POST",
        body: queryArg.addressWithEmailCodeDto,
      }),
    }),
    verfiyUserWithdrawAddressEmail: build.mutation<
      VerfiyUserWithdrawAddressEmailApiResponse,
      VerfiyUserWithdrawAddressEmailApiArg
    >({
      query: (queryArg) => ({
        url: `/withdrawal/processTest`,
        method: "POST",
        body: queryArg.addressWithCodesDto,
      }),
    }),
    verifyAddress: build.mutation<VerifyAddressApiResponse, VerifyAddressApiArg>({
      query: (queryArg) => ({
        url: `/withdrawal/verifyAddress`,
        method: "POST",
        body: queryArg.verifyAddressDto,
      }),
    }),
    resendEmailCode: build.mutation<ResendEmailCodeApiResponse, ResendEmailCodeApiArg>({
      query: (queryArg) => ({
        url: `/withdrawal/resend-email`,
        method: "POST",
        body: queryArg.resendEmailCodeDto,
      }),
    }),
    createCurrencyTransactionReport: build.query<
      CreateCurrencyTransactionReportApiResponse,
      CreateCurrencyTransactionReportApiArg
    >({
      query: (queryArg) => ({
        url: `/reporting/transactions`,
        params: {
          timezone: queryArg.timezone,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
        },
      }),
    }),
    createAccountReport: build.query<CreateAccountReportApiResponse, CreateAccountReportApiArg>({
      query: (queryArg) => ({
        url: `/reporting/account`,
        params: {
          timezone: queryArg.timezone,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
        },
      }),
    }),
    createAccountReportById: build.query<
      CreateAccountReportByIdApiResponse,
      CreateAccountReportByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/reporting/accountByID`,
        params: {
          timezone: queryArg.timezone,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          ID: queryArg.id,
        },
      }),
    }),
    createAccountReportByCustomerId: build.query<
      CreateAccountReportByCustomerIdApiResponse,
      CreateAccountReportByCustomerIdApiArg
    >({
      query: (queryArg) => ({
        url: `/reporting/accountByCustomerID`,
        params: {
          timezone: queryArg.timezone,
          startDate: queryArg.startDate,
          endDate: queryArg.endDate,
          ID: queryArg.id,
        },
      }),
    }),
    getTradeSummary: build.mutation<GetTradeSummaryApiResponse, GetTradeSummaryApiArg>({
      query: (queryArg) => ({
        url: `/trade/summary`,
        method: "POST",
        body: queryArg.tradeSummaryDto,
      }),
    }),
    createCt: build.mutation<CreateCtApiResponse, CreateCtApiArg>({
      query: (queryArg) => ({
        url: `/trade/create`,
        method: "POST",
        body: queryArg.createTradeDto,
      }),
    }),
    getTargetOrderSummary: build.mutation<
      GetTargetOrderSummaryApiResponse,
      GetTargetOrderSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/target-orders/summary`,
        method: "POST",
        body: queryArg.targetOrderSummaryDto,
      }),
    }),
    createTargetOrderCt: build.mutation<CreateTargetOrderCtApiResponse, CreateTargetOrderCtApiArg>({
      query: (queryArg) => ({
        url: `/target-orders/create`,
        method: "POST",
        body: queryArg.createTargetOrderDto,
      }),
    }),
    createGam: build.mutation<CreateGamApiResponse, CreateGamApiArg>({
      query: (queryArg) => ({
        url: `/target-orders/GAM`,
        method: "POST",
        body: queryArg.requestActionDto,
      }),
    }),
    requestCancel: build.mutation<RequestCancelApiResponse, RequestCancelApiArg>({
      query: (queryArg) => ({
        url: `/target-orders/request-cancel`,
        method: "POST",
        body: queryArg.requestActionDto,
      }),
    }),
    createPriceAlert: build.mutation<CreatePriceAlertApiResponse, CreatePriceAlertApiArg>({
      query: (queryArg) => ({
        url: `/price-alert/createPriceAlert`,
        method: "POST",
        body: queryArg.priceAlertDto,
      }),
    }),
    editPriceAlert: build.mutation<EditPriceAlertApiResponse, EditPriceAlertApiArg>({
      query: (queryArg) => ({
        url: `/price-alert/editPriceAlert`,
        method: "POST",
        body: queryArg.existingPriceAlertDto,
      }),
    }),
    deletePriceAlert: build.mutation<DeletePriceAlertApiResponse, DeletePriceAlertApiArg>({
      query: (queryArg) => ({
        url: `/price-alert/deletePriceAlert`,
        method: "POST",
        body: queryArg.priceAlertIdDto,
      }),
    }),
    getPriceAlerts: build.query<GetPriceAlertsApiResponse, GetPriceAlertsApiArg>({
      query: (queryArg) => ({
        url: `/price-alert/getPriceAlerts`,
        params: { limit: queryArg.limit, page: queryArg.page },
      }),
    }),
    getUnreadNotifications: build.query<
      GetUnreadNotificationsApiResponse,
      GetUnreadNotificationsApiArg
    >({
      query: (queryArg) => ({ url: `/user/notifications`, params: { read: queryArg.read } }),
    }),
    setNotificationsToRead: build.mutation<
      SetNotificationsToReadApiResponse,
      SetNotificationsToReadApiArg
    >({
      query: (queryArg) => ({
        url: `/user/notifications/read`,
        method: "PUT",
        body: queryArg.userNotificationIdsDto,
      }),
    }),
    setAllNotificationsToRead: build.mutation<
      SetAllNotificationsToReadApiResponse,
      SetAllNotificationsToReadApiArg
    >({
      query: () => ({ url: `/user/notifications/readAll`, method: "PUT" }),
    }),
    clearNotifications: build.mutation<ClearNotificationsApiResponse, ClearNotificationsApiArg>({
      query: (queryArg) => ({
        url: `/user/notifications/clear`,
        method: "PUT",
        body: queryArg.userNotificationIdsDto,
      }),
    }),
    clearAllNotifications: build.mutation<
      ClearAllNotificationsApiResponse,
      ClearAllNotificationsApiArg
    >({
      query: () => ({ url: `/user/notifications/clearAll`, method: "PUT" }),
    }),
    getDcaStrategySummary: build.mutation<
      GetDcaStrategySummaryApiResponse,
      GetDcaStrategySummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/strategies/dca/summary`,
        method: "POST",
        body: queryArg.dcaStrategyReqDto,
      }),
    }),
    createDcaStrategy: build.mutation<CreateDcaStrategyApiResponse, CreateDcaStrategyApiArg>({
      query: (queryArg) => ({
        url: `/strategies/dca`,
        method: "POST",
        body: queryArg.dcaStrategySummaryRes,
      }),
    }),
    getDcaStrategies: build.query<GetDcaStrategiesApiResponse, GetDcaStrategiesApiArg>({
      query: (queryArg) => ({
        url: `/strategies/dca/all`,
        params: { page: queryArg.page, filters: queryArg.filters },
      }),
    }),
    cancelDcaStrategy: build.mutation<CancelDcaStrategyApiResponse, CancelDcaStrategyApiArg>({
      query: (queryArg) => ({ url: `/strategies/dca/cancel/${queryArg.id}`, method: "PATCH" }),
    }),
    getUserDcaTriggers: build.query<GetUserDcaTriggersApiResponse, GetUserDcaTriggersApiArg>({
      query: (queryArg) => ({
        url: `/triggers/dca/${queryArg.strategyId}/triggers`,
        params: { page: queryArg.page },
      }),
    }),
    updateBurlingBankDetails: build.mutation<
      UpdateBurlingBankDetailsApiResponse,
      UpdateBurlingBankDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/banking/update-burling-bank-details`,
        method: "POST",
        body: queryArg.updateBurlingBankDetails,
      }),
    }),
    getBurlingBankDetails: build.query<
      GetBurlingBankDetailsApiResponse,
      GetBurlingBankDetailsApiArg
    >({
      query: () => ({ url: `/banking/burling-bank-details` }),
    }),
    addBankDetails: build.mutation<AddBankDetailsApiResponse, AddBankDetailsApiArg>({
      query: (queryArg) => ({
        url: `/banking/bank-details`,
        method: "POST",
        body: queryArg.bankAccountReqDto,
      }),
    }),
    getBankDetailsByAccDigits: build.query<
      GetBankDetailsByAccDigitsApiResponse,
      GetBankDetailsByAccDigitsApiArg
    >({
      query: (queryArg) => ({
        url: `/banking/bank-details`,
        params: { ibanAccNumber: queryArg.ibanAccNumber },
      }),
    }),
    getBankDetails: build.query<GetBankDetailsApiResponse, GetBankDetailsApiArg>({
      query: () => ({ url: `/banking/all-bank-details` }),
    }),
    getReferralsCount: build.query<GetReferralsCountApiResponse, GetReferralsCountApiArg>({
      query: () => ({ url: `/referral-partner/referrals-count` }),
    }),
    getReferralConversionMetrics: build.query<
      GetReferralConversionMetricsApiResponse,
      GetReferralConversionMetricsApiArg
    >({
      query: () => ({ url: `/referral-partner/conversion-metrics` }),
    }),
    getReferralPartnerFees: build.query<
      GetReferralPartnerFeesApiResponse,
      GetReferralPartnerFeesApiArg
    >({
      query: (queryArg) => ({
        url: `/referral-partner/fees`,
        params: { timeFrame: queryArg.timeFrame, timezone: queryArg.timezone },
      }),
    }),
    getReferralHoldings: build.query<GetReferralHoldingsApiResponse, GetReferralHoldingsApiArg>({
      query: () => ({ url: `/referral-partner/holdings` }),
    }),
    getReferralTradeHistory: build.query<
      GetReferralTradeHistoryApiResponse,
      GetReferralTradeHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/referral-partner/trade-history`,
        params: { timeFrame: queryArg.timeFrame, timezone: queryArg.timezone },
      }),
    }),
    getReferralGrowthHistory: build.query<
      GetReferralGrowthHistoryApiResponse,
      GetReferralGrowthHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/referral-partner/growth-history`,
        params: { timeFrame: queryArg.timeFrame, timezone: queryArg.timezone },
      }),
    }),
    getCoinVisits: build.query<GetCoinVisitsApiResponse, GetCoinVisitsApiArg>({
      query: (queryArg) => ({
        url: `/referral-partner/coin-visits`,
        params: { timeFrame: queryArg.timeFrame, timezone: queryArg.timezone },
      }),
    }),
    getReferralCode: build.query<GetReferralCodeApiResponse, GetReferralCodeApiArg>({
      query: () => ({ url: `/referral-partner/referral-code` }),
    }),
    getDepositsVolume: build.query<GetDepositsVolumeApiResponse, GetDepositsVolumeApiArg>({
      query: (queryArg) => ({
        url: `/referral-partner/deposits-volume`,
        params: { timeFrame: queryArg.timeFrame, timezone: queryArg.timezone },
      }),
    }),
    getTimeToFirstTrade: build.query<GetTimeToFirstTradeApiResponse, GetTimeToFirstTradeApiArg>({
      query: (queryArg) => ({
        url: `/referral-partner/time-to-first-trade`,
        params: { timeFrame: queryArg.timeFrame, timezone: queryArg.timezone },
      }),
    }),
    getAssetsTraded: build.query<GetAssetsTradedApiResponse, GetAssetsTradedApiArg>({
      query: (queryArg) => ({
        url: `/referral-partner/assets-traded`,
        params: { timeFrame: queryArg.timeFrame, timezone: queryArg.timezone },
      }),
    }),
    getReferalPartnerDetails: build.query<
      GetReferalPartnerDetailsApiResponse,
      GetReferalPartnerDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/referral-partner/partnership-match-table-info`,
        params: { referrer: queryArg.referrer },
      }),
    }),
    evalFlags: build.query<EvalFlagsApiResponse, EvalFlagsApiArg>({
      query: (queryArg) => ({ url: `/feature-flags/eval`, params: { keys: queryArg.keys } }),
    }),
    getAccessToken: build.query<GetAccessTokenApiResponse, GetAccessTokenApiArg>({
      query: () => ({ url: `/notabene/token` }),
    }),
    createTransfer: build.mutation<CreateTransferApiResponse, CreateTransferApiArg>({
      query: (queryArg) => ({
        url: `/notabene/transfer`,
        method: "POST",
        body: queryArg.createNotabeneTransferDto,
        headers: { "x-withdrawal-prepared-token": queryArg["x-withdrawal-prepared-token"] },
      }),
    }),
    getTransfer: build.query<GetTransferApiResponse, GetTransferApiArg>({
      query: (queryArg) => ({ url: `/notabene/transfer/${queryArg.txId}` }),
    }),
    completeTransfer: build.mutation<CompleteTransferApiResponse, CompleteTransferApiArg>({
      query: (queryArg) => ({
        url: `/notabene/transfer/${queryArg.txId}/complete`,
        method: "POST",
        headers: { "x-withdrawal-prepared-token": queryArg["x-withdrawal-prepared-token"] },
      }),
    }),
    getUserTransfers: build.query<GetUserTransfersApiResponse, GetUserTransfersApiArg>({
      query: () => ({ url: `/notabene/transfers` }),
    }),
    cancelTransfer: build.mutation<CancelTransferApiResponse, CancelTransferApiArg>({
      query: (queryArg) => ({ url: `/notabene/transfer/${queryArg.txId}/cancel`, method: "POST" }),
    }),
    cancelActiveTransfers: build.mutation<
      CancelActiveTransfersApiResponse,
      CancelActiveTransfersApiArg
    >({
      query: () => ({ url: `/notabene/transfers/cancel-active`, method: "POST" }),
    }),
    notabeneHandleWebhook: build.mutation<
      NotabeneHandleWebhookApiResponse,
      NotabeneHandleWebhookApiArg
    >({
      query: () => ({ url: `/notabene/webhook`, method: "POST" }),
    }),
    getDidDocument: build.query<GetDidDocumentApiResponse, GetDidDocumentApiArg>({
      query: (queryArg) => ({ url: `/notabene/did-document`, params: { entity: queryArg.entity } }),
    }),
    checkTransferAuthorized: build.query<
      CheckTransferAuthorizedApiResponse,
      CheckTransferAuthorizedApiArg
    >({
      query: (queryArg) => ({ url: `/notabene/transfer/${queryArg.txId}/authorized` }),
    }),
    getTrConfig: build.query<GetTrConfigApiResponse, GetTrConfigApiArg>({
      query: () => ({ url: `/notabene/config` }),
    }),
    searchVasps: build.query<SearchVaspsApiResponse, SearchVaspsApiArg>({
      query: (queryArg) => ({ url: `/notabene/vasps`, params: { q: queryArg.q } }),
    }),
    handleDepositConfirmed: build.mutation<
      HandleDepositConfirmedApiResponse,
      HandleDepositConfirmedApiArg
    >({
      query: (queryArg) => ({
        url: `/webhook/fireblocks/deposit-confirmed`,
        method: "POST",
        headers: {
          "x-belfast-signature": queryArg["x-belfast-signature"],
          "x-belfast-timestamp": queryArg["x-belfast-timestamp"],
          "x-belfast-idempotency-key": queryArg["x-belfast-idempotency-key"],
        },
      }),
    }),
    submitSenderInfo: build.mutation<SubmitSenderInfoApiResponse, SubmitSenderInfoApiArg>({
      query: (queryArg) => ({ url: `/transfers/${queryArg.id}/sender-info`, method: "POST" }),
    }),
    listLegalDocuments: build.query<ListLegalDocumentsApiResponse, ListLegalDocumentsApiArg>({
      query: () => ({ url: `/legal-documents` }),
    }),
    getCurrentLegalDocument: build.query<
      GetCurrentLegalDocumentApiResponse,
      GetCurrentLegalDocumentApiArg
    >({
      query: (queryArg) => ({ url: `/legal-documents/current/${queryArg["type"]}` }),
    }),
    getPublicCurrentLegalDocument: build.query<
      GetPublicCurrentLegalDocumentApiResponse,
      GetPublicCurrentLegalDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `/legal-documents/public/current/${queryArg["type"]}`,
        params: { country: queryArg.country, region: queryArg.region },
      }),
    }),
    getLegalDocumentVersion: build.query<
      GetLegalDocumentVersionApiResponse,
      GetLegalDocumentVersionApiArg
    >({
      query: (queryArg) => ({
        url: `/legal-documents/version`,
        params: { version: queryArg.version, country: queryArg.country, region: queryArg.region },
      }),
    }),
    listLegalDocumentVersions: build.query<
      ListLegalDocumentVersionsApiResponse,
      ListLegalDocumentVersionsApiArg
    >({
      query: (queryArg) => ({
        url: `/legal-documents/versions`,
        params: { country: queryArg.country, region: queryArg.region },
      }),
    }),
    createLegalDocumentDraft: build.mutation<
      CreateLegalDocumentDraftApiResponse,
      CreateLegalDocumentDraftApiArg
    >({
      query: (queryArg) => ({
        url: `/legal-documents/draft`,
        method: "POST",
        body: queryArg.createLegalDraftDto,
      }),
    }),
    publishLegalDocument: build.mutation<
      PublishLegalDocumentApiResponse,
      PublishLegalDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `/legal-documents/publish`,
        method: "POST",
        body: queryArg.publishLegalDocumentDto,
      }),
    }),
    check: build.query<CheckApiResponse, CheckApiArg>({
      query: () => ({ url: `/health/readiness` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type GetIntercomJwtApiResponse = /** status 200  */ IntercomJwtV2Response;
export type GetIntercomJwtApiArg = void;
export type GetConversationV2ApiResponse = /** status 200  */ Conversation;
export type GetConversationV2ApiArg = {
  id: string;
};
export type GetTagsApiResponse = /** status 200  */ TagList;
export type GetTagsApiArg = void;
export type GetClientConversationHistoryApiResponse = /** status 200  */ ConversationV2Response[];
export type GetClientConversationHistoryApiArg = void;
export type ReplyToConversationApiResponse = /** status 201  */ Conversation;
export type ReplyToConversationApiArg = {
  conversationReplyDto: ConversationReplyDto;
};
export type ReplyToConversationImageUploadApiResponse = /** status 201  */ Conversation;
export type ReplyToConversationImageUploadApiArg = {
  conversationReplyImageUploadDto: ConversationReplyImageUploadDto;
};
export type CreateConversationApiResponse = /** status 201  */ CreateConversationRes;
export type CreateConversationApiArg = {
  intercomCreateConversationDto: IntercomCreateConversationDto;
};
export type GetUserIdApiResponse = /** status 201  */ string;
export type GetUserIdApiArg = void;
export type CreateMonoovaAccountApiResponse = /** status 201  */ MonoovaMongo;
export type CreateMonoovaAccountApiArg = void;
export type GetMonoovaAccountDetailsApiResponse = /** status 200  */ MonoovaMongo;
export type GetMonoovaAccountDetailsApiArg = void;
export type GetUserIdByMonoovaAccountNumberApiResponse = /** status 200  */ UserId;
export type GetUserIdByMonoovaAccountNumberApiArg = {
  bankAccountNumber: string;
};
export type IdentifyUserApiResponse = /** status 201  */ object;
export type IdentifyUserApiArg = {
  identifyUser: IdentifyUser;
};
export type RetrieveUserApiResponse = /** status 200  */ object;
export type RetrieveUserApiArg = void;
export type SetPreferencesApiResponse = /** status 201  */ object;
export type SetPreferencesApiArg = {
  setPreferences: SetPreferences;
};
export type GetPreferencesApiResponse = /** status 200  */ object;
export type GetPreferencesApiArg = void;
export type TriggerKnockWorkflowApiResponse = unknown;
export type TriggerKnockWorkflowApiArg = {
  triggerKnockWorkflow: TriggerKnockWorkflow;
};
export type TriggerKnockWorkflowV2ApiResponse = unknown;
export type TriggerKnockWorkflowV2ApiArg = {
  triggerKnockWorkflow: TriggerKnockWorkflow;
};
export type SetChannelDataApiResponse = unknown;
export type SetChannelDataApiArg = {
  setChannelData: SetChannelData;
};
export type SetWorkflowPreferenceApiResponse = unknown;
export type SetWorkflowPreferenceApiArg = {
  setWorkflowPreferenceDto: SetWorkflowPreferenceDto;
};
export type VerifyAddressDataZooApiResponse = /** status 201  */ string;
export type VerifyAddressDataZooApiArg = {
  iDataZooVerification: IDataZooVerification;
};
export type VerifyBulkDatazooAddressApiResponse = /** status 201  */ object;
export type VerifyBulkDatazooAddressApiArg = void;
export type GetTaxAccountApiResponse = /** status 200  */ TaxBitAccountData;
export type GetTaxAccountApiArg = void;
export type UpdateTaxAccountApiResponse = /** status 200  */ TaxBitAccountData;
export type UpdateTaxAccountApiArg = {
  taxBitUpdateAccountDto: TaxBitUpdateAccountDto;
};
export type GetReleasedTaxDocumentsApiResponse = /** status 200  */ TaxBitReleasedDocumentsResponse;
export type GetReleasedTaxDocumentsApiArg = {
  /** Include every historical revision instead of just the latest per document type/year */
  includeHistorical?: boolean;
};
export type GetTaxTransactionsApiResponse = /** status 200  */ TaxBitTransactionsResponse;
export type GetTaxTransactionsApiArg = {
  /** ISO-8601 filter start date */
  startDate?: string;
  /** ISO-8601 filter end date */
  endDate?: string;
  /** Number of results per page (max 500) */
  pageSize?: number;
  /** Pagination continuation key from a previous response */
  continuationKey?: string;
};
export type CreateTaxTransferLotsApiResponse = /** status 201  */ TaxBitTransferLotsResponse;
export type CreateTaxTransferLotsApiArg = {
  transactionId: string;
  taxBitCreateTransferLotsDto: TaxBitCreateTransferLotsDto;
};
export type GetTaxTransferLotsApiResponse = /** status 200  */ TaxBitTransferLotsResponse;
export type GetTaxTransferLotsApiArg = {
  transactionId: string;
};
export type DeleteTaxTransferLotsApiResponse = unknown;
export type DeleteTaxTransferLotsApiArg = {
  transactionId: string;
};
export type GetTaxDocumentationTokenApiResponse =
  /** status 200  */ TaxBitAccountOwnerTokenResponse;
export type GetTaxDocumentationTokenApiArg = void;
export type GetTaxDocumentationStatusApiResponse =
  /** status 200  */ TaxBitDocumentationStatusResponse;
export type GetTaxDocumentationStatusApiArg = void;
export type CreateAccountApiResponse = unknown;
export type CreateAccountApiArg = {
  createAccountDto: CreateAccountDto;
};
export type LegacyCreateAccountApiResponse = unknown;
export type LegacyCreateAccountApiArg = {
  legacyCreateAccountDto: LegacyCreateAccountDto;
};
export type GetMultiAccountUsersApiResponse = /** status 200  */ AccountUsersRes[];
export type GetMultiAccountUsersApiArg = void;
export type SetSelectedUserApiResponse = unknown;
export type SetSelectedUserApiArg = {
  customerIdDto: CustomerIdDto;
};
export type SetDefaultUserApiResponse = unknown;
export type SetDefaultUserApiArg = {
  customerIdDto: CustomerIdDto;
};
export type AcceptTermsApiResponse = unknown;
export type AcceptTermsApiArg = void;
export type AcceptWelcomeModalApiResponse = unknown;
export type AcceptWelcomeModalApiArg = void;
export type AcceptTrEducationModalApiResponse = unknown;
export type AcceptTrEducationModalApiArg = void;
export type HandleResetPasswordApiResponse = /** status 201  */ TransmitSetPasswordRes;
export type HandleResetPasswordApiArg = {
  resetPasswordDto: ResetPasswordDto;
};
export type ForgotPasswordApiResponse = unknown;
export type ForgotPasswordApiArg = {
  forgotPasswordRequestDto: ForgotPasswordRequestDto;
};
export type SendSmsotpApiResponse = /** status 201  */ string;
export type SendSmsotpApiArg = {
  sendSmsotpDto: SendSmsotpDto;
};
export type VerifySmsotpApiResponse = /** status 201  */ object;
export type VerifySmsotpApiArg = {
  verifySmsotpDto: VerifySmsotpDto;
};
export type LockAccountApiResponse = unknown;
export type LockAccountApiArg = {
  lockAccountDto: LockAccountDto;
};
export type CreatePendingAccountApiResponse = unknown;
export type CreatePendingAccountApiArg = {
  createPendingAccountDto: CreatePendingAccountDto;
};
export type SubmitPhoneNumberApiResponse = unknown;
export type SubmitPhoneNumberApiArg = {
  submitPendingAccountPhoneNumberDto: SubmitPendingAccountPhoneNumberDto;
};
export type VerifyPhoneNumberApiResponse = unknown;
export type VerifyPhoneNumberApiArg = {
  verifyPendingAccountPhoneNumberDto: VerifyPendingAccountPhoneNumberDto;
};
export type GetLatestContactChangeApiResponse = /** status 200  */ ContactChangeRes;
export type GetLatestContactChangeApiArg = void;
export type CreateContactChangeApiResponse = /** status 201  */ CreateContactChangeRes;
export type CreateContactChangeApiArg = {
  createContactChangeReqDto: CreateContactChangeReqDto;
};
export type CheckPasswordApiResponse = unknown;
export type CheckPasswordApiArg = {
  passwordDto: PasswordDto;
};
export type VerifySecondaryAuthCodeApiResponse = unknown;
export type VerifySecondaryAuthCodeApiArg = {
  mfaCodeDto: MfaCodeDto;
};
export type ResendSecondaryAuthCodeApiResponse = unknown;
export type ResendSecondaryAuthCodeApiArg = void;
export type ProcessRequestedValuesApiResponse = unknown;
export type ProcessRequestedValuesApiArg = {
  processRequestedValuesReqDto: ProcessRequestedValuesReqDto;
};
export type VerifyRequestedValueCodeApiResponse = unknown;
export type VerifyRequestedValueCodeApiArg = {
  mfaCodeDto: MfaCodeDto;
};
export type ResendRequestedAuthCodeApiResponse = unknown;
export type ResendRequestedAuthCodeApiArg = void;
export type Check2FaCodeApiResponse = unknown;
export type Check2FaCodeApiArg = {
  mfaCodeDto: MfaCodeDto;
};
export type InitiateMfaApiResponse = unknown;
export type InitiateMfaApiArg = void;
export type ClearMfaApiResponse = unknown;
export type ClearMfaApiArg = void;
export type SubmitContactChangeApiResponse = /** status 201  */ ContactChangeRes;
export type SubmitContactChangeApiArg = void;
export type CancelContactChangeApiResponse = unknown;
export type CancelContactChangeApiArg = void;
export type UpdateOnfidoStepsApiResponse = unknown;
export type UpdateOnfidoStepsApiArg = void;
export type LoginApiResponse = /** status 201  */ LoginResponseDto;
export type LoginApiArg = {
  loginDto: LoginDto;
};
export type LoginV2ApiResponse = /** status 201  */ SessionRes;
export type LoginV2ApiArg = {
  loginDtoV2: LoginDtoV2;
};
export type LoginAdminPortalApiResponse = /** status 201  */ SessionRes;
export type LoginAdminPortalApiArg = {
  loginAdminDto: LoginAdminDto;
};
export type LoginNativeApiResponse = /** status 201  */ LoginNativeResponseDto;
export type LoginNativeApiArg = {
  loginDto: LoginDto;
};
export type RefreshSessionApiResponse = /** status 201  */ RefreshSessionResDto;
export type RefreshSessionApiArg = {
  refreshSessionDto: RefreshSessionDto;
};
export type RefreshSessionV1ApiResponse = /** status 201  */ RefreshSessionResDto;
export type RefreshSessionV1ApiArg = {
  refreshSessionDto: RefreshSessionDto;
};
export type EndSessionApiResponse = unknown;
export type EndSessionApiArg = void;
export type TokenExchangeApiResponse = /** status 201  */ SessionRes;
export type TokenExchangeApiArg = {
  tokenExchangeDto: TokenExchangeDto;
};
export type VerifyActionTokenApiResponse = /** status 201  */ ActionTokenRespDto;
export type VerifyActionTokenApiArg = {
  actionTokenReqDto: ActionTokenReqDto;
};
export type VerifyTransactionRiskApiResponse = /** status 201  */ ActionTokenRespDto;
export type VerifyTransactionRiskApiArg = {
  transactionRiskReqDto: TransactionRiskReqDto;
};
export type LoginRecordApiResponse = unknown;
export type LoginRecordApiArg = {
  loginRecordDto: LoginRecordDto;
};
export type RiskRecordApiResponse = unknown;
export type RiskRecordApiArg = {
  riskFailureRecordDto: RiskFailureRecordDto;
};
export type MagicLinkApiResponse = unknown;
export type MagicLinkApiArg = {
  magicLinkDto: MagicLinkDto;
};
export type ChangePasswordApiResponse = unknown;
export type ChangePasswordApiArg = {
  changePasswordDto: ChangePasswordDto;
};
export type GetWebAuthnCredentialsApiResponse = /** status 200  */ WebAuthnCredentialsRes;
export type GetWebAuthnCredentialsApiArg = void;
export type PostWebAuthnCredentialsApiResponse = unknown;
export type PostWebAuthnCredentialsApiArg = {
  webAuthnCredentialsDto: WebAuthnCredentialsDto;
};
export type UpdateWebAuthnCredentialsApiResponse = unknown;
export type UpdateWebAuthnCredentialsApiArg = {
  updateWebAuthnCredentialsDto: UpdateWebAuthnCredentialsDto;
};
export type DeleteWebAuthnCredentialsApiResponse = unknown;
export type DeleteWebAuthnCredentialsApiArg = {
  webAuthnDeleteCredentialsDto: WebAuthnDeleteCredentialsDto;
};
export type WebauthnTokenExchangeApiResponse = /** status 201  */ SessionRes;
export type WebauthnTokenExchangeApiArg = {
  webAuthnCredentialsDto: WebAuthnCredentialsDto;
};
export type CreateSms2FaApiResponse = /** status 200  */ SmsRes;
export type CreateSms2FaApiArg = void;
export type VerifySms2FaApiResponse = /** status 201  */ VerifySms2FaResponseDto;
export type VerifySms2FaApiArg = {
  twoFactorDto: TwoFactorDto;
};
export type Create2FaApiResponse = /** status 200  */ Create2FaResponseDto;
export type Create2FaApiArg = void;
export type Verify2FaApiResponse = /** status 201  */ Verify2FaResponseDto;
export type Verify2FaApiArg = {
  twoFactorDto: TwoFactorDto;
};
export type Deactivate2FaApiResponse = unknown;
export type Deactivate2FaApiArg = {
  twoFactorDto: TwoFactorDto;
};
export type SendEmailCodeApiResponse = unknown;
export type SendEmailCodeApiArg = {
  twoFaEmailVerificationDto: TwoFaEmailVerificationDto;
};
export type Check2FaEmailCodeApiResponse = unknown;
export type Check2FaEmailCodeApiArg = {
  twoFaVerificationDto: TwoFaVerificationDto;
};
export type HandleContactUsFormApiResponse = /** status 201  */ object;
export type HandleContactUsFormApiArg = {
  contactUsFormReqDto: ContactUsFormReqDto;
};
export type CreateApplicantApiResponse = /** status 200  */ CreateApplicantResponse;
export type CreateApplicantApiArg = {
  /** The reason why a user is running this flow. */
  reason?: "Application Form" | "Contact Change" | "Secure Biometrics" | "Re KYC" | "2FA Reset";
};
export type UpdateReKycStepsApiResponse = unknown;
export type UpdateReKycStepsApiArg = void;
export type ValidateSecureBiometricsApiResponse = /** status 200  */ CreateApplicantResponse;
export type ValidateSecureBiometricsApiArg = {
  code: string;
};
export type AddApplicantToOngoingMonitoringApiResponse = /** status 201  */ object;
export type AddApplicantToOngoingMonitoringApiArg = {
  createOngoingMonitoringDto: CreateOngoingMonitoringDto;
};
export type SlackAppActionHandlerApiResponse = unknown;
export type SlackAppActionHandlerApiArg = void;
export type UpdateKycStepsApiResponse = unknown;
export type UpdateKycStepsApiArg = {
  updateKycStepsDto: UpdateKycStepsDto;
};
export type GetUserDetailsApiResponse = /** status 200  */ GetUserDetailsResponse;
export type GetUserDetailsApiArg = void;
export type HandlePotentialPepApiResponse = /** status 201  */ AmlReturnType;
export type HandlePotentialPepApiArg = {
  onfidoPayload: OnfidoPayload;
};
export type LookUpAddressFromInputApiResponse = /** status 200  */ AutocompletePrediction;
export type LookUpAddressFromInputApiArg = {
  input: string;
};
export type GetPlaceDetailApiResponse = unknown;
export type GetPlaceDetailApiArg = {
  getPlaceDetailsDto: GetPlaceDetailsDto;
};
export type GetSalesforceAccountsApiResponse = /** status 200  */ SalesforceAccountList;
export type GetSalesforceAccountsApiArg = {
  pageNumber: number;
  pageSize: number;
  success: boolean;
};
export type CreateSalesForceAccountApiResponse = /** status 201  */ CreateSfAccountReturnType;
export type CreateSalesForceAccountApiArg = {
  createSfAccountPayloadDto: CreateSfAccountPayloadDto;
};
export type ProcessOnboardingQueuesApiResponse = unknown;
export type ProcessOnboardingQueuesApiArg = {
  dataZooQueuePayload: DataZooQueuePayload;
};
export type RekycSalesForceOpportunityApiResponse = unknown;
export type RekycSalesForceOpportunityApiArg = {
  reKycSfOpportunityPayloadDto: ReKycSfOpportunityPayloadDto;
};
export type UploadFileApiResponse = /** status 201  */ FileUploadResponseType;
export type UploadFileApiArg = {
  /** Any file to upload */
  formData: FormData;
};
export type DeleteFileApiResponse = unknown;
export type DeleteFileApiArg = {
  contentVersionId: string;
  code: string;
};
export type EncodeMessageApiResponse = /** status 201  */ string;
export type EncodeMessageApiArg = {
  /** API Key */
  "x-api-key"?: string;
  /** Message to encode */
  encodeMessageDto: EncodeMessageDto;
};
export type ValidateSecureUploadTokenApiResponse = /** status 201  */ string;
export type ValidateSecureUploadTokenApiArg = {
  /** Message to decode */
  decodeMessageDto: DecodeMessageDto;
};
export type HandleSecureFileUploadApiResponse = unknown;
export type HandleSecureFileUploadApiArg = {
  /** Process payload from secure-file upload form */
  secureFileUploadDto: SecureFileUploadDto;
};
export type HandleOnfidoWorkflowApiResponse = unknown;
export type HandleOnfidoWorkflowApiArg = {
  /** Onfido webhook payload */
  onfidoWorkflowPayload: OnfidoWorkflowPayload;
};
export type HandleTimelineFileApiResponse = unknown;
export type HandleTimelineFileApiArg = {
  /** Handles a clients incoming timeline file from Onfido */
  onfidoTimelineFileWebhook: OnfidoTimelineFileWebhook;
};
export type CheckIndividualTradingAccountByEmailApiResponse = /** status 200  */ boolean;
export type CheckIndividualTradingAccountByEmailApiArg = void;
export type GetPreviousSubmissionByEmailApiResponse = /** status 200  */ SalesforceAccountPayload;
export type GetPreviousSubmissionByEmailApiArg = void;
export type IsKycExpiredByEmailApiResponse = /** status 200  */ boolean;
export type IsKycExpiredByEmailApiArg = void;
export type IsDocumentExpiredApiResponse = /** status 200  */ boolean;
export type IsDocumentExpiredApiArg = void;
export type HandleUnsubscribePreferencesApiResponse = unknown;
export type HandleUnsubscribePreferencesApiArg = {
  /** SendGrid Webhook Payload */
  body: SendGridWebhookDto[];
};
export type AddContactToMarketingListApiResponse = /** status 201  */ string;
export type AddContactToMarketingListApiArg = {
  /** SendGrid Webhook Payload */
  sendgridContactToListDto: SendgridContactToListDto;
};
export type ExtractWorkflowDocPropApiResponse =
  /** status 200 Successful response */ OutputProperties;
export type ExtractWorkflowDocPropApiArg = void;
export type GetOccupationListApiResponse = /** status 200  */ string[];
export type GetOccupationListApiArg = void;
export type GetIndustriesListApiResponse = /** status 200  */ string[];
export type GetIndustriesListApiArg = void;
export type CreateDynamicFileUploadLinkApiResponse = /** status 200  */ ReceiptUploadLink;
export type CreateDynamicFileUploadLinkApiArg = {
  /** The reason for creating the upload link */
  reason: "Receipt Upload" | "Onboarding" | "Proof of Address";
};
export type DvsDisclosureApiResponse = unknown;
export type DvsDisclosureApiArg = {
  /** DVS Disclosure Payload */
  dvsDisclosurePayloadDto: DvsDisclosurePayloadDto;
};
export type OnfidoBiometricsConsentApiResponse = unknown;
export type OnfidoBiometricsConsentApiArg = {
  /** Onfido Biometrics Consent Payload */
  onfidoBiometricsConsentPayloadDto: OnfidoBiometricsConsentPayloadDto;
};
export type NotifyBrokerCallApiResponse = unknown;
export type NotifyBrokerCallApiArg = {
  notifyBrokerCallDto: NotifyBrokerCallDto;
};
export type UpdateSsnEinApiResponse = unknown;
export type UpdateSsnEinApiArg = {
  updateSsnEinDto: UpdateSsnEinDto;
};
export type GetRiskScoreConfigApiResponse = /** status 200  */ object;
export type GetRiskScoreConfigApiArg = void;
export type CreateAccessTokenApiResponse = /** status 201  */ CreateAccessTokenResponse;
export type CreateAccessTokenApiArg = {
  iCreateSumsubApplicantDto: ICreateSumsubApplicantDto;
};
export type WebhookApiResponse = unknown;
export type WebhookApiArg = void;
export type GetApplicantStatusApiResponse = /** status 200  */ ApplicantStatusResponseDto;
export type GetApplicantStatusApiArg = void;
export type GetTrustfullScoreViaReqApiResponse = unknown;
export type GetTrustfullScoreViaReqApiArg = void;
export type GenerateAssessmentLinkApiResponse =
  /** status 201  */ GenerateUkAssessmentLinkResponseDto;
export type GenerateAssessmentLinkApiArg = {
  generateUkAssessmentLinkDto: GenerateUkAssessmentLinkDto;
};
export type ValidateAssessmentTokenApiResponse =
  /** status 201  */ ValidateUkAssessmentTokenResponseDto;
export type ValidateAssessmentTokenApiArg = {
  validateUkAssessmentTokenDto: ValidateUkAssessmentTokenDto;
};
export type GetPublicAssessmentQuestionsApiResponse =
  /** status 201  */ GetAssessmentQuestionsResponseDto;
export type GetPublicAssessmentQuestionsApiArg = {
  validateUkAssessmentTokenDto: ValidateUkAssessmentTokenDto;
};
export type SubmitPublicAssessmentApiResponse = /** status 201  */ SubmitAssessmentResponseDto;
export type SubmitPublicAssessmentApiArg = {
  submitPublicUkAssessmentDto: SubmitPublicUkAssessmentDto;
};
export type GetUkOnboardingStatusApiResponse = /** status 200  */ GetUkOnboardingStatusResponseDto;
export type GetUkOnboardingStatusApiArg = void;
export type MarkRiskSummaryViewedApiResponse =
  /** status 200  */
  MarkRiskSummaryViewedResponseDto | /** status 201  */ MarkRiskSummaryViewedResponseDto;
export type MarkRiskSummaryViewedApiArg = void;
export type SubmitUkAccountTypeApiResponse =
  /** status 200  */
  SubmitUkAccountTypeResponseDto | /** status 201  */ SubmitUkAccountTypeResponseDto;
export type SubmitUkAccountTypeApiArg = {
  submitUkAccountTypeDto: SubmitUkAccountTypeDto;
};
export type RestartUkOnboardingApiResponse =
  /** status 200  */
  RestartUkOnboardingResponseDto | /** status 201  */ RestartUkOnboardingResponseDto;
export type RestartUkOnboardingApiArg = void;
export type SubmitInvestorTypeApiResponse =
  /** status 200  */
  InvestorTypeResponseDto | /** status 201  */ InvestorTypeResponseDto;
export type SubmitInvestorTypeApiArg = {
  submitInvestorTypeDto: SubmitInvestorTypeDto;
};
export type SubmitRestrictedInvestorStatementApiResponse =
  /** status 200  */
  | RestrictedInvestorStatementResponseDto
  | /** status 201  */ RestrictedInvestorStatementResponseDto;
export type SubmitRestrictedInvestorStatementApiArg = {
  submitRestrictedInvestorStatementDto: SubmitRestrictedInvestorStatementDto;
};
export type SubmitHnwInvestorStatementApiResponse =
  /** status 200  */
  HnwInvestorStatementResponseDto | /** status 201  */ HnwInvestorStatementResponseDto;
export type SubmitHnwInvestorStatementApiArg = {
  submitHnwInvestorStatementDto: SubmitHnwInvestorStatementDto;
};
export type GetAssessmentQuestionsApiResponse =
  /** status 200  */ GetAssessmentQuestionsResponseDto;
export type GetAssessmentQuestionsApiArg = void;
export type SubmitAssessmentApiResponse =
  /** status 200  */
  SubmitAssessmentResponseDto | /** status 201  */ SubmitAssessmentResponseDto;
export type SubmitAssessmentApiArg = {
  submitAssessmentDto: SubmitAssessmentDto;
};
export type GetAssessmentStatusApiResponse = /** status 200  */ GetAssessmentStatusResponseDto;
export type GetAssessmentStatusApiArg = void;
export type GetCoolingOffStatusApiResponse = /** status 200  */ GetCoolingOffStatusResponseDto;
export type GetCoolingOffStatusApiArg = void;
export type ConfirmAccountApiResponse =
  /** status 200  */
  ConfirmAccountResponseDto | /** status 201  */ ConfirmAccountResponseDto;
export type ConfirmAccountApiArg = void;
export type DeclineAccountApiResponse =
  /** status 200  */
  DeclineAccountResponseDto | /** status 201  */ DeclineAccountResponseDto;
export type DeclineAccountApiArg = void;
export type GetFundTradesApiResponse = unknown;
export type GetFundTradesApiArg = {
  /** The start date for the Fund Trades report. */
  fromDate?: string;
  /** The end date for the Fund Trades report. */
  toDate?: string;
};
export type GetFundFlowsApiResponse = unknown;
export type GetFundFlowsApiArg = {
  /** The start date for the Fund Trades report. */
  fromDate?: string;
  /** The end date for the Fund Trades report. */
  toDate?: string;
};
export type GetFundPositionsApiResponse = unknown;
export type GetFundPositionsApiArg = {
  /** Get the Positions for the given date and time */
  date: string;
};
export type GetAllPublicApiResponse = /** status 200  */ PublicAnnouncement[];
export type GetAllPublicApiArg = void;
export type GetAllApiResponse = /** status 200  */ AttributedAnnouncement[];
export type GetAllApiArg = {
  past?: boolean;
  present?: boolean;
  future?: boolean;
};
export type CreateApiResponse = /** status 201  */ AttributedAnnouncement;
export type CreateApiArg = {
  publicAnnouncement: PublicAnnouncement;
};
export type UpdateApiResponse = /** status 200  */ AttributedAnnouncement;
export type UpdateApiArg = {
  id: string;
  updateAnnouncementDto: UpdateAnnouncementDto;
};
export type DeleteAnnouncementsByIdApiResponse = unknown;
export type DeleteAnnouncementsByIdApiArg = {
  id: string;
};
export type GetLinkAnalyticsApiResponse = /** status 200  */ LinkMetrics[];
export type GetLinkAnalyticsApiArg = {
  id: string;
};
export type GetAllPermissionGroupsApiResponse = /** status 200  */ Group[];
export type GetAllPermissionGroupsApiArg = void;
export type AddAccountPermissionApiResponse = unknown;
export type AddAccountPermissionApiArg = {
  addPermission: AddPermission;
};
export type GetTransmitUserGroupApiResponse = /** status 200  */ Group[];
export type GetTransmitUserGroupApiArg = {
  userId: string;
};
export type RemovePermissionApiResponse = /** status 200  */ boolean;
export type RemovePermissionApiArg = {
  removePermission: RemovePermission;
};
export type EditUserPermissionsApiResponse = unknown;
export type EditUserPermissionsApiArg = {
  editPermissionsDto: EditPermissionsDto;
};
export type GetTransmitUserByEmailApiResponse = /** status 200  */ GetByEmailDto;
export type GetTransmitUserByEmailApiArg = {
  email: string;
};
export type GetUserByCustomerIdApiResponse = /** status 200  */ IUser;
export type GetUserByCustomerIdApiArg = {
  customerId: string;
};
export type GetPingApiResponse = unknown;
export type GetPingApiArg = void;
export type GetUserCountApiResponse = /** status 200  */ number;
export type GetUserCountApiArg = void;
export type CountActiveUsersApiResponse = /** status 200  */ number;
export type CountActiveUsersApiArg = void;
export type GetUserAccountCountLast30DaysApiResponse = /** status 200  */ number;
export type GetUserAccountCountLast30DaysApiArg = void;
export type GetUserLoginChartApiResponse = /** status 200  */ IDailyUserCount[];
export type GetUserLoginChartApiArg = void;
export type HandleAccountStatusApiResponse = /** status 201  */ object;
export type HandleAccountStatusApiArg = {
  disableUserDto: DisableUserDto;
};
export type Disable2FaApiResponse = /** status 200  */ IAccount;
export type Disable2FaApiArg = {
  email: string;
};
export type DisablePasskeyApiResponse = /** status 200  */ IAccount;
export type DisablePasskeyApiArg = {
  email: string;
};
export type EditAutomatedTradesDisabledApiResponse = unknown;
export type EditAutomatedTradesDisabledApiArg = {
  editAutomatedTradesDisabledDto: EditAutomatedTradesDisabledDto;
};
export type UpdateFeaturesApiResponse = unknown;
export type UpdateFeaturesApiArg = {
  updateAccountFeatureDto: UpdateAccountFeatureDto;
};
export type GetAllFeaturesApiResponse = /** status 200  */ string[];
export type GetAllFeaturesApiArg = void;
export type SetIsEmployeeApiResponse = /** status 200  */ IAccount;
export type SetIsEmployeeApiArg = {
  email: string;
  setEmployeeDto: SetEmployeeDto;
};
export type GetContactChangesApiResponse = unknown;
export type GetContactChangesApiArg = {
  /** Page number for pagination */
  page?: number;
  /** Number of items per page */
  limit?: number;
  /** Search by account email */
  email?: string;
  /** Search by customer ID */
  customerId?: string;
};
export type UpdateContactChangeStatusApiResponse = /** status 200  */ ContactChange;
export type UpdateContactChangeStatusApiArg = {
  id: string;
};
export type GetCustomerLogsApiResponse = /** status 201  */ ICustomerLog[];
export type GetCustomerLogsApiArg = {
  getCustomerActionsDto: GetCustomerActionsDto;
};
export type GetConfigApiResponse = /** status 200  */ Config;
export type GetConfigApiArg = void;
export type CreateBatchLogsApiResponse =
  /** status 201 The logs have been processed. */ BatchLogResponseDto;
export type CreateBatchLogsApiArg = {
  batchLogRequestDto: BatchLogRequestDto;
};
export type ListApiResponse = /** status 200  */ IFeatureFlag[];
export type ListApiArg = void;
export type UpsertApiResponse = /** status 200  */ IFeatureFlag;
export type UpsertApiArg = {
  key: string;
  featureFlagUpsertDto: FeatureFlagUpsertDto;
};
export type PutAdminFeatureFlagsByKeyOverrideApiResponse = /** status 200  */ IFeatureFlag;
export type PutAdminFeatureFlagsByKeyOverrideApiArg = {
  key: string;
  featureFlagOverrideDto: FeatureFlagOverrideDto;
};
export type ListTransfersApiResponse = /** status 200  */ ListTransfersResponseDto;
export type ListTransfersApiArg = {
  /** Internal user id */
  userId?: string;
  /** C&B customer id (resolves to userId via users collection) */
  customerId?: string;
  entity?: "AU" | "US" | "LEGACY";
  /** notabeneTransfers.status */
  status?: string;
  /** Most recent audit decision filter */
  decision?:
    | "AUTHORIZED"
    | "DECLINED"
    | "MANUAL_REVIEW"
    | "INFO_REQUESTED"
    | "CLEAR"
    | "REVIEW"
    | "BLOCK";
  /** Filter createdAt >= */
  dateFrom?: string;
  /** Filter createdAt <= */
  dateTo?: string;
  vaspCounterparty?: string;
  notabeneTxId?: string;
  fireblocksTxId?: string;
  blockchainTxHash?: string;
  internalRef?: string;
  page?: number;
  pageSize?: number;
};
export type GetTransferDetailApiResponse = /** status 200  */ TransferDetailResponseDto;
export type GetTransferDetailApiArg = {
  notabeneTxId: string;
};
export type GetAuditChainApiResponse = /** status 200  */ TransferAuditChainResponseDto;
export type GetAuditChainApiArg = {
  notabeneTxId: string;
};
export type ForceAuthorizeApiResponse = /** status 201  */ ForceActionResponseDto;
export type ForceAuthorizeApiArg = {
  notabeneTxId: string;
  manualOverrideDto: ManualOverrideDto;
};
export type ReleaseHoldApiResponse = /** status 201  */ ReleaseHoldResponseDto;
export type ReleaseHoldApiArg = {
  internalCtId: string;
  manualOverrideDto: ManualOverrideDto;
};
export type ForceDeclineApiResponse = /** status 201  */ ForceActionResponseDto;
export type ForceDeclineApiArg = {
  notabeneTxId: string;
  manualOverrideDto: ManualOverrideDto;
};
export type RescreenApiResponse = /** status 201  */ RescreenResponseDto;
export type RescreenApiArg = {
  notabeneTxId: string;
};
export type GetCryptoCurrenciesApiResponse = /** status 200  */ CurrencyConfigRankedRes[];
export type GetCryptoCurrenciesApiArg = void;
export type GetCryptoAllApiResponse = /** status 200  */ IPopulatedCryptoRes[];
export type GetCryptoAllApiArg = {
  /** The currnecy code to convert token data into. */
  quote?: string;
  /** Comma separated list of tokens to filter by. */
  filterByToken?: string;
};
export type GetCryptoAllTickersApiResponse = /** status 200  */ IPopulatedCryptoTickersRes[];
export type GetCryptoAllTickersApiArg = void;
export type GetTrendingCryptoCurrenciesApiResponse = /** status 200  */ CurrencyConfigRankedRes[];
export type GetTrendingCryptoCurrenciesApiArg = {
  /** A boolean value to add pricing data to the response */
  pricingData?: boolean;
  /** A boolean value to add pricing data to the response */
  limit?: number;
  /** The currnecy code to convert token data into. */
  quote?: string;
};
export type GetCryptoSectorsApiResponse = /** status 200  */ CryptoSectorsRes;
export type GetCryptoSectorsApiArg = void;
export type GetCoinPageDataApiResponse = /** status 200  */ TokenPageDataRes;
export type GetCoinPageDataApiArg = {
  token: string;
  /** The base currency code into which to convert price data. */
  baseCurrency?: string;
};
export type GetCoinPageChartApiResponse = /** status 200  */ ChartWCandleRes;
export type GetCoinPageChartApiArg = {
  token: string;
  /** The interval(timeframe) of the requested chart */
  interval?: string;
};
export type GetTokenChartDataApiResponse = /** status 200  */ ChartWCandleRes;
export type GetTokenChartDataApiArg = {
  token: string;
  /** The interval(timeframe) of the requested chart */
  interval?: string;
  /** The start date in which to grab token data from */
  startDate?: string;
  /** The currnecy code to convert token data into. */
  quote?: string;
};
export type GetCandleChartDataApiResponse = /** status 200  */ CandleChartType[];
export type GetCandleChartDataApiArg = {
  token: string;
  /** The interval(timeframe) of the requested chart */
  interval?: string;
};
export type GetTopRankedApiResponse = /** status 200  */ TopRankedRes[];
export type GetTopRankedApiArg = void;
export type IncrementCoinVisitApiResponse = /** status 201  */ CoinVisit;
export type IncrementCoinVisitApiArg = {
  coinVisitsDto: CoinVisitsDto;
};
export type GetFiatCurrenciesApiResponse = /** status 200  */ ForexCurrencyRes[];
export type GetFiatCurrenciesApiArg = {
  /** The currnecy code to convert token data into. */
  quote?: string;
  /** Comma separated list of tokens to filter by. */
  filterByToken?: string;
};
export type GetLiveForexApiResponse = /** status 200  */ ForexCurrencyRes[];
export type GetLiveForexApiArg = void;
export type GetFiatAndStableCoinsApiResponse = /** status 200  */ ForexCurrencyRes[];
export type GetFiatAndStableCoinsApiArg = void;
export type GetMarketTokensListApiResponse = /** status 200  */ MarketListRes;
export type GetMarketTokensListApiArg = {
  /** The limit (number of) records to return. */
  limit?: number;
  /** The page of records to return. */
  page?: number;
  /** The sector of tokens for which a filter will be applied */
  sector?: string;
  /** Search For One Token */
  searchQuery?: string;
  /** The subset of market data that has been requested. Determines filter and/or ordering of tokens. */
  type?: "all" | "watchlist" | "portfolio" | "recent" | "gainers";
};
export type GetMarketPageCardsApiResponse = /** status 200  */ MarketCardsRes;
export type GetMarketPageCardsApiArg = void;
export type GetBiggestMoversApiResponse = /** status 200  */ DashboardCryptoRes[];
export type GetBiggestMoversApiArg = {
  /** Dictates whether data should be related to customer held holdings */
  customerHeld: boolean;
};
export type GetBestPerformingAssetApiResponse = /** status 200  */ DashboardCryptoRes;
export type GetBestPerformingAssetApiArg = {
  /** The interval(timeframe) of the requested chart */
  interval?: string;
};
export type GetNewlyListedApiResponse = /** status 200  */ CurrencyConfigRes[];
export type GetNewlyListedApiArg = void;
export type GetMarketDataApiResponse = /** status 200  */ MarketOverallRes;
export type GetMarketDataApiArg = void;
export type GetTreeMapApiResponse = /** status 200  */ TreeMapTokenRes[];
export type GetTreeMapApiArg = void;
export type GetTokenCryptoNewsApiResponse = /** status 200  */ CryptoNewsRes[];
export type GetTokenCryptoNewsApiArg = {
  token: string;
};
export type GetDashboardCryptoNewsApiResponse = /** status 200  */ CryptoNewsRes[];
export type GetDashboardCryptoNewsApiArg = void;
export type UpdateCoinNoteApiResponse = /** status 201  */ PostNoteCoinResponseType;
export type UpdateCoinNoteApiArg = {
  updateCoinDto: UpdateCoinDto;
};
export type GetCoinNoteApiResponse = /** status 200  */ ICoinNote;
export type GetCoinNoteApiArg = {
  ticker: string;
};
export type GetUserCurrencyTransactionsApiResponse =
  /** status 200 The union of PaginatedCTsRes and PaginatedCTsMobileRes */
  PaginatedCTsRes | PaginatedCTsMobileRes;
export type GetUserCurrencyTransactionsApiArg = {
  /** The limit (number of) records to return. */
  limit?: number;
  /** The page of records to return. */
  page?: number;
  /** The base currency code into which to convert price data. */
  baseCurrency?: string;
  /** The device type that is accessing this endpoint. Changes return format. */
  device?: "desktop" | "mobile";
  /** The timezone into which to format dates if mobile device is selected. */
  timezone?: string;
  /** Filter option for the type of CT. */
  txType?: "all" | "trade" | "deposit" | "withdrawal" | "referral" | "target" | "stop_limit";
  /** Filter option for statuses of CT. */
  statuses?: (
    | "completed"
    | "pending"
    | "processing"
    | "requested"
    | "cancelled"
    | "authorised"
    | "open"
  )[];
  /** Filter option for the related currency code of the CT. */
  currency?: string;
  /** Filter option for the minimum CT created date in epoch time. */
  startDate?: number;
  /** Filter option for the maximum CT created date in epoch time. */
  endDate?: number;
  /** Filter option for the minimum CT value. */
  startTxSize?: number;
  /** Filter option for the maximum CT value. */
  endTxSize?: number;
  /** The User ID of the user to get the CTs for. Only for admin use. */
  userId?: string;
};
export type GetUserTransactionStatsApiResponse =
  /** status 200 User transaction statistics */ UserTransactionStatsRes;
export type GetUserTransactionStatsApiArg = {
  /** Start date filter (ISO 8601 format: YYYY-MM-DD) */
  startDate?: string;
  /** End date filter (ISO 8601 format: YYYY-MM-DD) */
  endDate?: string;
};
export type GetUserRecentTransactionsApiResponse = /** status 200  */ UserRecentTransactions[];
export type GetUserRecentTransactionsApiArg = void;
export type GetUserTokenPageRecentTransactionsApiResponse =
  /** status 200  */ CurrencyTransactionRes[];
export type GetUserTokenPageRecentTransactionsApiArg = {
  token: string;
  /** The base currency code into which to convert price data. */
  baseCurrency?: string;
};
export type GetCreatedCtApiResponse = /** status 200  */ CurrencyTransactionRes[];
export type GetCreatedCtApiArg = void;
export type GetTargetOrderCtApiResponse = /** status 200  */ PaginatedTargetOrdersRes;
export type GetTargetOrderCtApiArg = {
  /** The limit (number of) records to return. */
  limit?: number;
  /** The page of records to return. */
  page?: number;
  /** Sort option for target Order ct. */
  sortType?:
    | "date"
    | "targetHighest"
    | "targetLowest"
    | "targetClosest"
    | "targetFarthest"
    | "none";
  /** Filter option for target Order ct. */
  filterType?: "all" | "buy" | "sell";
  /** The token code of the target order. */
  tokenCode?: string;
  /** Filter option for statuses of target CTs. */
  statusFilter?: "inProgress" | "orderHistory";
};
export type GetTargetOrderTokensApiResponse = /** status 200  */ CurrencyConfigRes[];
export type GetTargetOrderTokensApiArg = void;
export type ExportCsvApiResponse = /** status 200  */ object;
export type ExportCsvApiArg = {
  /** The base currency code into which to convert price data. */
  baseCurrency?: string;
  /** The timezone into which to format dates if mobile device is selected. */
  timezone?: string;
  /** Filter option for the type of CT. */
  txType?: "all" | "trade" | "deposit" | "withdrawal" | "referral" | "target" | "stop_limit";
  /** Filter option for statuses of CT. */
  statuses?: (
    | "completed"
    | "pending"
    | "processing"
    | "requested"
    | "cancelled"
    | "authorised"
    | "open"
  )[];
  /** Filter option for the related currency code of the CT. */
  currency?: string;
  /** Filter option for the minimum CT created date in epoch time. */
  startDate?: number;
  /** Filter option for the maximum CT created date in epoch time. */
  endDate?: number;
  /** Filter option for the minimum CT value. */
  startTxSize?: number;
  /** Filter option for the maximum CT value. */
  endTxSize?: number;
  /** The User ID of the user to get the CTs for. Only for admin use. */
  userId?: string;
  /** When true, export in Koinly-compatible CSV format (sent/received columns). When false or omitted, use the standard transaction CSV. */
  koinlyFormat?: boolean;
};
export type ExportCsvKoinlyApiResponse = /** status 200  */ object;
export type ExportCsvKoinlyApiArg = {
  /** The base currency code into which to convert price data. */
  baseCurrency?: string;
  /** The timezone into which to format dates if mobile device is selected. */
  timezone?: string;
  /** Filter option for the type of CT. */
  txType?: "all" | "trade" | "deposit" | "withdrawal" | "referral" | "target" | "stop_limit";
  /** Filter option for statuses of CT. */
  statuses?: (
    | "completed"
    | "pending"
    | "processing"
    | "requested"
    | "cancelled"
    | "authorised"
    | "open"
  )[];
  /** Filter option for the related currency code of the CT. */
  currency?: string;
  /** Filter option for the minimum CT created date in epoch time. */
  startDate?: number;
  /** Filter option for the maximum CT created date in epoch time. */
  endDate?: number;
  /** Filter option for the minimum CT value. */
  startTxSize?: number;
  /** Filter option for the maximum CT value. */
  endTxSize?: number;
  /** The User ID of the user to get the CTs for. Only for admin use. */
  userId?: string;
  /** When true, export in Koinly-compatible CSV format (sent/received columns). When false or omitted, use the standard transaction CSV. */
  koinlyFormat?: boolean;
};
export type ExportCsvAdminApiResponse = /** status 200  */ object;
export type ExportCsvAdminApiArg = {
  /** The base currency code into which to convert price data. */
  baseCurrency?: string;
  /** The timezone into which to format dates if mobile device is selected. */
  timezone?: string;
  /** Filter option for the type of CT. */
  txType?: "all" | "trade" | "deposit" | "withdrawal" | "referral" | "target" | "stop_limit";
  /** Filter option for statuses of CT. */
  statuses?: (
    | "completed"
    | "pending"
    | "processing"
    | "requested"
    | "cancelled"
    | "authorised"
    | "open"
  )[];
  /** Filter option for the related currency code of the CT. */
  currency?: string;
  /** Filter option for the minimum CT created date in epoch time. */
  startDate?: number;
  /** Filter option for the maximum CT created date in epoch time. */
  endDate?: number;
  /** Filter option for the minimum CT value. */
  startTxSize?: number;
  /** Filter option for the maximum CT value. */
  endTxSize?: number;
  /** The User ID of the user to get the CTs for. Only for admin use. */
  userId?: string;
  /** When true, export in Koinly-compatible CSV format (sent/received columns). When false or omitted, use the standard transaction CSV. */
  koinlyFormat?: boolean;
};
export type GetOrderSizeRangeApiResponse =
  /** status 200 Order size range (min and max) */ OrderSizeRangeRes;
export type GetOrderSizeRangeApiArg = {
  /** Time range filter for transactions */
  timeRange?: "all_time" | "last_month" | "last_quarter" | "last_year" | "custom";
  /** Start date for custom time range (ISO 8601 format: YYYY-MM-DD). Required when timeRange is 'custom'. */
  startDate?: string;
  /** End date for custom time range (ISO 8601 format: YYYY-MM-DD). Required when timeRange is 'custom'. */
  endDate?: string;
  /** Number of bins for the histogram */
  numberOfBins?: number;
};
export type FilterTransactionsApiResponse =
  /** status 200 Paginated list of filtered currency transactions */
  PaginatedCTsRes | /** status 201  */ PaginatedCTsRes;
export type FilterTransactionsApiArg = {
  transactionsFilterRequestDto: TransactionsFilterRequestDto;
};
export type AddNoteToCtApiResponse = unknown;
export type AddNoteToCtApiArg = {
  ctNoteDto: CtNoteDto;
};
export type GetPendingWithdrawalsApiResponse = /** status 200  */ PendingWithdrawalRes[];
export type GetPendingWithdrawalsApiArg = void;
export type SetWithdrawalApprovalStatusApiResponse =
  /** status 200 The withdrawal approval status that was set */
  WithdrawalApprovalStatusResponse | /** status 201  */ WithdrawalApprovalStatusResponse;
export type SetWithdrawalApprovalStatusApiArg = {
  setWithdrawalApprovalStatusDto: SetWithdrawalApprovalStatusDto;
};
export type GetUserDepositAddressApiResponse = /** status 200  */ DepositAddressRes;
export type GetUserDepositAddressApiArg = {
  token: string;
};
export type ProcessDepositApiResponse = unknown;
export type ProcessDepositApiArg = {
  processDepositDto: ProcessDepositDto;
};
export type CreateStripeVbankTransferApiResponse =
  /** status 200 Stripe financial address details */ ProcessStripeDepositRes;
export type CreateStripeVbankTransferApiArg = void;
export type HasExistingStripeAccountsApiResponse =
  /** status 200 Boolean indicating if user has existing Stripe accounts */ boolean;
export type HasExistingStripeAccountsApiArg = void;
export type GetWalletPageBalanceApiResponse = /** status 200  */ WalletBalanceRes;
export type GetWalletPageBalanceApiArg = {
  /** The base currency code into which to convert price data. */
  baseCurrency?: string;
};
export type GetWalletPageHoldingsApiResponse = /** status 200  */ HoldingRes[];
export type GetWalletPageHoldingsApiArg = {
  /** The base currency code into which to convert price data. */
  baseCurrency?: string;
};
export type GetWalletPageHoldingsNewApiResponse = /** status 200  */ HoldingRes[];
export type GetWalletPageHoldingsNewApiArg = {
  /** The base currency code into which to convert price data. */
  baseCurrency?: string;
};
export type GetBestPerformingHoldingsApiResponse = /** status 200  */ HoldingRes[];
export type GetBestPerformingHoldingsApiArg = void;
export type GetUserHeldCurrenciesApiResponse = /** status 200  */ CurrencyConfigRes[];
export type GetUserHeldCurrenciesApiArg = void;
export type GetUserRunningBalanceChartApiResponse = /** status 200  */ ChartStackedRes[];
export type GetUserRunningBalanceChartApiArg = {
  /** The interval(timeframe) of the requested chart */
  interval?: string;
  /** The number of currencies that is wanted for individual charts. */
  numberOfCurrencies?: number;
};
export type GetAllUserRunningBalanceChartsApiResponse = /** status 200  */ AllRunningTotalChartsRes;
export type GetAllUserRunningBalanceChartsApiArg = void;
export type GetUserFiatHoldingsApiResponse = /** status 200  */ UserFiatHoldings[];
export type GetUserFiatHoldingsApiArg = void;
export type GetReferralsApiResponse = /** status 200  */ ReferralsDataRes;
export type GetReferralsApiArg = void;
export type GetReferralRewardsApiResponse = /** status 200  */ ReferralRewardsRes[];
export type GetReferralRewardsApiArg = void;
export type GetReferralMontlyRewardsApiResponse = /** status 200  */ ReferralMontlyRewardsRes[];
export type GetReferralMontlyRewardsApiArg = {
  /** The time frame of the data to collect. */
  timeFrame: string;
};
export type CreateReferralUrlApiResponse = /** status 200  */ ReferralsDataRes;
export type CreateReferralUrlApiArg = void;
export type UpdateLinkShareAnalyticsApiResponse = unknown;
export type UpdateLinkShareAnalyticsApiArg = {
  shareLinkDto: ShareLinkDto;
};
export type SubmitReferralCodeApiResponse = unknown;
export type SubmitReferralCodeApiArg = {
  referralCodeDto: ReferralCodeDto;
};
export type GetReferredByUserApiResponse = /** status 200  */ string;
export type GetReferredByUserApiArg = void;
export type GetUserDatav2ApiResponse = /** status 200  */ UserRes;
export type GetUserDatav2ApiArg = void;
export type GetUserSummaryApiResponse = /** status 200  */ UserSummary[];
export type GetUserSummaryApiArg = {
  /** The time frame of the data to collect. */
  timeFrame: "1D" | "1M" | "3M" | "6M" | "9M" | "1Y" | "ALL";
};
export type GetKycStatusApiResponse = /** status 200  */ KycStatusRes;
export type GetKycStatusApiArg = void;
export type GetWatchlistApiResponse = /** status 200  */ IWatchListDataRes[];
export type GetWatchlistApiArg = {
  /** The currency code to convert token data into. */
  quote?: string;
};
export type AddWatchlistApiResponse = /** status 201  */ IWatchListDataRes[];
export type AddWatchlistApiArg = {
  /** The code of the currency. */
  token: string;
};
export type RemoveWatchlistApiResponse = /** status 200  */ IWatchListDataRes[];
export type RemoveWatchlistApiArg = {
  /** The code of the currency. */
  token: string;
};
export type GetWatchlistV2ApiResponse = /** status 200  */ IWatchListDataRes[];
export type GetWatchlistV2ApiArg = {
  /** The currency code to convert token data into. */
  quote?: string;
};
export type AddWatchlistV2ApiResponse = /** status 201  */ AddWatchlistV2Response;
export type AddWatchlistV2ApiArg = {
  addWatchlistV2Dto: AddWatchlistV2Dto;
};
export type RemoveWatchlistV2ApiResponse = /** status 200  */ RemoveWatchlistV2Response;
export type RemoveWatchlistV2ApiArg = {
  removeWatchlistV2Dto: RemoveWatchlistV2Dto;
};
export type AcceptStateDisclosureApiResponse = unknown;
export type AcceptStateDisclosureApiArg = {
  acceptStateDisclosureDto: AcceptStateDisclosureDto;
};
export type AcceptDepositDisclosureApiResponse = unknown;
export type AcceptDepositDisclosureApiArg = {
  acceptDepositDisclosureDto: AcceptDepositDisclosureDto;
};
export type GetTodayDisclosureAcceptanceApiResponse =
  /** status 200  */ TodayDisclosureAcceptanceRes;
export type GetTodayDisclosureAcceptanceApiArg = {
  /** IANA timezone to determine 'today'. */
  timezone: string;
  /** Transaction type to check acceptance for. */
  transactionType:
    | "trade"
    | "target_order"
    | "dca_strategy"
    | "crypto_withdrawal"
    | "fiat_withdrawal";
};
export type PrepareWithdrawalApiResponse = /** status 201  */ PrepareWithdrawalResponseDto;
export type PrepareWithdrawalApiArg = {
  prepareWithdrawalDto: PrepareWithdrawalDto;
};
export type CheckWithdrawalEmailCodeApiResponse = unknown;
export type CheckWithdrawalEmailCodeApiArg = {
  withdrawalVerificationDto: WithdrawalVerificationDto;
};
export type ResendWithdrawalEmailCodeApiResponse = unknown;
export type ResendWithdrawalEmailCodeApiArg = {
  sendWithdrawalEmailCodeDto: SendWithdrawalEmailCodeDto;
};
export type CheckIsUserLockedApiResponse = /** status 200  */ boolean;
export type CheckIsUserLockedApiArg = {
  fiat: boolean;
};
export type ProcessWithdrawalApiResponse = unknown;
export type ProcessWithdrawalApiArg = {
  processWithdrawalDto: ProcessWithdrawalDto;
};
export type ProcessFiatWithdrawalApiResponse = unknown;
export type ProcessFiatWithdrawalApiArg = {
  processFiatWithdrawalDto: ProcessFiatWithdrawalDto;
};
export type GetMinimumWithdrawalAmountApiResponse = /** status 201  */ number;
export type GetMinimumWithdrawalAmountApiArg = {
  minimumWithdrawalDto: MinimumWithdrawalDto;
};
export type GetUserCryptoAddressesApiResponse = /** status 200  */ WithdrawAddressSeparateRes[];
export type GetUserCryptoAddressesApiArg = {
  onlyVerified: boolean;
};
export type GetUserWithdrawAddressApiResponse = /** status 200  */ TokenSpecificWithdrawAddressRes;
export type GetUserWithdrawAddressApiArg = {
  token: string;
};
export type AddUserWithdrawAddressApiResponse = unknown;
export type AddUserWithdrawAddressApiArg = {
  addWithdrawAddressDto: AddWithdrawAddressDto;
};
export type PatchAddressTrFieldsApiResponse = unknown;
export type PatchAddressTrFieldsApiArg = {
  address: string;
  patchTrFieldsDto: PatchTrFieldsDto;
};
export type UpdateUserWithdrawAddressApiResponse = unknown;
export type UpdateUserWithdrawAddressApiArg = {
  updateAddressDto: UpdateAddressDto;
};
export type CheckEmailCodeApiResponse = unknown;
export type CheckEmailCodeApiArg = {
  addressWithEmailCodeDto: AddressWithEmailCodeDto;
};
export type VerfiyUserWithdrawAddressEmailApiResponse =
  /** status 201  */ ProcessWithdrawAddressRes;
export type VerfiyUserWithdrawAddressEmailApiArg = {
  addressWithCodesDto: AddressWithCodesDto;
};
export type VerifyAddressApiResponse = unknown;
export type VerifyAddressApiArg = {
  verifyAddressDto: VerifyAddressDto;
};
export type ResendEmailCodeApiResponse = unknown;
export type ResendEmailCodeApiArg = {
  resendEmailCodeDto: ResendEmailCodeDto;
};
export type CreateCurrencyTransactionReportApiResponse = /** status 200  */ CtReport;
export type CreateCurrencyTransactionReportApiArg = {
  /** The timezone into which to format dates. */
  timezone?: string;
  /** Filter option for the minimum CT created date in epoch time. */
  startDate?: number;
  /** Filter option for the maximum CT created date in epoch time. */
  endDate?: number;
};
export type CreateAccountReportApiResponse = /** status 200  */ AccountReport;
export type CreateAccountReportApiArg = {
  /** The timezone into which to format dates. */
  timezone?: string;
  /** Filter option for the minimum CT created date in epoch time. */
  startDate?: number;
  /** Filter option for the maximum CT created date in epoch time. */
  endDate?: number;
};
export type CreateAccountReportByIdApiResponse = /** status 200  */ AccountReport;
export type CreateAccountReportByIdApiArg = {
  /** The timezone into which to format dates. */
  timezone?: string;
  /** Filter option for the minimum CT created date in epoch time. */
  startDate?: number;
  /** Filter option for the maximum CT created date in epoch time. */
  endDate?: number;
  /** The user ID. */
  id: string;
};
export type CreateAccountReportByCustomerIdApiResponse = /** status 200  */ AccountReport;
export type CreateAccountReportByCustomerIdApiArg = {
  /** The timezone into which to format dates. */
  timezone?: string;
  /** Filter option for the minimum CT created date in epoch time. */
  startDate?: number;
  /** Filter option for the maximum CT created date in epoch time. */
  endDate?: number;
  /** The user ID. */
  id: string;
};
export type GetTradeSummaryApiResponse = /** status 201  */ SanitisedTradeSummaryRes;
export type GetTradeSummaryApiArg = {
  tradeSummaryDto: TradeSummaryDto;
};
export type CreateCtApiResponse = unknown;
export type CreateCtApiArg = {
  createTradeDto: CreateTradeDto;
};
export type GetTargetOrderSummaryApiResponse = /** status 201  */ SanitisedTargetOrderSummaryRes;
export type GetTargetOrderSummaryApiArg = {
  targetOrderSummaryDto: TargetOrderSummaryDto;
};
export type CreateTargetOrderCtApiResponse = unknown;
export type CreateTargetOrderCtApiArg = {
  createTargetOrderDto: CreateTargetOrderDto;
};
export type CreateGamApiResponse = unknown;
export type CreateGamApiArg = {
  requestActionDto: RequestActionDto;
};
export type RequestCancelApiResponse = unknown;
export type RequestCancelApiArg = {
  requestActionDto: RequestActionDto;
};
export type CreatePriceAlertApiResponse = unknown;
export type CreatePriceAlertApiArg = {
  priceAlertDto: PriceAlertDto;
};
export type EditPriceAlertApiResponse = unknown;
export type EditPriceAlertApiArg = {
  existingPriceAlertDto: ExistingPriceAlertDto;
};
export type DeletePriceAlertApiResponse = unknown;
export type DeletePriceAlertApiArg = {
  priceAlertIdDto: PriceAlertIdDto;
};
export type GetPriceAlertsApiResponse = /** status 200  */ PaginatedPriceAlertsRes;
export type GetPriceAlertsApiArg = {
  /** The limit (number of) records to return. */
  limit?: number;
  /** The page of records to return. */
  page?: number;
};
export type GetUnreadNotificationsApiResponse = /** status 200  */ PaginatedUserNotificationsRes;
export type GetUnreadNotificationsApiArg = {
  /** Whether to get only read or unread notifications. */
  read: boolean;
};
export type SetNotificationsToReadApiResponse = unknown;
export type SetNotificationsToReadApiArg = {
  userNotificationIdsDto: UserNotificationIdsDto;
};
export type SetAllNotificationsToReadApiResponse = unknown;
export type SetAllNotificationsToReadApiArg = void;
export type ClearNotificationsApiResponse = unknown;
export type ClearNotificationsApiArg = {
  userNotificationIdsDto: UserNotificationIdsDto;
};
export type ClearAllNotificationsApiResponse = unknown;
export type ClearAllNotificationsApiArg = void;
export type GetDcaStrategySummaryApiResponse = /** status 201  */ DcaStrategySummaryRes;
export type GetDcaStrategySummaryApiArg = {
  dcaStrategyReqDto: DcaStrategyReqDto;
};
export type CreateDcaStrategyApiResponse = /** status 201  */ DcaStrategyDto;
export type CreateDcaStrategyApiArg = {
  dcaStrategySummaryRes: DcaStrategySummaryRes;
};
export type GetDcaStrategiesApiResponse = /** status 200  */ GetDcaStrategiesDto;
export type GetDcaStrategiesApiArg = {
  page: number;
  filters: string[];
};
export type CancelDcaStrategyApiResponse = /** status 200  */ DcaStrategyDto;
export type CancelDcaStrategyApiArg = {
  id: string;
};
export type GetUserDcaTriggersApiResponse = /** status 200  */ GetTriggersResDto;
export type GetUserDcaTriggersApiArg = {
  strategyId: string;
  page: number;
};
export type UpdateBurlingBankDetailsApiResponse = unknown;
export type UpdateBurlingBankDetailsApiArg = {
  updateBurlingBankDetails: UpdateBurlingBankDetails;
};
export type GetBurlingBankDetailsApiResponse = /** status 200  */ UserBankingDto;
export type GetBurlingBankDetailsApiArg = void;
export type AddBankDetailsApiResponse = /** status 201  */ IBankDetails;
export type AddBankDetailsApiArg = {
  bankAccountReqDto: BankAccountReqDto;
};
export type GetBankDetailsByAccDigitsApiResponse = /** status 200  */ IBankDetailsRes;
export type GetBankDetailsByAccDigitsApiArg = {
  ibanAccNumber: string;
};
export type GetBankDetailsApiResponse = /** status 200  */ IBankDetailsRes[];
export type GetBankDetailsApiArg = void;
export type GetReferralsCountApiResponse = /** status 200  */ ReferralsCountRes;
export type GetReferralsCountApiArg = void;
export type GetReferralConversionMetricsApiResponse = /** status 200  */ ReferralConversionRes;
export type GetReferralConversionMetricsApiArg = void;
export type GetReferralPartnerFeesApiResponse = /** status 200  */ ReferralFeesRes;
export type GetReferralPartnerFeesApiArg = {
  timeFrame: "1W" | "1M" | "1Y" | "ALL";
  timezone: string;
};
export type GetReferralHoldingsApiResponse = /** status 200  */ ReferralAssetHoldings;
export type GetReferralHoldingsApiArg = void;
export type GetReferralTradeHistoryApiResponse = /** status 200  */ ReferralTradeHistory;
export type GetReferralTradeHistoryApiArg = {
  timeFrame: "1W" | "1M" | "1Y" | "ALL";
  timezone: string;
};
export type GetReferralGrowthHistoryApiResponse = /** status 200  */ ReferralGrowthHistoryRes;
export type GetReferralGrowthHistoryApiArg = {
  timeFrame: "1W" | "1M" | "1Y" | "ALL";
  timezone: string;
};
export type GetCoinVisitsApiResponse = /** status 200  */ ReferralCoinVisitsRes;
export type GetCoinVisitsApiArg = {
  timeFrame: "1W" | "1M" | "1Y" | "ALL";
  timezone: string;
};
export type GetReferralCodeApiResponse = /** status 200  */ ReferralCodeRes;
export type GetReferralCodeApiArg = void;
export type GetDepositsVolumeApiResponse = /** status 200  */ ReferralDepositVolumeRes;
export type GetDepositsVolumeApiArg = {
  timeFrame: "1W" | "1M" | "1Y" | "ALL";
  timezone: string;
};
export type GetTimeToFirstTradeApiResponse = /** status 200  */ ReferralAvgFirstTradeTimeRes;
export type GetTimeToFirstTradeApiArg = {
  timeFrame: "1W" | "1M" | "1Y" | "ALL";
  timezone: string;
};
export type GetAssetsTradedApiResponse = /** status 200  */ ReferralAssetsTraded;
export type GetAssetsTradedApiArg = {
  timeFrame: "1W" | "1M" | "1Y" | "ALL";
  timezone: string;
};
export type GetReferalPartnerDetailsApiResponse = /** status 200  */ PartnershipMatchTableItem;
export type GetReferalPartnerDetailsApiArg = {
  referrer: string;
};
export type EvalFlagsApiResponse = /** status 200  */ object;
export type EvalFlagsApiArg = {
  keys: string;
};
export type GetAccessTokenApiResponse = /** status 200  */ NotabeneTokenResponseDto;
export type GetAccessTokenApiArg = void;
export type CreateTransferApiResponse = /** status 201  */ NotabeneTransferResponseDto;
export type CreateTransferApiArg = {
  "x-withdrawal-prepared-token": string;
  createNotabeneTransferDto: CreateNotabeneTransferDto;
};
export type GetTransferApiResponse = /** status 200  */ NotabeneTransferResponseDto;
export type GetTransferApiArg = {
  /** Notabene transfer ID */
  txId: string;
};
export type CompleteTransferApiResponse = /** status 201  */ NotabeneTransferResponseDto;
export type CompleteTransferApiArg = {
  /** Notabene transfer ID */
  txId: string;
  "x-withdrawal-prepared-token": string;
};
export type GetUserTransfersApiResponse = /** status 200  */ NotabeneTransferResponseDto[];
export type GetUserTransfersApiArg = void;
export type CancelTransferApiResponse = unknown;
export type CancelTransferApiArg = {
  /** Notabene transfer ID */
  txId: string;
};
export type CancelActiveTransfersApiResponse = unknown;
export type CancelActiveTransfersApiArg = void;
export type NotabeneHandleWebhookApiResponse = unknown;
export type NotabeneHandleWebhookApiArg = void;
export type GetDidDocumentApiResponse = /** status 200  */ object;
export type GetDidDocumentApiArg = {
  /** Which legal entity's DID document to return. Omitted = first configured entity. */
  entity?: "AU" | "US";
};
export type CheckTransferAuthorizedApiResponse = unknown;
export type CheckTransferAuthorizedApiArg = {
  /** Notabene transfer ID */
  txId: string;
};
export type GetTrConfigApiResponse = /** status 200  */ TrConfigResponseDto;
export type GetTrConfigApiArg = void;
export type SearchVaspsApiResponse = /** status 200  */ VaspDirectoryRowDto[];
export type SearchVaspsApiArg = {
  /** Search query (min 2 chars) */
  q: string;
};
export type HandleDepositConfirmedApiResponse = unknown;
export type HandleDepositConfirmedApiArg = {
  "x-belfast-signature": string;
  "x-belfast-timestamp": string;
  "x-belfast-idempotency-key": string;
};
export type SubmitSenderInfoApiResponse = unknown;
export type SubmitSenderInfoApiArg = {
  /** Notabene transfer id */
  id: string;
};
export type ListLegalDocumentsApiResponse = /** status 200  */ LegalDocumentRes[];
export type ListLegalDocumentsApiArg = void;
export type GetCurrentLegalDocumentApiResponse = /** status 200  */ LegalDocumentRes;
export type GetCurrentLegalDocumentApiArg = {
  type: string;
};
export type GetPublicCurrentLegalDocumentApiResponse = /** status 200  */ LegalDocumentRes;
export type GetPublicCurrentLegalDocumentApiArg = {
  type: string;
  country?: string;
  region?: string;
};
export type GetLegalDocumentVersionApiResponse = /** status 200  */ LegalDocumentRes;
export type GetLegalDocumentVersionApiArg = {
  version: string;
  country?: string;
  region?: string;
};
export type ListLegalDocumentVersionsApiResponse = /** status 200  */ LegalDocumentRes[];
export type ListLegalDocumentVersionsApiArg = {
  country?: string;
  region?: string;
};
export type CreateLegalDocumentDraftApiResponse = /** status 201  */ ILegalDocument;
export type CreateLegalDocumentDraftApiArg = {
  createLegalDraftDto: CreateLegalDraftDto;
};
export type PublishLegalDocumentApiResponse = /** status 201  */ ILegalDocument;
export type PublishLegalDocumentApiArg = {
  publishLegalDocumentDto: PublishLegalDocumentDto;
};
export type CheckApiResponse = /** status 200 The Health Check is successful */ {
  status?: string;
  info?: {
    [key: string]: {
      status: string;
      [key: string]: any;
    };
  } | null;
  error?: {
    [key: string]: {
      status: string;
      [key: string]: any;
    };
  } | null;
  details?: {
    [key: string]: {
      status: string;
      [key: string]: any;
    };
  };
};
export type CheckApiArg = void;
export type IntercomJwtV2Response = {
  userHash: string;
};
export type ConversationAuthor = {
  type: object;
  id: string;
  name: string;
  email: string;
};
export type ConversationSource = {
  type: string;
  id: string;
  delivered_as: string;
  subject: string;
  body: string;
  author: ConversationAuthor;
  attachments: object[];
  url: string;
  redacted: boolean;
};
export type ConversationContacts = {
  type: string;
  id: string;
};
export type ConversationFirstContactReply = {
  created_at: number;
  type: string;
  url: string;
};
export type ConversationStatistics = {
  type: string;
  time_to_assignment: number | null;
  time_to_admin_reply: number | null;
  time_to_first_close: number | null;
  time_to_last_close: number | null;
  median_time_to_reply: number | null;
  first_contact_reply_at: number;
  first_assignment_at: number | null;
  first_admin_reply_at: number | null;
  first_close_at: number | null;
  last_assignment_at: number | null;
  last_assignment_admin_reply_at: number | null;
  last_contact_reply_at: number;
  last_admin_reply_at: number | null;
  last_close_at: number | null;
  last_closed_by_id: number | null;
  count_reopens: number;
  count_assignments: number;
  count_conversation_parts: number;
};
export type ConversationAdmins = {
  type: string;
  id: string;
};
export type ConversationTeammates = {
  type: string;
  admins: ConversationAdmins[];
};
export type ConversationTopics = {
  type: string;
  topics: object[];
  total_count: number;
};
export type Conversation = {
  type: string;
  id: string;
  created_at: number;
  updated_at: number;
  waiting_since: number | null;
  snoozed_until: number | null;
  source: ConversationSource;
  contacts: ConversationContacts;
  first_contact_reply: ConversationFirstContactReply | null;
  admin_assignee_id: number | null;
  team_assignee_id: number | null;
  open: boolean;
  state: string;
  read: boolean;
  messageType: "SUPPORT" | "BROKER" | "TICKET" | "ACTION" | "UPDATE";
  tags: object;
  priority: string;
  sla_applied: object;
  statistics: ConversationStatistics;
  conversation_rating: object;
  teammates: ConversationTeammates;
  title: string;
  custom_attributes: object;
  topics: ConversationTopics;
  conversation_parts: {
    conversation_parts?: object;
  };
};
export type Tag = {
  type: string;
  id: string;
  name: string;
};
export type TagList = {
  type: string;
  data: Tag[];
};
export type ConversationV2Response = {
  source: string;
  created_at: number;
  id: string;
  read: boolean;
  tags: object;
  state: string;
  messageType: "SUPPORT" | "BROKER" | "TICKET" | "ACTION" | "UPDATE";
  body: string;
};
export type ConversationReplyDto = {
  message: string;
  id: string;
};
export type ConversationReplyImageUploadDto = {
  id: string;
};
export type CreateConversationRes = {
  type: string;
  id: string;
  created_at: number;
  body: string;
  message_type: string;
  conversation_id: string;
};
export type IntercomCreateConversationDto = {
  /** The body of the conversation. */
  body?: string;
  to?: string;
  customerId?: string;
};
export type MonoovaMongo = {
  swift?: string;
  routingNumber?: string;
  bsb?: string;
  bankAccountNumber: number;
  bankAccountName: string;
  payId?: string | null;
  currency: string;
  providerClientId: string;
  provider: string;
  createdAt: number;
};
export type UserId = {
  id: string;
};
export type IdentifyUser = {
  name: string;
};
export type SetPreferences = {
  preferences: object;
};
export type TriggerKnockWorkflow = {
  workflowId: string;
  recipients: string[];
  data: object;
};
export type SetChannelData = {
  channel: string;
  userDeviceToken: string;
};
export type SetWorkflowPreferenceDto = {
  workflowId: object;
  enabled: boolean;
};
export type IDataZooVerificationRequest = {
  /** Country Code */
  countryCode?: string;
  /** Service */
  service?: string[];
  /** Client reference */
  clientReference: string;
  /** First name */
  firstName: string;
  /** Middle name */
  middleName?: string;
  /** Last name */
  lastName: string;
  /** Date of birth */
  dateOfBirth: string;
  /** Address element 1 */
  addressElement1?: string;
  /** Address element 3 */
  addressElement3?: string;
  /** Address element 4 */
  addressElement4?: string;
  /** Address element 5 */
  addressElement5?: string;
  identityVariables: {
    socialSecurityNo?: string;
    phoneNo?: string;
    emailAddress?: string;
  };
  /** Consent obtained flag for data sources that require it */
  consentObtained?: object;
};
export type IDataZooVerification = {
  /** Country of residence */
  countryOfResidence: string;
  /** Country code */
  countryCode?: string;
  /** Information */
  information: IDataZooVerificationRequest;
};
export type TaxBitYearEndFairMarketValue = {
  year_end: string;
  fair_market_value: string;
};
export type TaxBitAccountData = {
  year_end_fair_market_value?: TaxBitYearEndFairMarketValue[];
  id: string;
  taxbit_id: string;
  tenant_id: string;
  date_created: string;
  date_modified: string;
  account_owner_id: string;
  filer_id?: string;
  /** @deprecated Use `filer_id`. */
  payer_id?: string;
  account_type?: string;
  establishment_date?: string;
  disposition_method?: string;
  secondary_account_owner_ids?: string[];
  closest_intermediary_account_id?: string;
};
export type TaxBitUpdateAccountDto = {
  /** Disposition method to apply to the account's gain calculations */
  disposition_method: "HIFO" | "FIFO" | "LIFO" | "LOFO";
};
export type TaxBitAsset = {
  uuid: string;
  name: string;
  code: string;
  type: string;
};
export type TaxBitAssetAmount = {
  asset: TaxBitAsset;
  amount: string;
};
export type TaxBitReleasedDocument = {
  id: string;
  type: string;
  year: number;
  url: string;
  revision: number;
  revision_type: string;
  is_filed: boolean;
  created_date: string;
};
export type TaxBitReleasedDocumentsResponse = {
  data: TaxBitReleasedDocument[];
};
export type TaxBitAccountOwnerTokenResponse = {
  access_token: string;
  expires_in?: number;
};
export type TaxBitDocumentationStatusResponse = {
  status: "NOT_STARTED" | "PENDING" | "VALID" | "ACTION_REQUIRED";
  tinStatus?: string;
  documentId?: string;
  needsResubmission?: boolean;
  tinValidationDate?: string;
  lastSyncedAt?: string;
};
export type TaxBitTransaction = {
  asset_amount: TaxBitAssetAmount;
  id: string;
  client_transaction_id?: string;
  type: string;
  datetime: string;
  missing_cost_basis: boolean;
  has_transfer_lot_data: boolean;
  date_created: string;
  date_modified: string;
  cost_basis?: TaxBitAssetAmount;
  proceeds?: TaxBitAssetAmount;
  gain?: TaxBitAssetAmount;
};
export type TaxBitAssetCodeInputDto = {
  /** Asset code e.g. BTC, ETH, USD */
  code: string;
};
export type TaxBitAssetAmountInputDto = {
  /** Decimal amount as string */
  amount: string;
  asset: TaxBitAssetCodeInputDto;
};
export type TaxBitTransactionsResponse = {
  data: TaxBitTransaction[];
  continuation_key?: string;
};
export type TaxBitTransferLot = {
  cost_basis: TaxBitAssetAmount;
  id?: string;
  quantity: string;
  acquisition_datetime: string;
  date_created?: string;
};
export type TaxBitTransferLotsResponse = {
  data: TaxBitTransferLot[];
};
export type TaxBitTransferLotInputDto = {
  /** Quantity of the lot */
  quantity: string;
  /** Cost basis in fiat (e.g. USD) */
  cost_basis: TaxBitAssetAmountInputDto;
  /** ISO-8601 acquisition datetime */
  acquisition_datetime: string;
};
export type TaxBitCreateTransferLotsDto = {
  lots: TaxBitTransferLotInputDto[];
};
export type SignUpStateDisclosureItemDto = {
  /** State (e.g. minnesota, connecticut) */
  state: string;
  /** Whether the disclosure was accepted */
  accepted: boolean;
  /** Client timestamp when accepted (ms) */
  timestamp: number;
  /** Optional disclosure version for re-prompt when terms change */
  disclosureVersion?: string;
};
export type CreateAccountDto = {
  /** The email of the account with which the login will be created. */
  email: string;
  /** User Name of the account with which the login will be created. */
  firstName: string;
  /** User Last Name of the account with which the login will be created. */
  lastName: string;
  /** User selected country. */
  country: string;
  /** User selected state. */
  stateName?: string;
  /** One time use Code */
  oobCode?: string;
  /** Referrer code */
  referrer: string | null;
  /** utm source */
  utm_source: string | null;
  /** utm medium */
  utm_medium: string | null;
  /** utm campaign */
  utm_campaign: string | null;
  /** Google Click Identifier (GCLID) */
  gclid__c: string | null;
  /** The password with which the login will be created */
  password: string;
  /** The phone number of the user requesting a password reset. SMS will be sent here. */
  phone: string;
  /** Cloudflare Turnstile verification token. Required for web requests, optional for iOS platform. */
  turnstileToken?: string;
  /** State disclosure acceptances from sign-up (e.g. CT/MN). Stored on user profile same as dashboard acceptance. */
  stateDisclosures?: SignUpStateDisclosureItemDto[];
};
export type LegacyCreateAccountDto = {
  /** The email of the account with which the login will be created. */
  email: string;
  /** One time use Code */
  oobCode: string;
  /** The password with which the login will be created */
  password: string;
};
export type AccountUsersRes = {
  customerId: string;
  name: string;
  default: boolean;
  selected: boolean;
  isUnverified: boolean;
};
export type CustomerIdDto = {
  /** The customer ID of a customer. */
  customerId: string;
};
export type TransmitSetPasswordRes = {
  message: string;
};
export type ResetPasswordDto = {
  /** The one time use code used for security purposes. */
  oobCode: string;
  /** The new password to set for the user's login. */
  newPassword: string;
};
export type ForgotPasswordRequestDto = {
  /** The email of the user requesting a password reset. Email will be sent here. */
  email: string;
  /** link generated that will redirected to provided url string */
  redirect_url: string;
};
export type SendSmsotpDto = {
  /** The phone number of the user requesting a password reset. SMS will be sent here. */
  phoneNumber: string;
};
export type VerifySmsotpDto = {
  /** The phone number of the user requesting a password reset. SMS will be sent here. */
  phoneNumber: string;
  /** The OTP code sent to the user's phone number. */
  otp: string;
};
export type LockAccountDto = {
  /** The reason for locking the account. */
  lockReason: string;
  /** The type of lock to apply to the account. */
  lockType: string;
};
export type CreatePendingAccountDto = {
  /** The email of the account with which the login will be created. */
  email: string;
  /** User Name of the account with which the login will be created. */
  firstName: string;
  /** User Last Name of the account with which the login will be created. */
  lastName: string;
  /** User selected country. */
  country: string;
  /** User selected state. */
  stateName?: string;
  /** One time use Code */
  oobCode?: string;
  /** Referrer code */
  referrer: string | null;
  /** utm source */
  utm_source: string | null;
  /** utm medium */
  utm_medium: string | null;
  /** utm campaign */
  utm_campaign: string | null;
  /** Google Click Identifier (GCLID) */
  gclid__c: string | null;
  /** State disclosure acceptances from sign-up (e.g. CT/MN). Stored on user profile same as dashboard acceptance. */
  stateDisclosures?: SignUpStateDisclosureItemDto[];
  /** Unique key for the pending account to allow for security practices */
  uniqueKey: string;
};
export type SubmitPendingAccountPhoneNumberDto = {
  /** The phone number of the user going through the sign up flow. */
  phoneNumber: string;
  /** The unique key of the pending account */
  uniqueKey: string;
  /** The email of the user going through the sign up flow. */
  email: string;
  /** Cloudflare Turnstile verification token. Required for web requests, optional for iOS platform. */
  turnstileToken?: string;
};
export type VerifyPendingAccountPhoneNumberDto = {
  /** The phone number of the user going through the sign up flow. */
  phoneNumber: string;
  /** The unique key of the pending account */
  uniqueKey: string;
  /** The email of the user going through the sign up flow. */
  email: string;
  /** Cloudflare Turnstile verification token. Required for web requests, optional for iOS platform. */
  turnstileToken?: string;
  /** The password with which the login will be created */
  password: string;
  /** The OTP code sent to the user's phone number. */
  otp: string;
};
export type ContactChangeRes = {
  status:
    | "PENDING_MFA"
    | "PENDING_ONFIDO"
    | "ONFIDO_SUBMITTED"
    | "PROCESSING"
    | "COMPLETED"
    | "FROZEN"
    | "MANUAL_REVIEW"
    | "EXPIRED"
    | "CANCELLED";
  type: "EMAIL" | "PHONE" | "ADDRESS";
  accountEmail?: string;
  originalValue?: string;
  requestedValue?: string;
};
export type CreateContactChangeRes = {
  type: "EMAIL" | "PHONE" | "ADDRESS";
  status?:
    | "PENDING_MFA"
    | "PENDING_ONFIDO"
    | "ONFIDO_SUBMITTED"
    | "PROCESSING"
    | "COMPLETED"
    | "FROZEN"
    | "MANUAL_REVIEW"
    | "EXPIRED"
    | "CANCELLED";
};
export type CreateContactChangeReqDto = {
  /** The contact change type, e.g. EMAIL, PHONE */
  type: "EMAIL" | "PHONE" | "ADDRESS";
};
export type PasswordDto = {
  /** The password */
  password: string;
};
export type MfaCodeDto = {
  /** The authentication code */
  code: string;
};
export type ProcessRequestedValuesReqDto = {
  /** The requested value change change */
  requestedValue: string;
};
export type LoginResponseDto = {
  redirect_url: string;
};
export type LoginDto = {
  /** The email of the login. */
  email: string;
  /** The redirect url after successful login */
  redirect_url: string;
  /** The password of the login. */
  password: string;
  /** The client of the login. */
  client?: string;
  /** Multi Factor Authentication Code (if enabled). */
  mfa?: string;
};
export type TokenResponse = {
  access_token: string;
  id_token: string;
  refresh_token: string;
  is_user_created?: boolean;
};
export type SessionRes = {
  email: string;
  tokens: TokenResponse;
  features: string[];
  permission: string[];
};
export type LoginDtoV2 = {
  /** The email of the login. */
  email: string;
  /** The password of the login. */
  password: string;
  /** The client of the login. */
  client?: string;
  /** Multi Factor Authentication Code (if enabled). */
  mfa?: string;
};
export type LoginAdminDto = {
  /** The client of the login. */
  client: string;
  /** Google OAuth2 code */
  code: string;
  /** Multi Factor Authentication Code (if enabled). */
  mfaCode: string;
};
export type LoginNativeResponseDto = {
  permission: string[];
  access_token: string;
  expires_in: number;
  id_token: string;
  refresh_token: string;
  token_type: string;
  session_id: string;
  features: string[];
};
export type RefreshSessionResDto = {
  /** The access token associated to the users current session. Used to verify the session. */
  accessToken: string;
  /** The refresh token associated to the users current session. Used to refresh the session, allowing the user to stay logged in. */
  refreshToken: string;
  /** The id token associated to the users current session. Used to get users information, allowing the determine which user this token belong to */
  idToken: string;
  /** The expires_in attribute indicates how long this new token will valid for, in minutes. */
  expiresIn: string;
  permission?: string[];
};
export type RefreshSessionDto = {
  /** The access token associated to the users current session. Used to verify the session. */
  accessToken?: string;
  /** The refresh token associated to the users current session. Used to refresh the session, allowing the user to stay logged in. */
  refreshToken: string;
  /** The id token associated to the users current session. Used to get users information, allowing the determine which user this token belong to */
  idToken?: string;
  /** The client of the login. */
  client?: string;
};
export type TokenExchangeDto = {
  /** Exchange code used for retrieving accessToken */
  code?: string;
  /** user's email */
  email?: string;
  /** two fa code from user */
  twoFA?: string;
  /** The Client ID of the application */
  client?: string;
};
export type ActionTokenRespDto = {
  /** User's risk score - higher the number the more risk the user is. */
  riskScore: number;
  /** Recommended way to handle the reported action */
  recommendation: object;
  /** Explains the reasons for the recommendation */
  reasons: string[];
  /** User's transmit ID */
  transmitID: string;
};
export type ActionTokenReqDto = {
  /** Action token used to get user's challenge score */
  actionToken?: string;
  /** id token used to get user's challenge score */
  idToken?: string;
};
export type TransactionDataDto = {
  amount?: number;
  currency?: string;
  reason?: string;
  transactionId?: string;
};
export type TransactionRiskReqDto = {
  /** Action token from Transmit SDK */
  actionToken?: string;
  /** ID token of the authenticated user */
  idToken?: string;
  /** Transmit action type (e.g. transaction, withdraw, register) */
  actionType?: string;
  /** Transaction context data */
  transactionData?: TransactionDataDto;
};
export type LoginRecordDto = {
  /** Error message from risk recommendation */
  errorReason: string;
  /** Error stack trace or additional error details */
  errorStack?: object;
  /** timestamp */
  timestamp: number;
};
export type RiskFailureRecordDto = {
  /** Transmit action type that failed */
  actionType: string;
  /** Error message from the failed risk check */
  errorReason: string;
  /** Error stack or additional details */
  errorStack?: object;
  /** Email of the user at time of failure */
  email?: string;
};
export type MagicLinkDto = {
  /** User's email */
  email: string;
  /** redirect url */
  redirectUrl: string;
};
export type ChangePasswordDto = {
  /** User's current password */
  currPassword: string;
  /** User's new password */
  newPassword: string;
  /** User's new password */
  confirmPassword: string;
};
export type WebAuthnDevice = {
  /** ID of the device */
  id: string;
  /** name of the device */
  displayName: string;
  /** status of the credential */
  status: string;
  /** Operating system type */
  os_type: string;
  /** Operating system version */
  os_version: string;
  /** Browser name */
  browser: string;
  /** User agent */
  user_agent: string;
  /** Timestamp of the first seen */
  first_seen: string;
  /** Timestamp of the last seen */
  last_seen: string;
};
export type WebAuthnCredentialsRes = {
  /** List of devices associated with the credential */
  devices: WebAuthnDevice[];
  /** Number of devices associated with the credential */
  numberOfCredentials: number;
};
export type WebAuthnCredentialsDto = {
  /** encoded string to register the device */
  encodedString: string;
};
export type UpdateWebAuthnCredentialsDto = {
  /** id of the passkey to change */
  credentialId: string;
  /** display name of the passkey */
  displayName?: string;
};
export type WebAuthnDeleteCredentialsDto = {
  /** credential id to delete the device */
  credentialId: string;
};
export type SmsRes = {
  status: string;
  phone: string;
};
export type VerifySms2FaResponseDto = {
  status: string;
};
export type TwoFactorDto = {
  /** The 2FA code used for verifying the request. */
  code: string;
};
export type Create2FaResponseDto = {
  uri: string;
  secret: string;
};
export type Verify2FaResponseDto = {
  factorStatus: string;
};
export type TwoFaEmailVerificationDto = {
  /** The type of emial template used for the 2FA verification request */
  emailTemplate: "bankDetails2FA" | "withdrawal" | "brokerWithdrawalNotify";
};
export type TwoFaVerificationDto = {
  /** The email code */
  emailCode: string;
  /** The 2FA Authenticator code */
  twoFaCode?: string;
};
export type ContactUsFormReqDto = {
  /** Form details sent by the user */
  FirstName: string;
  LastName: string;
  Phone: string;
  Email?: string;
  Message__c: string;
  Preferred_Name__c?: string;
  LeadSource: string;
  Country: string;
  Referred_By__c: string;
  utm_source__c: string;
  utm_medium__c: string;
  utm_campaign__c: string;
  gclid__c: string;
  Social_Media_Link__c?: string;
};
export type CreateApplicantResponse = {
  token: string;
  applicant_id: string;
  expiryTime?: string;
  workflowRunId?: string;
};
export type CreateOngoingMonitoringDto = {
  /** The applicant id generated when creating the applicant */
  applicant_id: string;
};
export type UpdateKycStepsDto = {
  /** Update Kyc Steps */
  newApplicationForm?: boolean;
  biometrics: boolean;
  workflowRunId?: string;
};
export type GetUserDetailsResponse = {
  firstname: string;
  lastname: string;
  dob: string;
  country: string;
  email: string;
  kycStatus?: string;
  id?: string;
};
export type AmlReturnType = {
  isPoliticallyExposed: boolean;
  isSanction: boolean;
  isLegalAndRegulatoryWarnings: boolean;
  isAdverseMedia: boolean;
};
export type BaseNestedObject = {
  id: string;
  status: string;
  completed_at_iso8601: string;
  href: string;
};
export type NestedPayload = {
  resource_type: string;
  action: string;
  object: BaseNestedObject;
};
export type OnfidoPayload = {
  payload: NestedPayload;
};
export type MatchedStrings = {
  length: number;
  offset: number;
};
export type StructuredFormatting = {
  main_text: string;
  main_text_matched_substrings: MatchedStrings[];
  secondary_text: string;
};
export type Terms = {
  offset: number;
  value: string;
};
export type Prediction = {
  description: string;
  matched_substrings: MatchedStrings[];
  place_id: string;
  reference: string;
  structured_formatting: StructuredFormatting;
  terms: Terms[];
  types: string[];
};
export type Predictions = {
  predictions: Prediction[];
  status: string;
};
export type AutocompletePrediction = {
  description: string;
  id: string;
  place_id: string;
  predictions: Predictions[];
};
export type GetPlaceDetailsDto = {
  /** Receives place_id, returns place details */
  placeid: string;
};
export type ObjectId = {};
export type Address = {
  city: string;
  street: string;
  country: string;
  state: string;
  zipCode: string;
};
export type EntityDetails = {
  name: string;
  recordType: "Other" | "Trust" | "SMSF";
  companyType?:
    | "Limited Liability Company (LLC)"
    | "Proprietary Limited Company (Pty Ltd)"
    | "Corporation"
    | "Partnership"
    | "Other";
  natureOfBusiness: string;
  otherCompanyType: string;
  id: string;
  address: Address;
  opportunityRecordTypeId?: string;
  accountRecordTypeId?: string;
};
export type SalesforceAccountPayload = {
  email: string;
  firstName: string;
  portalId: string;
  lastName: string;
  phone: string;
  dob: string;
  defaultCurrency:
    | "Australian Dollar (AUD)"
    | "British Pound (GBP)"
    | "Canadian Dollar (CAD)"
    | "Euro (EUR)"
    | "New Zealand Dollar (NZD)"
    | "US Dollar (USD)";
  hearAboutUs:
    | "Referral Partner / Affiliate"
    | "Online - web search"
    | "Online - social media"
    | "Friend / family"
    | "Colleague"
    | "Advertisement"
    | "News Article"
    | "Email"
    | "Event"
    | "Other";
  initialInvestment:
    | "$0-$10K"
    | "$500-$10K"
    | "$10K-$50K"
    | "$50K-$100K"
    | "$100K-$500K"
    | "$500K-$1M"
    | "$1M+"
    | "Prefer not to answer";
  investmentExp: "Beginner (0-1 year)" | "Intermediate (2-3 years)" | "Expert (4+ years)";
  occupation: string;
  industry: string;
  tandc: boolean;
  nationality?: string;
  type: "Individual" | "Entity";
  wealthSource: (
    | "Income"
    | "Savings"
    | "Pension"
    | "Property Income"
    | "Benefits"
    | "Borrowing"
    | "Family Support"
    | "Investments"
    | "Inheritance"
    | "Employment"
    | "Fiat Investments"
    | "Crypto Investments"
    | "Private Pension"
    | "Others"
  )[];
  investmentFrequency:
    | "Daily"
    | "Fortnightly"
    | "Monthly"
    | "Quarterly"
    | "Biannually"
    | "Annually";
  address: Address;
  referralCode?: string;
  ssn?: string;
  ignoreBiometrics?: boolean;
  otherWealthSource?: string;
  preferredName?: string;
  filesSize?: number;
  documents?: string[];
  subsidiary?: string;
  accountPurpose?: (
    | "Short Term Trading"
    | "Long Term Trading"
    | "Custody of Assets"
    | "Purchase Only"
    | "Sell Only"
  )[];
  entityDetails?: EntityDetails;
};
export type ISalesforceAccount = {
  _id?: ObjectId;
  timestamp?: number;
  success?: boolean;
  payload: SalesforceAccountPayload;
};
export type SalesforceAccountList = {
  data: ISalesforceAccount[];
  totalPages?: number;
};
export type CreateSfAccountReturnType = {
  "Person Account Record ID": string;
  "Opportunity ID": string;
};
export type AccountType = "Individual" | "Entity";
export type DefaultCurrencyPickListOptions =
  | "Australian Dollar (AUD)"
  | "British Pound (GBP)"
  | "Canadian Dollar (CAD)"
  | "Euro (EUR)"
  | "New Zealand Dollar (NZD)"
  | "US Dollar (USD)";
export type InvestmentExperienceLevel =
  | "Beginner (0-1 year)"
  | "Intermediate (2-3 years)"
  | "Expert (4+ years)";
export type InvestmentAmmountPickListOption =
  | "$0-$10K"
  | "$500-$10K"
  | "$10K-$50K"
  | "$50K-$100K"
  | "$100K-$500K"
  | "$500K-$1M"
  | "$1M+"
  | "Prefer not to answer";
export type HeardAboutUsOptions =
  | "Referral Partner / Affiliate"
  | "Online - web search"
  | "Online - social media"
  | "Friend / family"
  | "Colleague"
  | "Advertisement"
  | "News Article"
  | "Email"
  | "Event"
  | "Other";
export type InvestmentFrequency =
  | "Daily"
  | "Fortnightly"
  | "Monthly"
  | "Quarterly"
  | "Biannually"
  | "Annually";
export type EntityDetailsDto = {
  /** Name of entity */
  name: string;
  /** Type of opportunity record type */
  recordType: "Other" | "Trust" | "SMSF";
  /** Type of company record type */
  companyType?:
    | ""
    | "Limited Liability Company (LLC)"
    | "Proprietary Limited Company (Pty Ltd)"
    | "Corporation"
    | "Partnership"
    | "Other";
  /** The nature of the business */
  natureOfBusiness: string;
  /** Other known names for the entity */
  otherCompanyType: string;
  /** The id of the entity */
  id: string;
  /** The address of the entity */
  address: Address;
  /** Salesforce Opportunity Record Type ID. */
  opportunityRecordTypeId?: string;
  /** Salesforce Account Record Type ID */
  accountRecordTypeId?: string;
};
export type CreateSfAccountPayloadDto = {
  /** Type of user */
  type: AccountType;
  /** Nationality of user */
  nationality?: string;
  /** Default Currency of the user account */
  defaultCurrency: DefaultCurrencyPickListOptions;
  /** Wealth Source of the user account */
  wealthSource: (
    | "Income"
    | "Savings"
    | "Pension"
    | "Property Income"
    | "Benefits"
    | "Borrowing"
    | "Family Support"
    | "Investments"
    | "Inheritance"
    | "Employment"
    | "Fiat Investments"
    | "Crypto Investments"
    | "Private Pension"
    | "Others"
  )[];
  /** Phone number of user */
  phone: string;
  /** Date of Birth of user */
  dob: string;
  /** Terms and Conditions agreement status */
  tandc: boolean;
  /** Investment Experience Level */
  investmentExp: InvestmentExperienceLevel;
  /** Initial Investment range */
  initialInvestment: InvestmentAmmountPickListOption;
  /** Existing Crypto Holdings range */
  existingCryptoHoldings: InvestmentAmmountPickListOption;
  /** Account Purpose of the user account */
  accountPurpose?: (
    | "Short Term Trading"
    | "Long Term Trading"
    | "Custody of Assets"
    | "Purchase Only"
    | "Sell Only"
  )[];
  /** How they heard about us */
  hearAboutUs: HeardAboutUsOptions;
  /** Occupation of user */
  occupation: string;
  /** Industry of user */
  industry: string;
  /** Other source of wealth of user */
  otherWealthSource?: string;
  /** Referral code of user */
  referralCode?: string;
  /** Investment frequency of user */
  investmentFrequency: InvestmentFrequency;
  /** Social Security Numer of user */
  ssn?: string;
  /** User preferred name */
  preferredName?: string;
  /** User is not required to complete biometrics */
  ignoreBiometrics?: boolean;
  /** Address of user */
  address: Address;
  /** List of contentVersionId */
  documents?: string[];
  /** Details of the entity if it is a non-individual form */
  entityDetails?: EntityDetailsDto;
  /** User has accepted the DVS disclosure */
  isDvsDisclosureAccepted?: boolean;
};
export type DataZooQueuePayload = {
  /** User date of birth */
  dateOfBirth: string;
  /** The address of the entity */
  address: Address;
  /** User phone number */
  phoneNumber: string;
  /** User social security number */
  ssn?: string;
  /** User middle name */
  middleName?: string;
};
export type ReKycSfOpportunityPayloadDto = {
  /** Nationality of user */
  nationality?: string;
  /** Wealth Source of the user account */
  wealthSource: (
    | "Income"
    | "Savings"
    | "Pension"
    | "Property Income"
    | "Benefits"
    | "Borrowing"
    | "Family Support"
    | "Investments"
    | "Inheritance"
    | "Employment"
    | "Fiat Investments"
    | "Crypto Investments"
    | "Private Pension"
    | "Others"
  )[];
  /** Occupation of user */
  occupation: string;
  /** Social Security Numer of user */
  ssn?: string;
  /** List of contentVersionId */
  documents?: string[];
  type: string;
  firstName: string;
  lastName: string;
  /** Address of user */
  aboutYouAddress: Address;
  /** Address of company */
  entityAddress1: Address;
  /** Address of registered company */
  entityAddress2: Address;
  entityId: string;
  accountId?: string;
};
export type FileUploadResponseType = {
  id: string;
  success: boolean;
  errors: object[];
};
export type FormData = {};
export type EncodeMessageDto = {
  reason?:
    | "Application Form"
    | "Contact Change"
    | "Secure Biometrics"
    | "Re KYC"
    | "2FA Reset"
    | "Receipt Upload"
    | "Onboarding"
    | "Proof of Address";
  createdTime: string;
  recordId: string;
  email?: string;
};
export type DecodeMessageDto = {
  message: string;
};
export type SecureFileUploadDto = {
  /** Code to be validated */
  code: string;
  /** Documents uploaded */
  documents: string[];
  /** Additional Comments */
  comments?: string;
};
export type WorkflowLinkDto = {
  /** The URL to redirect to if the link has expired */
  expired_redirect_url: string | null;
  /** The URL of the link */
  url: string;
  /** The expiration date of the link */
  expires_at: string | null;
  /** The URL to redirect to upon completion */
  completed_redirect_url: string | null;
  /** The language of the link */
  language: string | null;
};
export type OnfidoWorkflowResourceDto = {
  /** The status of the task */
  status: string;
  /** The workflow identifier */
  workflow_id: string;
  /** The creation date of the task */
  created_at: string;
  /** The output of the task */
  output: object;
  /** The tags associated with the task */
  tags: object[];
  /** The update date of the task */
  updated_at: string;
  /** The reasons for the task status */
  reasons: object[];
  /** The error associated with the task */
  error: object;
  /** The dashboard URL for the task */
  dashboard_url: string;
  /** The unique identifier of the task */
  id: string;
  /** The version ID of the workflow */
  workflow_version_id: number;
  /** The applicant identifier */
  applicant_id: string;
  /** The link information associated with the task */
  link: WorkflowLinkDto;
  /** The SDK token associated with the task */
  sdk_token: object;
};
export type DashboardData = {
  resource_type: string;
  action: string;
  object: BaseNestedObject;
  resource: OnfidoWorkflowResourceDto;
};
export type OnfidoWorkflowPayload = {
  payload: DashboardData;
};
export type TimelineFileObject = {
  id: string;
  workflow_run_id: string;
  completed_at_iso8601: string;
  href: string;
};
export type TimelineFileResource = {
  timeline_file_download_url: string;
};
export type TimelineFilePayload = {
  resource_type: string;
  action: string;
  object: TimelineFileObject;
  resource: TimelineFileResource;
};
export type OnfidoTimelineFileWebhook = {
  payload: TimelineFilePayload;
};
export type EventCategoryDto = {
  category: string;
};
export type SendGridWebhookDto = {
  email: string;
  timestamp: number;
  smtpId: string;
  event:
    | "processed"
    | "deferred"
    | "delivered"
    | "open"
    | "click"
    | "bounce"
    | "dropped"
    | "spamreport"
    | "unsubscribe"
    | "group_unsubscribe"
    | "group_resubscribe";
  category: EventCategoryDto[];
  sgEventId: string;
  sgMessageId: string;
  response?: string;
  attempt?: string;
  useragent?: string;
  ip?: string;
  url?: string;
  asmGroupId?: number;
  reason?: string;
  status?: string;
};
export type SendgridContactToListDto = {
  /** User features array */
  listNames: ("marketing" | "fund" | "brokerage")[];
  email: string;
};
export type Document = {
  id: string;
  type?: string;
};
export type OutputProperties = {
  date_of_birth: string;
  date_of_expiry: string;
  document_number: string;
  document_numbers: Document[];
  document_type: string;
  first_name: string;
  issuing_country: string;
  last_name: string;
};
export type ReceiptUploadLink = {
  link: string;
};
export type DvsDisclosurePayloadDto = {
  isDvsDisclosureAccepted: boolean;
};
export type OnfidoBiometricsConsentPayloadDto = {
  isBiometricsConsentAccepted: boolean;
  isOnfidoTermsAccepted: boolean;
};
export type NotifyBrokerCallDto = {
  confirmation: boolean;
};
export type UpdateSsnEinDto = {
  ssn?: string;
  ein?: string;
};
export type CreateAccessTokenResponse = {
  token: string;
  userId: string;
};
export type ICreateSumsubApplicantDto = {
  /** One of the available flows in https://cockpit.sumsub.com/checkus#/sdkIntegrations/levels */
  levelName: "Initial Welcome Screen" | "Initial Welcome Screen - Individual";
};
export type ApplicantStatusResponseDto = {
  /** Moderation Comment */
  moderationComment?: string;
  /** Client Comment */
  clientComment?: string;
  /** company or individual */
  type?: string;
  /** Review status from Sumsub */
  reviewStatus: "init" | "pending" | "prechecked" | "onHold" | "completed";
  /** Review answer from Sumsub */
  reviewAnswer: "GREEN" | "RED" | "GRAY";
};
export type GenerateUkAssessmentLinkResponseDto = {
  /** Tokenized public assessment link */
  link: string;
};
export type GenerateUkAssessmentLinkDto = {
  /** Email of the existing client to send the assessment link to */
  email: string;
};
export type ValidateUkAssessmentTokenResponseDto = {
  /** Whether the token is valid and unexpired */
  valid: boolean;
  /** Human-readable validity or error message */
  message?: string;
  /** First name of the client the link was issued for */
  firstName?: string;
};
export type ValidateUkAssessmentTokenDto = {
  /** The encoded token from the assessment link */
  code: string;
};
export type AssessmentQuestionOptionDto = {
  /** Option identifier */
  id: string;
  /** Option text to display */
  text: string;
};
export type AssessmentQuestionDto = {
  /** Unique question identifier */
  id: string;
  /** Question text */
  questionText: string;
  /** Question type */
  type: "EXPERIENCE" | "PROFESSIONAL" | "KNOWLEDGE";
  /** Available answer options */
  options: AssessmentQuestionOptionDto[];
  /** Whether this is a knockout question (internal use only) */
  isKnockout?: boolean;
};
export type GetAssessmentQuestionsResponseDto = {
  /** Whether questions were retrieved successfully */
  success: boolean;
  /** List of assessment questions */
  questions: AssessmentQuestionDto[];
  /** Current attempt number (1-3) */
  attemptNumber: number;
  /** Message if user is locked out */
  message?: string;
  /** Whether the user is currently locked out */
  isLockedOut?: boolean;
  /** Timestamp when lockout ends */
  lockoutEndsAt?: number;
  /** Whether the result is flagged for manual review (score 80-94). Advisory only — it does not block the client's journey. */
  manualReview?: boolean;
};
export type SubmitAssessmentResponseDto = {
  /** Whether the assessment was submitted successfully */
  success: boolean;
  /** Whether the user passed the assessment */
  passed: boolean;
  /** Whether the user passed but with a warning (score 95-124). When true, the frontend should show a warning pop-up before proceeding. */
  passedWithWarning?: boolean;
  /** Whether the result landed in the manual-review band (score 80-94, no knockout). Advisory — support reviews the borderline score while the client continues the journey. */
  manualReviewRequired?: boolean;
  /** Score achieved (number of correct answers) */
  score: number;
  /** Total number of questions */
  totalQuestions: number;
  /** Current attempt number */
  attemptNumber: number;
  /** Number of remaining attempts */
  remainingAttempts: number;
  /** Whether the user failed due to a knockout question */
  knockoutFailed?: boolean;
  /** Message to display to the user */
  message?: string;
  /** Whether a 24-hour wait is required before next attempt */
  waitRequired?: boolean;
  /** Timestamp when next attempt is available */
  nextAttemptAvailableAt?: number;
  /** Whether the user is permanently locked out (6-month lockout) */
  permanentLockout?: boolean;
  /** Timestamp when lockout ends */
  lockoutEndsAt?: number;
};
export type AssessmentAnswerDto = {
  /** Question identifier */
  questionId: string;
  /** Selected answer option identifier */
  selectedOptionId: string;
};
export type SubmitPublicUkAssessmentDto = {
  /** Array of answers to assessment questions */
  answers: AssessmentAnswerDto[];
  /** The encoded token from the assessment link */
  code: string;
  /** Investor classification selected before the assessment */
  investorType: "RESTRICTED" | "HIGH_NET_WORTH" | "NEITHER";
  /** Whether the investor statement declaration was agreed to */
  statementAgreed: boolean;
};
export type UkOnboardingCheckpointsDto = {
  /** Individual vs Entity has been selected */
  accountTypeSelected: boolean;
  /** Risk warning viewed, investor type selected and statement agreed */
  classificationDone: boolean;
  /** Appropriateness assessment passed */
  assessmentDone: boolean;
  /** Identity verification completed */
  idVerificationDone: boolean;
  /** Application form completed */
  applicationFormDone: boolean;
};
export type GetUkOnboardingStatusResponseDto = {
  /** Whether UK onboarding has started */
  hasStarted: boolean;
  /** Whether risk summary has been viewed */
  riskSummaryViewed: boolean;
  /** Selected investor type */
  investorType?: ("RESTRICTED" | "HIGH_NET_WORTH" | "NEITHER") | null;
  /** Whether investor statement has been agreed */
  statementAgreed: boolean;
  /** Whether assessment has been passed */
  assessmentPassed: boolean;
  /** Whether the assessment result is flagged for manual review (score 80-94). Advisory only — the client continues the journey. */
  assessmentManualReview?: boolean;
  /** Number of assessment attempts made */
  assessmentAttempts: number;
  /** Whether cooling-off period has completed */
  coolingOffComplete: boolean;
  /** Timestamp when cooling-off ends */
  coolingOffEndsAt?: number;
  /** Final confirmation status */
  finalConfirmation?: ("CONFIRMED" | "DECLINED") | null;
  /** Current step in the UK onboarding flow */
  currentStep: string;
  /** Account type selected at the start of the journey */
  selectedAccountType?: ("INDIVIDUAL" | "ENTITY") | null;
  /** Completed checkpoints of the onboarding journey */
  checkpoints: UkOnboardingCheckpointsDto;
  /** Whether saved progress expired (10 days after the first step) and was reset on this fetch */
  progressExpired?: boolean;
};
export type MarkRiskSummaryViewedResponseDto = {
  /** Whether the action was successful */
  success: boolean;
};
export type SubmitUkAccountTypeResponseDto = {
  /** Whether the selection was saved */
  success: boolean;
};
export type SubmitUkAccountTypeDto = {
  /** The account type the user is onboarding. Entity onboarding is not available for UK clients — only INDIVIDUAL is accepted. */
  accountType: "INDIVIDUAL" | "ENTITY";
};
export type RestartUkOnboardingResponseDto = {
  /** Whether the journey was restarted */
  success: boolean;
  /** Message to display to the user */
  message?: string;
};
export type InvestorTypeResponseDto = {
  /** Whether the selection was successful */
  success: boolean;
  /** The selected investor type */
  investorType: "RESTRICTED" | "HIGH_NET_WORTH" | "NEITHER";
  /** Whether the user can proceed with onboarding */
  canProceed: boolean;
  /** Message to display to the user */
  message?: string;
};
export type SubmitInvestorTypeDto = {
  /** The investor type selected by the user */
  investorType: "RESTRICTED" | "HIGH_NET_WORTH" | "NEITHER";
};
export type RestrictedInvestorStatementResponseDto = {
  /** Whether the statement was accepted */
  success: boolean;
  /** Message to display to the user */
  message?: string;
};
export type SubmitRestrictedInvestorStatementDto = {
  /** Whether the user agrees to the restricted investor declaration */
  declarationAgreed: boolean;
};
export type HnwInvestorStatementResponseDto = {
  /** Whether the statement was accepted */
  success: boolean;
  /** Message to display to the user */
  message?: string;
};
export type SubmitHnwInvestorStatementDto = {
  /** Whether the user agrees to the high net worth investor declaration */
  declarationAgreed: boolean;
};
export type SubmitAssessmentDto = {
  /** Array of answers to assessment questions */
  answers: AssessmentAnswerDto[];
};
export type GetAssessmentStatusResponseDto = {
  /** Number of attempts made */
  attemptCount: number;
  /** Whether the user has passed the assessment */
  passed: boolean;
  /** Whether the user is currently locked out */
  isLockedOut: boolean;
  /** Timestamp when lockout ends */
  lockoutEndsAt?: number;
  /** Number of remaining attempts */
  remainingAttempts: number;
  /** Whether a 24-hour wait is required before next attempt */
  waitRequired?: boolean;
  /** Timestamp when next attempt is available */
  nextAttemptAvailableAt?: number;
  /** Whether the result is flagged for manual review (score 80-94). Advisory only — it does not block the client's journey. */
  manualReview?: boolean;
};
export type GetCoolingOffStatusResponseDto = {
  /** Whether the cooling-off period has started */
  hasStarted: boolean;
  /** Whether the cooling-off period has completed */
  hasCompleted: boolean;
  /** Timestamp when cooling-off started */
  startedAt?: number;
  /** Timestamp when cooling-off ends */
  endsAt?: number;
  /** Remaining time in milliseconds */
  remainingTimeMs?: number;
  /** Whether the user can confirm their account */
  canConfirm: boolean;
};
export type ConfirmAccountResponseDto = {
  /** Whether the confirmation was successful */
  success: boolean;
  /** Whether the account is now active */
  accountActive: boolean;
  /** Message to display to the user */
  message?: string;
};
export type DeclineAccountResponseDto = {
  /** Whether the decline was processed successfully */
  success: boolean;
  /** Whether the account has been closed */
  accountClosed: boolean;
  /** Message to display to the user */
  message?: string;
};
export type PublicAnnouncement = {
  type: "info" | "maintenance" | "news";
  title: string;
  content: string;
  from: string;
  to: string;
};
export type AttributedAnnouncement = {
  author: string;
  type: "info" | "maintenance" | "news";
  title: string;
  content: string;
  from: string;
  to: string;
  createdAt: string;
  updatedAt: string;
};
export type UpdateAnnouncementDto = {
  type?: "info" | "maintenance" | "news";
  title?: string;
  content?: string;
  from?: string;
  to?: string;
};
export type LinkMetrics = {
  date: string;
  clicked: number;
  clickedPerUser: number;
  usersClicked: number;
};
export type Group = {
  group_id: string;
  name: string;
  description: string;
  created_at: number;
  updated_at: number;
  custom_data: {
    addedBy?: string;
  };
};
export type AddPermission = {
  groupName: string;
  userIds: string[];
};
export type RemovePermission = {
  groupName: string;
  userId: string;
};
export type EditPermissionsDto = {
  groupIds: string[];
  userIds: string[];
};
export type MongoUser = {
  acceptTerms: boolean;
  acceptTermsTime: number;
  is2FAEnabled: boolean;
  isPassKeyEnabled?: boolean;
  phone: string;
  employee: boolean;
  smsVerified: boolean;
  smsCreateTime: number;
  lastLoginTime: number;
  loginCount: number;
  sessionActive: boolean;
  lastLoggedInAt: number;
  automatedTradesDisabled: boolean | null;
  features?: string[];
  suspended: boolean;
};
export type User = {
  id: string;
  dob: string;
  name: string;
  phone: string;
  isLocked: boolean;
  customerId: string;
  creditLimit: string;
  dateCreated: number;
  isBypassLock: boolean;
  address: string;
  riskAssessment: string;
  broker: {
    phoneAU?: string;
    phoneUS?: string;
    name?: string;
    email?: string;
  };
  defaultCurrency: string;
};
export type TransmitUser = {
  user_id: string;
  created_at: number;
  updated_at: number;
  last_auth: string;
  status: string;
  email: {
    value?: string;
    email_verified?: boolean;
    verified_at?: string;
  };
  groupIds: string[];
  app_id: string;
  external_account_id?: string;
  custom_app_data: {
    cookieExpiry?: string | null;
    testEnabled?: boolean;
    permissions?: {
      accountManagement?: boolean;
      analytics?: boolean;
      announcements?: boolean;
    };
    originalCreationDate?: string;
    providerUserInfo?: object[];
  };
  username?: string;
  password_information: {
    updated_at?: number;
    expired?: boolean;
    temporary?: boolean;
  };
  app_name: string;
};
export type GetByEmailDto = {
  account: MongoUser;
  users: User[];
  transmit: TransmitUser;
};
export type IdName = {
  id: string;
  name: string;
  sumsubExternalId?: string;
};
export type IReKycDetails = {
  reKyc: boolean;
  kycExpiryDate: string;
  accountId: string;
  recordType: string;
  edd: boolean;
  formSubmitted?: boolean;
  onfidoCheck?: boolean;
  reKycCount?: number;
  lastReKycTimestamp?: number;
};
export type ISalesforceDetails = {
  accountId: string;
  recordType: string;
  ssnRequired?: boolean;
  submitted?: boolean;
  einRequired?: boolean;
};
export type IAddress = {
  fullAddress: string;
  streetAddress?: string;
  city?: string;
  state?: string;
  zip?: string;
  country: string;
};
export type IAuthorisedUser = {
  id: string;
  firstName: string;
  lastName?: string;
  email: string;
};
export type IUserHolding = {
  currencyConfig: string;
  available: number;
  reserved: number;
  openTargets: number;
  total: number;
  pendingPortal?: number;
};
export type INotification = {
  id: number;
  date: number;
  type: string;
  subType: string;
  message: string;
  read: boolean;
};
export type INotificationPreferences = {
  channel: "IOS" | "ANDROID" | "EMAIL" | "SMS";
  enabled: boolean;
};
export type ICryptoAddress = {
  id: string;
  address: string;
  memo?: string;
  currencyConfig: string[];
  format: IdName;
  status: IdName;
  testAmount?: number;
  lastUpdated?: number;
  nickname?: string;
  isFirstParty?: boolean | null;
  thirdPartyRecipientName?: string;
  destinationType?: object;
  destinationVasp?: string;
  destinationVaspName?: string;
  walletVerificationReference?: string;
  travelRuleStatus?: object;
};
export type IReferralLinkAnalytics = {
  directLink?: number;
  email?: number;
  twitter?: number;
  facebook?: number;
  whatsapp?: number;
};
export type IReferralReward = {
  currencyConfig: string;
  amount: number;
};
export type IFiatTransactionAccount = {
  provider: string;
  bsb?: string;
  swift?: string;
  routingNumber?: string;
  bankAccountNumber: object;
  bankAccountName: string;
  payId?: string;
  currency: string;
  providerClientId: string;
  createdAt: number;
  bankName?: string;
  accountType?: string;
  accountHolderAddress?: object;
  bankAddress?: object;
};
export type IVerificationCode = {
  code: string;
  timestamp?: number;
};
export type PaymentIntent = {
  paymentIntentId: string;
  timestamp: number;
  paymentMethodId: string;
  paymentMethodType: string;
  status: string;
  created: number;
  amount: number;
  customerId?: string;
};
export type StripeInfo = {
  stripeCustomerId?: string;
  paymentIntents: PaymentIntent[];
};
export type IMobileApp = {
  iosVersion?: number;
};
export type IDvsDisclosure = {
  accepted: boolean;
  timestamp: number;
};
export type IOnfidoBiometricsConsent = {
  accepted: boolean;
  onfidoTermsAccepted: boolean;
  timestamp: number;
};
export type IStateDisclosureData = {
  state: string;
  accepted: boolean;
  timestamp: number;
  ipAddress?: string;
  /** When terms change, bump this so we can re-prompt and keep a history of acceptances per version. */
  disclosureVersion?: string;
};
export type IDepositDisclosureData = {
  state: string;
  accepted: boolean;
  timestamp: number;
  ipAddress?: string;
  type: string;
  /** When terms change, bump this so we can re-prompt and keep a history of acceptances per version. */
  disclosureVersion?: string;
};
export type IUser = {
  _id?: ObjectId;
  id: string;
  customerId: string;
  shortId: string;
  dob: string;
  phone: string;
  name: string;
  firstName?: string;
  lastName?: string;
  vipStatus: IdName;
  defaultBuySellFee: string;
  defaultTradeFee: string;
  allowArBalance: boolean;
  kycStatus: IdName;
  rekycDetails?: IReKycDetails;
  salesforceDetails?: ISalesforceDetails;
  riskAssessment: IdName;
  creditLimit: string;
  address: IAddress;
  defaultCurrencyConfig: string;
  broker: ObjectId;
  authorisedUsers: IAuthorisedUser[];
  holdings: IUserHolding[];
  watchlist: string[];
  notifications: INotification[];
  notificationPreferences?: INotificationPreferences;
  cryptoAddresses: ICryptoAddress[];
  imgUrl?: string;
  referralOptIn?: boolean;
  referralOptInTime?: number;
  testFeatureEnabled?: boolean;
  referralSignUpCode: string;
  referralCode: string;
  referralProgram: IdName;
  referralProgramTier: IdName;
  referredBy: string;
  referralFee: string;
  referralEligibilityAchievedDate: number;
  referralLinkAnalytics?: IReferralLinkAnalytics;
  pendingReferralRewards: IReferralReward[];
  totalReferralRewards: IReferralReward[];
  fiatTransactionAccounts?: IFiatTransactionAccount[];
  segment?: string;
  dateCreated?: number;
  isLocked?: boolean;
  isBypassLock?: boolean;
  subsidiary?: string;
  verificationCode?: IVerificationCode;
  enabledBank?: object;
  stripeInfo?: StripeInfo;
  mobileApp?: IMobileApp;
  dvsDisclosure?: IDvsDisclosure;
  onfidoBiometricsConsent?: IOnfidoBiometricsConsent;
  stateDisclosures?: IStateDisclosureData[];
  depositDisclosures?: IDepositDisclosureData[];
  externalId?: string;
};
export type IDailyUserCount = {
  date: string;
  count: number;
};
export type DisableUserDto = {
  /** Transmit User ID */
  userId: string;
  /** User status */
  status: "Disabled" | "Active";
};
export type IKycSteps = {
  applicationForm?: boolean;
  newApplicationForm?: boolean;
  biometrics?: boolean;
  workflowRunId?: string;
  ukRiskSummaryViewed?: boolean;
  ukInvestorTypeSelected?: boolean;
  ukStatementAgreed?: boolean;
  ukAssessmentPassed?: boolean;
  ukCoolingOffComplete?: boolean;
  ukFinalConfirmation?: boolean;
};
export type IEmailPreferences = {
  marketing?: boolean;
  brokerage?: boolean;
  fund?: boolean;
};
export type IMarketing = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
};
export type IAccountLock = {
  locked: boolean;
  lockType: string;
  reason: string;
  timestamp: number;
};
export type IAmplitude = {
  deviceId?: string;
  sessionId?: string;
};
export type IAccount = {
  _id?: ObjectId;
  id?: string;
  email: string;
  default: ObjectId | null;
  selected: ObjectId | null;
  users: ObjectId[];
  accessToken: string | null;
  refreshToken: string | null;
  is2FAEnabled?: boolean;
  factorSID: string | null;
  identity: string | null;
  acceptWelcomeModal?: boolean;
  acceptTrEducationModal?: boolean;
  acceptTerms?: boolean;
  acceptTermsTime?: number;
  accountCreateCode?: string;
  accountCreateCodeTimestamp?: number;
  accountCreateTime?: number;
  accountInitTime?: number;
  formSubmissionTime?: string;
  lastLoginTime?: number;
  loginCount?: number;
  smsVerified?: boolean;
  smsCreateTime?: number;
  phone?: string;
  transmitUserId?: string;
  testEnabled?: boolean;
  features?: string[];
  roles: string[];
  employee?: boolean;
  sessionActive?: boolean;
  lastLoggedInAt?: number;
  automatedTradeDisabled?: boolean;
  kycSteps?: IKycSteps;
  isCustomerTalkingWithBroker?: boolean;
  SFaccountId?: string;
  SFleadId?: string;
  subsidiary?: string;
  emailPreferences?: IEmailPreferences;
  marketing?: IMarketing;
  suspended?: boolean;
  isPassKeyEnabled?: boolean;
  numberOfActivePasskeys?: number;
  accountLock?: IAccountLock;
  amplitude?: IAmplitude;
};
export type EditAutomatedTradesDisabledDto = {
  email: string;
  disabled: boolean;
};
export type UpdateAccountFeatureDto = {
  /** Transmit User Email */
  email: string;
  /** User features array */
  features: (
    | "research"
    | "swap"
    | "fund"
    | "alerts"
    | "fiatDeposit"
    | "fiatWithdrawal"
    | "targets"
    | "export"
    | "dca"
    | "portfolio-revamp"
    | "RaF"
    | "refer-a-friend"
    | "contact-change-v2"
    | "add-account"
    | "sumsub"
    | "passkey"
    | "stripe"
    | "account-lock"
    | "stripe-vban"
  )[];
};
export type SetEmployeeDto = {
  /** The employee status to set for the account */
  employee: boolean;
  /** The associated transmit user id */
  transmitId: string;
};
export type EmailVerification = {
  code: string;
  createdAt?: number;
};
export type VerificationStep = {
  completed: boolean;
  attempts?: number;
  emailVerification?: EmailVerification;
  verifiedAt?: number;
  lastAttempt?: number;
};
export type VerificationSteps = {
  password?: VerificationStep;
  twoFa?: VerificationStep;
  requestedValueAuth?: VerificationStep;
  secondaryValueAuth?: VerificationStep;
  expiresAt?: number;
};
export type OnfidoProcess = {
  isRequired?: boolean;
  result?: "approved" | "pending" | "review" | "declined" | "abandoned" | null | "NULL";
};
export type ContactChange = {
  _id?: ObjectId;
  accountId: string;
  actingUserCUID: string;
  accountEmail: string;
  status:
    | "PENDING_MFA"
    | "PENDING_ONFIDO"
    | "ONFIDO_SUBMITTED"
    | "PROCESSING"
    | "COMPLETED"
    | "FROZEN"
    | "MANUAL_REVIEW"
    | "EXPIRED"
    | "CANCELLED";
  type: "EMAIL" | "PHONE" | "ADDRESS";
  originalValue?: string;
  requestedValue?: string;
  reqValueTrustfullScore?: number;
  trustfullLink?: string;
  verificationSteps?: VerificationSteps;
  onfidoProcess?: OnfidoProcess;
  isNotificationSent: boolean;
  transmitScore?: string;
  isHighHoldings?: boolean;
  createdAt?: number;
  updatedAt?: number;
  is2FAEnabled?: boolean;
};
export type ICustomerLog = {
  email: string;
  createdAt?: string;
  correlationID: string;
  timestamp?: number;
  service: string;
  endpoint: string;
  action: string;
  subAction?: string;
  error: boolean;
  message?: string;
  payload: string;
};
export type GetCustomerActionsDto = {
  /** The email of the user to search */
  email: string;
  /** The date range the to fetch actions based upon */
  dateRange: number;
};
export type Config = {
  authcontroller: boolean;
  tradecontroller: boolean;
  targetorderscontroller: boolean;
  depositcontroller: boolean;
  withdrawalcontroller: boolean;
  pricealertcontroller: boolean;
  reportingcontroller: boolean;
  holdingscontroller: boolean;
  knockcontroller: boolean;
  accountmanagementcontroller: boolean;
};
export type BatchLogResponseDto = {
  /** Array of successfully created logs */
  successful: any[];
  /** Array of logs that failed to be created */
  failed: any[];
};
export type BatchLogRequestDto = {
  /** Array of logs to be created */
  logs: any[];
};
export type IFeatureFlag = {
  _id?: ObjectId;
  key: string;
  defaultEnabled: boolean;
  perEntity?: object;
  /** Stored as a plain object on disk. Keys are user ids. */
  perUserOverrides?: object;
  updatedBy: string;
  updatedAt?: string;
  createdAt?: string;
};
export type FeatureFlagPerEntityDto = {
  AU?: boolean;
  US?: boolean;
};
export type FeatureFlagUpsertDto = {
  defaultEnabled?: boolean;
  perEntity?: FeatureFlagPerEntityDto;
};
export type FeatureFlagOverrideDto = {
  /** Internal user id (Transmit uid) to override */
  userId: string;
  /** Override value */
  value: boolean;
};
export type ListTransfersResponseDto = {
  page: number;
  pageSize: number;
  total: number;
  results: object[];
};
export type TransferDetailResponseDto = {
  notabeneTxId: string;
  transfer: object;
  /** Hash chain validity across all audit rows for this transfer */
  chainValid: boolean;
  audit: object[];
};
export type TransferAuditChainResponseDto = {
  notabeneTxId: string;
  /** True iff every row in the chain hashes correctly */
  chainValid: boolean;
  rows: object[];
};
export type ForceActionResponseDto = {
  notabeneTxId: string;
  newStatus: string;
  auditRowId: string;
  unit21AlertId?: string;
};
export type ManualOverrideDto = {
  /** Free-text justification recorded in the audit chain */
  reason: string;
};
export type ReleaseHoldResponseDto = {
  /** The tr-pending placeholder CT that was released */
  internalCtId: string;
  /** Whether the placeholder row was actually deleted */
  released: boolean;
  /** The hold status the CT was in before release */
  priorStatus?: string;
  auditRowId: string;
};
export type RescreenResponseDto = {
  notabeneTxId: string;
  notabeneRefetched: boolean;
  castellumRequested: boolean;
};
export type CurrencyConfigPermissions = {
  buy: boolean;
  sell: boolean;
  deposit: boolean;
  withdraw: boolean;
};
export type RestrictedCountryRes = {
  id: string;
  name: string;
};
export type CurrencyConfigRankedRes = {
  rank: number;
  change1d?: number;
  market_cap?: number;
  price?: number;
  sparkline?: string[];
  formatName: string;
  type: string;
  name: string;
  code: string;
  networkName: string;
  depositable?: boolean;
  inactive?: boolean;
  logoUrl?: string;
  primarySector?: string;
  secondarySector?: string;
  memo?: boolean;
  permissions?: CurrencyConfigPermissions;
  displayName?: string;
  restrictedCountries?: RestrictedCountryRes[];
};
export type IPopulatedCryptoRes = {
  coin_id: string;
  code: string;
  price: number;
  rank: number;
  market_cap: number;
  change1d: number;
  displayName: string;
  logoUrl?: string;
  description?: string;
  permissions: CurrencyConfigPermissions;
  restrictedCountries?: RestrictedCountryRes[];
};
export type IPopulatedCryptoTickersRes = {
  code: string;
};
export type CryptoSectorsRes = {
  primary: string[];
  secondary: string[];
};
export type CurrencyConfigRes = {
  formatName: string;
  type: string;
  name: string;
  code: string;
  networkName: string;
  depositable?: boolean;
  inactive?: boolean;
  logoUrl?: string;
  primarySector?: string;
  secondarySector?: string;
  memo?: boolean;
  permissions?: CurrencyConfigPermissions;
  displayName?: string;
  restrictedCountries?: RestrictedCountryRes[];
};
export type TokenPageDataRes = {
  description: string;
  sectors: string[];
  currencyConfig: CurrencyConfigRes;
  price: number;
  change: number;
  marketCap: number;
  tradingVolume: number;
  supply: number;
  supplyRatio: number;
  rank: number;
};
export type ChartWCandleRes = {
  yCandle: number[][];
  yLine: number[];
  x: string[];
};
export type CandleChartType = {
  time: number;
  close: number;
  open: number;
  high: number;
  low: number;
  volume?: number;
};
export type TopRankedRes = {
  logoUrl: string;
  rank: number;
  displayName: string;
  price: number;
  change: number;
  symbol: string;
};
export type CoinVisit = {
  userId: string;
  coinSymbol: string;
  userVisits?: number;
  createdAt?: number;
  updatedAt?: number;
};
export type CoinVisitsDto = {
  /** The token of the coin to increment visits for */
  token: string;
};
export type ForexCurrencyRes = {
  code: string;
  name: string;
  type: string;
  permissions: CurrencyConfigPermissions;
  logoUrl?: string;
  price?: number;
};
export type MarketTokenDataRes = {
  currencyConfig: CurrencyConfigRes;
  price: number;
  change1d: number | null;
  change7d: number | null;
  change30d: number | null;
  rank?: number | null;
  cap?: object;
  status?: boolean;
  marketCap?: number;
  chart: string[];
  watched: boolean;
};
export type MarketListRes = {
  totalTokens: number;
  pageSize: number;
  currentPage: number;
  totalPages: number;
  data: MarketTokenDataRes[];
};
export type MarketCardsRes = {
  recent: MarketTokenDataRes[];
  gainers: MarketTokenDataRes[];
  trending: MarketTokenDataRes[];
};
export type DashboardCryptoRes = {
  chart: string[];
  currencyConfig: CurrencyConfigRes;
  price: number;
  change?: number;
};
export type MarketOverallRes = {
  value: number;
  change: number;
};
export type TreeMapToken = {
  name: string;
  performanceValue: number;
  price: number;
  daily: number;
  weekly: number;
  monthly: number;
  currencyConfig: CurrencyConfigRes;
};
export type SecondarySector = {
  name: string;
  value: number;
  tokens: TreeMapToken[];
};
export type PrimarySector = {
  value: number;
  sectors: SecondarySector[];
};
export type TreeMapTokenRes = {
  name: string;
  marketCapDominance: PrimarySector;
};
export type CryptoNewsRes = {
  timestamp: number;
  link: string;
  id: string;
  image: string;
  title: string;
  readingTime: number;
  source: string;
  tag?: string;
};
export type PostNoteCoinResponseType = {
  timestamp: number;
  value: string;
};
export type UpdateCoinDto = {
  /** Post a coin note */
  value: string;
  ticker: string;
};
export type ICoinNote = {
  currencyConfigId: string;
  userId: string;
  value: string;
  timestamp: number;
};
export type Bin = {
  start: number;
  end: number;
  freq: number;
};
export type CurrencyTransactionLineRes = {
  fee: number;
  value: number;
  price: number;
  side?: string;
  currencyConfig: CurrencyConfigRes;
  total: number;
  units: number;
  known?: boolean;
  quoteCurrencyConfig: CurrencyConfigRes;
};
export type CurrencyTransactionRes = {
  id: string;
  status: string;
  created: number;
  completed: number;
  type: string;
  createdHour: string;
  createdDay: string;
  value: number;
  lines: CurrencyTransactionLineRes[];
  quoteCurrencyConfig: CurrencyConfigRes;
  cryptoAddressText?: string;
  bankAccountNumber?: string;
  note?: string;
  date?: string;
  data?: object;
  pendingEmailSent?: boolean;
  withdrawalApprovalStatus?: object;
};
export type PaginatedCTsRes = {
  bins: Bin[];
  totalCTs: number;
  pageSize: number;
  currentPage: number;
  totalPages: number;
  data: CurrencyTransactionRes[];
};
export type CurrencyTransactionMobile = {
  date: string;
  data: CurrencyTransactionRes[];
};
export type PaginatedCTsMobileRes = {
  bins: Bin[];
  totalCTs: number;
  pageSize: number;
  currentPage: number;
  totalPages: number;
  data: CurrencyTransactionMobile[];
};
export type UserTransactionStatsRes = {
  /** Start date of the first transaction (epoch timestamp) */
  startDate: number;
  /** End date of the last transaction (epoch timestamp) */
  endDate: number;
};
export type UserRecentTransactions = {
  type: string;
  id: string;
  value: number;
  timestamp: number;
};
export type TargetOrderCtRes = {
  id: string;
  status: string;
  created: number;
  completed: number;
  type: string;
  createdHour: string;
  createdDay: string;
  value: number;
  lines: CurrencyTransactionLineRes[];
  quoteCurrencyConfig: CurrencyConfigRes;
  cryptoAddressText?: string;
  bankAccountNumber?: string;
  note?: string;
  date?: string;
  data?: object;
  pendingEmailSent?: boolean;
  withdrawalApprovalStatus?: object;
  targetType: string;
  gamRequested?: boolean;
  cancelRequested?: boolean;
  percentageDifference: number;
  currentPrice: number;
};
export type PaginatedTargetOrdersRes = {
  totalCTs: number;
  pageSize: number;
  currentPage: number;
  totalPages: number;
  data: TargetOrderCtRes[];
};
export type OrderSizeRangeRes = {
  /** Minimum transaction value (order size) in the specified time range */
  minOrderSize: number;
  /** Maximum transaction value (order size) in the specified time range */
  maxOrderSize: number;
  /** Normalized histogram data (0-1) representing transaction distribution across order size bins */
  histogramData: any[];
};
export type TransactionsFilterRequestDto = {
  /** The limit (number of) records to return. */
  limit?: number;
  /** The page of records to return. */
  page?: number;
  /** Sort option for transactions */
  sortBy?: "most_recent" | "high_to_low" | "low_to_high";
  /** Time range filter for transactions */
  timeRange?: "all_time" | "last_month" | "last_quarter" | "last_year" | "custom";
  /** Start date for custom time range (ISO 8601 format: YYYY-MM-DD). Required when timeRange is 'custom'. */
  startDate?: string;
  /** End date for custom time range (ISO 8601 format: YYYY-MM-DD). Required when timeRange is 'custom'. */
  endDate?: string;
  /** Filter by transaction types */
  transactionTypes?: ("buy_order" | "sell_order" | "deposit" | "withdraw" | "target" | "airdrop")[];
  /** Filter by transaction statuses */
  statuses?: ("completed" | "cancelled" | "pending" | "pending_approval")[];
  /** Minimum transaction value (order size) filter. */
  minOrderSize?: number;
  /** Maximum transaction value (order size) filter. */
  maxOrderSize?: number;
};
export type CtNoteDto = {
  /** The id of the CT to which the note will be added. */
  ctId: string;
  /** The note that will be added. */
  note: string;
};
export type PendingWithdrawalRes = {
  id: string;
  date: number;
  amount: number;
  quoteCurrencyConfig: CurrencyConfigRes;
  currency: CurrencyConfigRes;
  memo: string;
  fromAccount: string;
  type: string;
  cryptoAddress: string;
  cryptoAddressNickname: string;
  withdrawalApprovalStatus: string;
};
export type WithdrawalApprovalStatusResponse = {
  /** The withdrawal approval status that was set */
  status: "Pending" | "Processing" | "Accepted" | "Declined";
};
export type SetWithdrawalApprovalStatusDto = {
  /** The id of the currency transaction to update. */
  ctId: string;
  /** The withdrawal approval status to set. */
  status: "Pending" | "Processing" | "Accepted" | "Declined";
};
export type DepositAddressRes = {
  id: string;
  memo?: string;
  address: string;
  depositable: boolean;
  formatName: string;
};
export type ProcessDepositDto = {
  /** The token code of the currency for the deposit. */
  token: string;
  /** The amount sent in the deposit transaction. */
  amount: number;
  /** The transaction ID the deposit that was performed by the customer. */
  tx_id: string;
  /** The (Netsuite) ID the address to which the deposit was sent. */
  address_id: string;
  /** A unique ID for the transaction. */
  zurich_id: string;
  /** ISO 8601 date/time when the disclosure was displayed to the user. */
  disclosureRequestDateTime?: string;
  /** ISO 8601 date/time when the user accepted the disclosure. */
  disclosureAcceptanceDateTime?: string;
};
export type AddressDto = {
  /** City of the address */
  city: string;
  /** Country of the address */
  country: string;
  /** First line of the address */
  line1: string;
  /** Second line of the address (optional) */
  line2?: string | null;
  /** Postal code of the address */
  postal_code: string;
  /** State/province of the address */
  state: string;
};
export type AbaFinancialAddressDto = {
  /** Account holder's address */
  account_holder_address: AddressDto;
  /** Name of the account holder */
  account_holder_name: string;
  /** Bank account number */
  account_number: string;
  /** Type of bank account */
  account_type: string;
  /** Bank's address */
  bank_address: AddressDto;
  /** Name of the bank */
  bank_name: string;
  /** ABA routing number */
  routing_number: string;
};
export type SwiftFinancialAddressDto = {
  /** Account holder's address */
  account_holder_address: AddressDto;
  /** Name of the account holder */
  account_holder_name: string;
  /** Bank account number */
  account_number: string;
  /** Type of bank account */
  account_type: string;
  /** Bank's address */
  bank_address: AddressDto;
  /** Name of the bank */
  bank_name: string;
  /** SWIFT code for international transfers */
  swift_code: string;
};
export type ProcessStripeDepositRes = {
  /** ABA financial address for domestic US transfers */
  aba_financial_address: AbaFinancialAddressDto;
  /** SWIFT financial address for international transfers */
  swift_financial_address?: SwiftFinancialAddressDto | null;
};
export type BalanceRes = {
  value: number;
  change: number | null;
  dollarChange?: number | null;
};
export type WalletBalanceRes = {
  defaultCurrencyConfig: CurrencyConfigRes;
  balance: BalanceRes;
  pending: number;
};
export type HoldingRes = {
  currencyConfig: CurrencyConfigRes;
  change?: number;
  isLowBalance: boolean;
  available: number;
  openTargets: number;
  reserved: number;
  pendingPortal?: number;
  total: number;
  price: number;
  value: number;
  pendingValue: number;
  totalValue: number;
  sparkline?: string;
};
export type ChartRes = {
  y: number[];
  x: string[];
};
export type ChartStackedRes = {
  currencyConfig: object;
  axes: ChartRes;
};
export type AllRunningTotalChartsRes = {
  "1D": ChartStackedRes[];
  "1W": ChartStackedRes[];
  "1M": ChartStackedRes[];
  "3M": ChartStackedRes[];
  "6M": ChartStackedRes[];
  "1Y": ChartStackedRes[];
  ALL: ChartStackedRes[];
};
export type UserFiatHoldings = {
  code: string;
  name: string;
  type: string;
  permissions: CurrencyConfigPermissions;
  logoUrl?: string;
  available: number;
};
export type ReferralProgramRes = {
  description: string;
  reward: string;
  rewardPercent: string;
  currencyConfig: CurrencyConfigRes;
  refereeBonus: number;
};
export type RewardsRes = {
  currencyConfig: CurrencyConfigRes;
  units: number;
  value: number;
  created?: string | null;
};
export type ReferralsDataRes = {
  referralProgram: ReferralProgramRes;
  rewardsTotal: RewardsRes[];
  rewardsPending: RewardsRes[];
  rewardsMonthly: RewardsRes[];
  referees: number;
  referralCode?: string;
  referralOptIn?: boolean;
  tier: string;
};
export type ReferralRewardsRes = {
  timestamp: number;
  tier: string;
  reward: string;
};
export type ReferralMontlyRewardsRes = {
  timestamp: string;
  currency: string;
  value: number;
};
export type ShareLinkDto = {
  /** The type of referral method used by the customer. */
  shareType: "directLink" | "email" | "twitter" | "facebook" | "whatsapp";
};
export type ReferralCodeDto = {
  /** The referral partners' code. */
  rpCode: string;
};
export type AddressRes = {
  zip?: string;
  country?: string;
  city?: string;
  state?: string;
  fullAddress: string;
  streetAddress?: string;
};
export type AuthorisedUserRes = {
  email: string;
  firstName: string;
  lastName?: string;
};
export type BrokerRes = {
  name: string;
  email: string;
  phoneNumberAU: string;
  phoneNumberUS: string;
  imgUrl?: string;
  countryCode?: string;
};
export type UserDetailsRes = {
  customerId: string;
  name: string;
  dob: string;
  email: string;
  phone: string;
  firstName: string;
  lastName: string;
};
export type KycType = {
  newApplicationForm?: boolean;
  biometrics?: boolean;
  transmitIdentity: {
    startToken?: string;
    tokenExpiry?: string;
    state?: string;
    sessionId?: string;
  };
};
export type OverviewRes = {
  balance: number;
  pending: number;
};
export type ReKycRes = {
  reKyc: boolean;
  recordType: string;
  edd: boolean;
  kycExpiryDate: string;
  formSubmitted?: boolean;
  onfidoCheck?: boolean;
};
export type SalesforceDetailsRes = {
  recordType: string;
  ssnRequired?: boolean;
  submitted?: boolean;
  einRequired?: boolean;
};
export type AccountLockRes = {
  locked: boolean;
  lockType: string;
  reason: string;
  timestamp: number;
};
export type StateDisclosureDataRes = {
  state: string;
  accepted: boolean;
  timestamp: number;
  disclosureVersion?: string;
};
export type DepositDisclosureDataRes = {
  state: string;
  accepted: boolean;
  timestamp: number;
  type: string;
  disclosureVersion?: string;
};
export type UserRes = {
  is2FAEnabled: boolean;
  acceptTerms: boolean;
  accountCreateTime: number;
  defaultTradeFee: number;
  address: AddressRes;
  defaultCurrencyConfig: CurrencyConfigRes;
  authorisedUsers: AuthorisedUserRes[];
  broker: BrokerRes;
  details: UserDetailsRes;
  employee?: boolean;
  kycSteps: KycType;
  id: string;
  referredBy?: string;
  referralSignUpCode?: string;
  isLocked?: boolean;
  isBypassLock?: boolean;
  sumsubExternalId?: string;
  holdings: HoldingRes[];
  overview: OverviewRes;
  acceptWelcomeModal?: boolean;
  acceptTrEducationModal?: boolean;
  loginCount?: number;
  isCustomerTalkingWithBroker: boolean;
  rekycDetails: ReKycRes;
  isUnverified: boolean;
  isPendingVerification: boolean;
  kycStatus?: string;
  salesforceDetails: SalesforceDetailsRes;
  subsidiary?: string;
  accountLock: AccountLockRes;
  stateDisclosures?: StateDisclosureDataRes[];
  depositDisclosures?: DepositDisclosureDataRes[];
};
export type UserSummary = {
  type: string;
  value: number | null;
};
export type KycStatusRes = {
  isVerified: boolean;
  kycSteps: KycType;
  kycStatus?: string;
  sumsubExternalId?: string;
};
export type IWatchListDataRes = {
  _id: string;
  id: string;
  currencyConfig: CurrencyConfigRes;
  logoUrl: string;
  name: string;
  price: string;
  change1d: number;
  circulating_supply: number;
  market_cap: string;
  tradingVolume: number;
  sparkline: string[];
  rank?: number;
};
export type AddWatchlistV2Response = {
  success: boolean;
  data?: IWatchListDataRes;
  watchlist?: IWatchListDataRes[];
  error?: string;
};
export type AddWatchlistV2Dto = {
  /** The code of the currency */
  token: string;
  /** The currency code to convert token data into */
  quote?: string;
};
export type RemoveWatchlistV2Response = {
  success: boolean;
  token: string;
  error?: string;
};
export type RemoveWatchlistV2Dto = {
  /** The code of the currency */
  token: string;
};
export type AcceptStateDisclosureDto = {
  /** The state of the user */
  state: string;
  /** Whether the user has accepted the disclosure */
  isAccepted: boolean;
  /** Optional version/id of the disclosure terms being accepted. When terms change, bump this to re-prompt and keep a history of acceptances per version. */
  disclosureVersion?: string;
};
export type AcceptDepositDisclosureDto = {
  /** The state of the user */
  state: string;
  /** Whether the user has accepted the disclosure */
  isAccepted: boolean;
  /** The type of deposit disclosure: Crypto or Fiat */
  type: "Crypto" | "Fiat";
  /** Optional version/id of the disclosure terms being accepted. When terms change, bump this to re-prompt and keep a history of acceptances per version. */
  disclosureVersion?: string;
};
export type TodayDisclosureAcceptanceRes = {
  /** ISO 8601 date/time when the disclosure was displayed to the user. */
  disclosureRequestDateTime: string;
  /** ISO 8601 date/time when the user accepted the disclosure. */
  disclosureAcceptanceDateTime: string;
};
export type PrepareWithdrawalResponseDto = {
  /** Opaque withdrawal-prepared token. Send in X-Withdrawal-Prepared-Token header. */
  token: string;
  /** ISO timestamp when this token expires. */
  expiresAt: string;
  /** Whether THIS withdrawal requires the Travel Rule step. false when the TR flag is off for the user, or when the withdrawal is US-entity and under the de-minimis USD threshold — the frontend then skips the Notabene stage entirely. */
  travelRuleRequired?: boolean;
};
export type PrepareWithdrawalDto = {
  /** The 2FA code used for verifying the request. */
  code: string;
  asset: string;
  amount: number;
  destinationAddress: string;
  emailCode: string;
};
export type WithdrawalVerificationDto = {
  /** The token symbol */
  emailCode: string;
  /** The amount to send */
  twoFaCode?: string;
  /** The type of withdrawal */
  type?: "Crypto" | "Fiat";
};
export type SendWithdrawalEmailCodeDto = {
  /** withdrawal address */
  cryptoAddress: string;
  /** The token symbol */
  token: string;
  /** The amount to send */
  amount: string;
  /** The type of withdrawal */
  type?: "Crypto" | "Fiat";
};
export type ProcessWithdrawalDto = {
  /** The 2FA code used for verifying the request. */
  code: string;
  /** The token code of the currency for the withdrawal. */
  token: string;
  /** The amount requested for withdrawal. */
  amount: number;
  /** The address to which the withdrawal will be sent. */
  address: string;
  /** The email 2FA code for the withdrawal. */
  emailCode: string;
  /** Whether or not the process is valid */
  valid?: boolean;
  /** The error message if the process is invalid */
  error?: string;
  /** The Notabene transfer ID for Travel Rule compliance */
  notabeneTxId?: string;
  /** Withdrawal-prepared token returned by POST /withdrawal/prepare. When provided, the backend validates and consumes the token in lieu of re-checking the raw email code + 2FA. The token is bound to a specific asset/amount/address and is single-use, short-lived (60 min). */
  withdrawalToken?: string;
  /** ISO 8601 date/time when the disclosure was displayed to the user. */
  disclosureRequestDateTime?: string;
  /** ISO 8601 date/time when the user accepted the disclosure. */
  disclosureAcceptanceDateTime?: string;
  /** IANA timezone for end-of-day disclosure acceptance lookup. */
  timezone?: string;
};
export type ProcessFiatWithdrawalDto = {
  /** The 2FA code used for verifying the request. */
  code: string;
  /** The bank account id for withdrawal. */
  bankAccountId: string;
  /** The currency of the withdrawal. */
  currency: string;
  /** The amount requested for withdrawal. */
  amount: number;
  /** The email 2FA code for the withdrawal. */
  emailCode: string;
  /** Whether or not the process is valid */
  valid?: boolean;
  /** The error message if the process is invalid */
  error?: string;
  /** ISO 8601 date/time when the disclosure was displayed to the user. */
  disclosureRequestDateTime?: string;
  /** ISO 8601 date/time when the user accepted the disclosure. */
  disclosureAcceptanceDateTime?: string;
  /** IANA timezone for end-of-day disclosure acceptance lookup. */
  timezone?: string;
};
export type MinimumWithdrawalDto = {
  /** The token symbol */
  token: string;
  /** The amount to send */
  amount?: number;
};
export type WithdrawAddressSeparateRes = {
  memo?: string;
  address: string;
  status: string;
  format: string;
  nickname: string;
  currencyConfig: CurrencyConfigRes;
  /** Travel-Rule lifecycle of this address — read by the withdrawal modal
    to decide whether to insert the D4 backfill stage. */
  travelRuleStatus?: object;
  isFirstParty?: boolean | null;
};
export type IPopulatedHolding = {
  currencyConfig: object;
  available: number;
  reserved: number;
  openTargets: number;
  total: number;
  pendingPortal?: number;
};
export type WithdrawAddressRes = {
  memo?: string;
  address: string;
  status: string;
  format: string;
  currencyConfig: CurrencyConfigRes[];
  lastUpdated?: number;
  nickname?: string;
};
export type TokenSpecificWithdrawAddressRes = {
  holdingData: IPopulatedHolding;
  verifiedAddresses: WithdrawAddressRes[];
  pendingAddresses: WithdrawAddressRes[];
};
export type AddWithdrawAddressDto = {
  /** The withdrawal address to be added */
  address: string;
  /** The blockchain format to which the address belongs. */
  format: string;
  /** The token symbol to which the withdrawal address is associated. */
  token: string;
  /** The memo required for some blockchains transactions. Needed to differentiate destinations. */
  memo?: string;
  /** The nickname to be assigned to the withdrawal address. This is for user reference. */
  nickname?: string;
  /** True if the wallet is owned by the customer */
  isFirstParty?: boolean;
  /** Recipient name when wallet is third-party */
  thirdPartyRecipientName?: string;
  destinationType?: "Self-Hosted Wallet" | "Exchange" | "Other VASP";
  /** Notabene VASP DID for the destination */
  destinationVasp?: string;
  /** Human-readable VASP name */
  destinationVaspName?: string;
  /** SafeConnect attestation reference */
  walletVerificationReference?: string;
};
export type PatchTrFieldsDto = {
  isFirstParty?: boolean;
  thirdPartyRecipientName?: string;
  destinationType?: "Self-Hosted Wallet" | "Exchange" | "Other VASP";
  destinationVasp?: string;
  destinationVaspName?: string;
  walletVerificationReference?: string;
};
export type UpdateAddressDto = {
  /** The withdrawal address to be updated */
  address: string;
  /** The format of the blockchain address. */
  format: string;
  /** The status of the withdrawal address. This is for user reference. */
  status: string;
  /** The memo required for some blockchains transactions. Needed to differentiate destinations. */
  memo?: boolean;
  /** The token symbol to which the withdrawal address is associated. */
  currencyCode: string;
  /** The nickname to be assigned to the withdrawal address. This is for user reference. */
  nickname?: string;
};
export type AddressWithEmailCodeDto = {
  /** The withdrawal address to be added */
  address: string;
  /** Code from users email. */
  emailCode: string;
};
export type ProcessWithdrawAddressRes = {
  status: string;
};
export type AddressWithCodesDto = {
  /** The withdrawal address to be added */
  address: string;
  /** Code from users email. */
  emailCode: string;
  /** Users 2FA. */
  twoFactorCode: string;
};
export type VerifyAddressDto = {
  /** The withdrawal address to be verified */
  address: string;
  /** The test amount that was sent to the address */
  testAmount: number;
  /** The token symbol to which the withdrawal address is associated. */
  token: string;
};
export type ResendEmailCodeDto = {
  /** The withdrawal address to be added */
  address: string;
  /** The token symbol to which the withdrawal address is associated. */
  token: string;
};
export type ReportCurrencyTransactionLine = {
  side: string;
  currency: string;
  units: string;
  price: string;
  value: string;
  fee: string;
  total: string;
};
export type ReportCurrencyTransaction = {
  date: string;
  type: string;
  status: string;
  totalValue: string;
  lines: ReportCurrencyTransactionLine[];
  address: string;
  txId: string;
};
export type CtReport = {
  completedTrades: ReportCurrencyTransaction[];
  openTargets: ReportCurrencyTransaction[];
  completedDepositsAndWithdrawals: ReportCurrencyTransaction[];
  completedOther: ReportCurrencyTransaction[];
  cancelled: ReportCurrencyTransaction[];
};
export type AccountReportUserHolding = {
  asset: string;
  units: string;
  price: string;
  value: string;
};
export type ReportCurrencyTransactionWoExtra = {
  date: string;
  type: string;
  status: string;
  lines: ReportCurrencyTransactionLine[];
};
export type AccountReportTx = {
  date: string;
  type: string;
  currency: string;
  units: string;
};
export type AccountReportCryptoWithdrawal = {
  date: string;
  type: string;
  currency: string;
  units: string;
  address: string;
};
export type AccountReportCryptoDeposit = {
  date: string;
  type: string;
  currency: string;
  units: string;
  txId: string;
};
export type AccountReport = {
  accountName: string;
  holdings: AccountReportUserHolding[];
  orders: ReportCurrencyTransactionWoExtra[];
  fiatTransactions: AccountReportTx[];
  cryptoWithdrawals: AccountReportCryptoWithdrawal[];
  cryptoDeposits: AccountReportCryptoDeposit[];
  otherTransactions: ReportCurrencyTransactionWoExtra[];
  totalPortfolioValue: number;
  defaultCurrency: string;
};
export type SanitisedTradeToken = {
  currencyConfig: CurrencyConfigRes;
  value: number;
  units: number;
  price: number;
};
export type TradeFee = {
  value: number;
  amount: number;
  isPromotional?: boolean;
  promotionalPartnerCode?: string;
};
export type SanitisedTradeSummaryRes = {
  sell: SanitisedTradeToken;
  buy: SanitisedTradeToken;
  fee: TradeFee;
  totalValue: number;
  type: string;
  quoteCurrencyConfig: CurrencyConfigRes;
  knownSide: string;
  valid: boolean;
  error?: string;
};
export type TokenInfo = {
  /** The units requested to trade, is optional as only one side of the trade can be defined. */
  units?: number;
  /** The code of the token being requested. */
  code: string;
};
export type TradeSummaryDto = {
  /** The buy side of the trade. */
  buy: TokenInfo;
  /** The sell side of the trade. */
  sell: TokenInfo;
};
export type CreateTradeDto = {
  /** The buy side of the trade. */
  buy: TokenInfo;
  /** The sell side of the trade. */
  sell: TokenInfo;
  /** The datetime of when the trade was requested, in the user's timezone. */
  datetime: string;
  /** ISO 8601 date/time when the disclosure was displayed to the user. */
  disclosureRequestDateTime?: string;
  /** ISO 8601 date/time when the user accepted the disclosure. */
  disclosureAcceptanceDateTime?: string;
  /** IANA timezone (e.g. America/New_York). Used to look up that day's disclosure acceptance for Netsuite. */
  timezone?: string;
};
export type SanitisedTargetOrderSummaryRes = {
  sell: SanitisedTradeToken;
  buy: SanitisedTradeToken;
  fee: TradeFee;
  totalValue: number;
  type: string;
  remainingUnits: number;
  quoteCurrencyConfig: CurrencyConfigRes;
  knownSide: string;
  valid: boolean;
  error?: string;
  percentageDifference: number;
  knownCurrentPrice: number;
};
export type TargetTokenInfo = {
  /** The units requested to trade, is optional as only one side of the trade can be defined. */
  units?: number;
  /** The target price for the target order, is optional as only one side of the trade can be defined. */
  targetPrice?: number;
  /** The code of the token being requested. */
  code: string;
};
export type TargetOrderSummaryDto = {
  /** The buy side of the trade. */
  buy: TargetTokenInfo;
  /** The sell side of the trade. */
  sell: TargetTokenInfo;
};
export type CreateTargetOrderDto = {
  /** The buy side of the trade. */
  buy: TargetTokenInfo;
  /** The sell side of the trade. */
  sell: TargetTokenInfo;
  /** The datetime of when the trade was requested, in the user's timezone. */
  datetime: string;
  /** ISO 8601 date/time when the disclosure was displayed to the user. */
  disclosureRequestDateTime?: string;
  /** ISO 8601 date/time when the user accepted the disclosure. */
  disclosureAcceptanceDateTime?: string;
  /** IANA timezone (e.g. America/New_York). Used to look up that day's disclosure acceptance for Netsuite. */
  timezone?: string;
};
export type RequestActionDto = {
  /** The ID of the target order being requested. */
  ctId: string;
  datetime: string;
};
export type PriceAlertDto = {
  /** Cross over price */
  crossOverPrice: number;
  /** Currency code */
  code: string;
};
export type ExistingPriceAlertDto = {
  /** Id of existing price alert */
  id: string;
  /** Cross over price */
  crossOverPrice: number;
  /** Currency code */
  code: string;
};
export type PriceAlertIdDto = {
  /** Id of existing price alert */
  id: string;
};
export type PriceAlertRes = {
  currencyConfig: CurrencyConfigRes;
  crossOverPrice: number;
  limitPrice: number;
  timestamp: number;
  id: string;
  currentPrice: number;
  percentageDifference: number;
  status: string;
};
export type PaginatedPriceAlertsRes = {
  totalPriceAlerts: number;
  pageSize: number;
  currentPage: number;
  totalPages: number;
  data: PriceAlertRes[];
};
export type NotificationRes = {
  id: string;
  timestamp: number;
  type: string;
  subType?: string | null;
  message: string;
  read: boolean;
  relatedId: string | null;
};
export type PaginatedUserNotificationsRes = {
  data: NotificationRes[];
};
export type UserNotificationIdsDto = {
  /** The ids of the user notifications to perform actions on */
  ids: string[];
};
export type DcaStrategySummaryRes = {
  /** The sell currency of a strategy. */
  sell: SanitisedTradeToken;
  /** The buy currency of a strategy. */
  buy: SanitisedTradeToken;
  /** The user fee for each order on a strategy. */
  fee: TradeFee;
  /** The total value of the strategy. */
  totalValue: number;
  /** The type of the strategy. */
  type: string;
  /** The currency config of the quote currency */
  quoteCurrencyConfig: CurrencyConfigRes;
  /** The known side of the strategy. */
  knownSide: string;
  /** Whether or not the strategy is valid. */
  valid: boolean;
  /** The frequency of the strategy. */
  frequency: "Day" | "Week" | "Month" | "Quarter";
  /** The start date of the strategy. */
  startDate: number;
  /** The end date of the strategy, if any. */
  endDate?: number;
  /** The spend limit for the strategy, if any. */
  spendLimit?: number;
  /** The difference in user holdings vs the specified strategy amount. */
  nextOrderDifference?: number;
  /** The total number of triggers for this strategy. */
  totalTriggers?: number | null;
  /** ISO 8601 date/time when the disclosure was displayed to the user. */
  disclosureRequestDateTime?: string;
  /** ISO 8601 date/time when the user accepted the disclosure. */
  disclosureAcceptanceDateTime?: string;
  /** IANA timezone (e.g. America/New_York). Used to look up that day's disclosure acceptance for Netsuite. */
  timezone?: string;
};
export type SummaryTokenInfo = {
  /** The units requested to trade, is optional as only one side of the trade can be defined. */
  units?: number;
  /** The code of the token being requested. */
  code: string;
};
export type DcaStrategyReqDto = {
  /** The frequency of the strategy. */
  frequency: "Day" | "Week" | "Month" | "Quarter";
  /** The amount used in the strategy. */
  amount: number;
  /** The currency to buy. */
  buy: SummaryTokenInfo;
  /** The currency to sell. */
  sell: SummaryTokenInfo;
  /** The start date of the strategy. */
  startDate: number;
  /** The end date of the strategy, if any. */
  endDate?: number;
  /** The spend limit for the strategy, if any. */
  spendLimit?: number;
};
export type DcaStrategyDto = {
  /** The unique Mongo ID of a strategy. */
  _id: string;
  /** The ID of the user. */
  userId: string;
  /** The transmit ID of the user. */
  transmitUserId: string;
  /** The status of the strategy. */
  status: "Active" | "Cancelled" | "Completed" | "Pending Completed";
  /** The frequency of the strategy. */
  frequency: "Day" | "Week" | "Month" | "Quarter";
  /** The amount used in the strategy. */
  amount: number;
  /** The start date of the strategy. */
  startDate: number;
  /** The end date of the strategy, if any. */
  endDate?: number;
  /** The spend limit for the strategy, if any. */
  spendLimit?: number;
  /** The currency config of the buy currency */
  buyCurrency: CurrencyConfigRes;
  /** The currency config of the sell currency */
  sellCurrency: CurrencyConfigRes;
  /** The date of the next order. */
  nextOrderDueDate: number;
  /** The amount of past triggers that have been actioned on this stratrgy. */
  pastTriggers?: number;
  /** The total number of triggers for this strategy. */
  totalTriggers?: number | null;
  /** The total amount spent on a strategy. */
  totalAmountSpent: number;
  /** The average purchase price of a given asset. */
  averagePurchasePrice: number;
  /** The accumulated balance of a purchased asset. */
  accumulatedBalance: number;
  /** The current market DCA strategy value based on the buy currency accumulated balance. */
  strategyValue: number;
  /** The date the strategy was created at */
  createdAt: number;
  /** The date the strategy was updated at */
  updatedAt: number;
};
export type GetDcaStrategiesDto = {
  /** The page number to retrieve. */
  page: number;
  /** The current page count. */
  pageCount: number;
  /** The strategies retrieved. */
  strategies: DcaStrategyDto[];
};
export type DcaTriggerDto = {
  /** The unique identifier of the DCA Trigger */
  _id: string;
  /** The unique identifier of the DCA Trigger */
  userId: string;
  /** The unique identifier of the DCA Strategy */
  strategyId: string;
  /** The Currency Transaction ID of the DCA Trigger */
  CTId: string;
  /** The status of the DCA Trigger */
  status: "PENDING" | "EXECUTED" | "PROCESSING" | "PENDING_NETSUITE" | "FAILED" | "CANCELLED";
  /** The fee of the trigger */
  fee: string;
  /** The currency config of the buy currency */
  buyCurrency: CurrencyConfigRes;
  /** The currency config of the sell currency */
  sellCurrency: CurrencyConfigRes;
  /** The units of the currency to buy */
  buyUnits: number;
  /** The units of the currency to sell */
  sellUnits: number;
  /** The price of the currency */
  buyCurrencyPrice: number;
  /** The time to execute the DCA Trigger */
  timeToExecute: string;
  /** The time the DCA Trigger was created */
  createdAt: string;
  /** The time the DCA Trigger was last updated */
  updatedAt: string;
};
export type GetTriggersResDto = {
  /** The page number of the triggers */
  page: number;
  /** The total number of triggers */
  pageCount: number;
  /** The DCA Triggers */
  triggers: DcaTriggerDto[];
};
export type UpdateBurlingBankDetails = {
  /** Customer Id */
  customerId: string;
  /** new state of the toggle */
  toggle: boolean;
};
export type UserBankingDto = {
  burlingBank: boolean;
};
export type IBankDetails = {
  userId: string;
  netsuiteRecordId: string;
  currency: string;
  trailingAccNumberDigits: string;
  isInactive: boolean;
  createdAt: number;
};
export type AddressFieldsDto = {
  /** The street address */
  streetAddress: string;
  /** The city */
  city: string;
  /** The state */
  state: string;
  /** The country */
  country: string;
  /** The postcode */
  postcode: string;
  /** The unit */
  unit?: string;
};
export type BankAccountReqDto = {
  /** The 2FA code used for verifying the request. */
  code: string;
  /** The beneficiary name */
  beneficiaryName: string;
  /** The beneficiary address */
  beneficiaryAddress: AddressFieldsDto;
  /** The currency concerning the bank account */
  currency: string;
  /** The bank name */
  bankName: string;
  /** The bank address */
  bankAddress: AddressFieldsDto;
  /** The email 2FA code from verification. */
  emailCode: string;
  /** The swift code of the bank */
  swiftCode?: string;
  /** The IBAN or Account Number. We combine them to keep aligned with the NetSuite payload, as NetSuite does not have separate fields for both. */
  ibanAccNumber: string;
  /** The Sort Code or BSB number. We combine them to keep aligned with the NetSuite payload, as NetSuite does not have separate fields for both. */
  sortCodeOrBsb?: string;
  /** The ABA routing number (specific to US) */
  abaRoutingNumber?: string;
  /** The institution number (specific to CAD) */
  institutionNumber?: string;
  /** The transit number (specific to CAD) */
  transitNumber?: string;
  /** The identity type */
  identityType: "Individual" | "Business";
  /** The account type */
  accountType: "SVGS" | "CACC";
};
export type IBankDetailsRes = {
  currency: string;
  trailingAccNumberDigits: string;
};
export type ReferralsCountRes = {
  count: number;
};
export type ReferralConversionRes = {
  signedUp: number;
  verified: number;
  activeCustomers: number;
};
export type ReferralFeesObj = {
  timestamp: string;
  fees: number;
};
export type ReferralFeesDataRes = {
  timeframeData: ReferralFeesObj[];
  totalFees: number;
};
export type ReferralFeesRes = {
  data: ReferralFeesDataRes;
};
export type IAssetPercentage = {
  name: string;
  percentage: number;
  value?: number;
};
export type ReferralAssetHoldings = {
  data: IAssetPercentage[];
};
export type ReferralTradeData = {
  timestamp: string;
  "Buy Orders": number;
  "Sell Orders": number;
  "Target Orders": number;
  "Trade Orders": number;
};
export type ReferralTradeHistory = {
  data: ReferralTradeData[];
};
export type ReferralGrowthObj = {
  timestamp: string;
  count: number;
};
export type ReferralGrowthHistoryRes = {
  data: ReferralGrowthObj[];
};
export type ReferralCoinVisitObj = {
  coinSymbol: string;
  visits: number;
};
export type ReferralCoinVisitsRes = {
  data: ReferralCoinVisitObj[];
};
export type ReferralCodeRes = {
  referralCode: string;
};
export type ReferralDepositVolumeObj = {
  timestamp: string;
  "Crypto Deposits": number;
  "Fiat Deposits": number;
};
export type ReferralDepositVolumeRes = {
  data: ReferralDepositVolumeObj[];
};
export type ReferralAvgFirstTradeTimeRes = {
  avgFirstTradeTime: number;
};
export type ReferralAssetObj = {
  topAssets: IAssetPercentage[];
  timestamp: string;
  totalValue: number;
};
export type ReferralAssetsTraded = {
  data: ReferralAssetObj[];
};
export type PartnershipMatchTableItem = {
  name: string;
  code: string;
  reward: number;
};
export type NotabeneTokenResponseDto = {
  /** The Notabene customer token (access token) for frontend SDK */
  token: string;
  /** Token expiration time in seconds */
  expiresIn: number;
  /** Notabene API base URL the token was minted against */
  nodeUrl: string;
};
export type NotabenePolicyDto = {
  /** Policy type */
  type: string;
  /** Policy status */
  status?: string;
  /** Additional policy data */
  data?: object;
};
export type NotabeneAgentDto = {
  /** Agent identifier (DID or address) */
  "@id": string;
  /** What this agent represents */
  for: string;
  /** Agent role in the transfer */
  role?: string;
  /** Policies associated with this agent */
  policies?: NotabenePolicyDto[];
};
export type NotabeneTransferResponseDto = {
  /** Notabene transfer ID */
  txId: string;
  /** Current status of the transfer */
  status: string;
  /** Array of agents involved in the transfer */
  agents?: NotabeneAgentDto[];
  /** Authorization policies for this transfer */
  policies?: NotabenePolicyDto[];
  /** Discovered counterparty VASP information */
  counterparty?: object;
  /** Error message if transfer failed */
  errorMessage?: string;
  /** Asset code or CAIP-19 identifier the transfer was created for */
  asset?: string;
  /** Transfer amount as a string (decimal) */
  amount?: string;
  /** Destination wallet address */
  destinationAddress?: string;
  /** Source wallet address (set on inbound transfers). */
  sourceAddress?: string;
  /** Transfer direction. */
  direction?: "OUTGOING" | "INCOMING";
  /** True when Notabene's resolver returned a counterparty VASP that disagrees with the user-declared destination. */
  counterpartyMismatch?: boolean;
  /** True when the originator still owes IVMS101 PII (Notabene requested a presentation that hasn't been satisfied). The frontend keeps the SafeConnect SDK mounted while this is set, even if the lifecycle status has churned to a transient FLAGGED/PENDING. */
  requiresPresentation?: boolean;
  /** Optional human-readable reason for the current state. */
  reason?: string;
  /** Internal withdrawal id this transfer was linked to once the withdrawal was submitted. When set, the withdrawal is already done — the frontend must not resume it or show the 'continue your withdrawal' banner. */
  withdrawalId?: string;
};
export type CreateNotabeneTransferDto = {
  /** Token code for the asset being transferred */
  asset: string;
  /** Amount to transfer as a string for precision */
  amount: string;
  /** Destination blockchain address */
  destinationAddress: string;
  /** Optional memo for the transaction (for chains that support it) */
  memo?: string;
};
export type TrConfigResponseDto = {
  /** SLA shown on the Pending Review surface, in business days. */
  pendingReviewBusinessDays: number;
};
export type VaspDirectoryRowDto = {
  /** VASP decentralised identifier (DID) */
  vaspDid: string;
  /** Human-readable VASP / exchange name */
  vaspName: string;
  /** Jurisdiction / country code of the VASP, when known */
  jurisdiction?: string;
};
export type LegalJurisdictionRes = {
  level: object;
  country?: string;
  region?: string;
};
export type LegalCategoryRes = {
  id: string;
  title: string;
  content: string;
};
export type LegalTranslationRes = {
  language: object;
  title: string;
  effectiveDate?: string;
  noticeText?: string;
  warningTitle?: string;
  warningText?: string;
  content: string;
  bulletPoints?: string[];
  categories?: LegalCategoryRes[];
  acceptButtonText: string;
  supportsLanguageSelection?: boolean;
  supportedLanguages?: object[];
};
export type LegalDocumentRes = {
  type: object;
  jurisdiction: LegalJurisdictionRes;
  version: string;
  translations: LegalTranslationRes[];
};
export type ILegalJurisdiction = {
  level: object;
  /** ISO 3166-1 alpha-2 (e.g. "US", "AU"). Absent for global. */
  country?: string;
  /** ISO 3166-2 subdivision (e.g. "CT", "MN"). Present only when level === "state". */
  region?: string;
};
export type ILegalDocument = {
  _id?: ObjectId;
  type: object;
  jurisdiction: ILegalJurisdiction;
  /** Release identifier within the (type, jurisdiction) stream, e.g. "2025-01". */
  version: string;
  /** Language → ILegalTranslation map, stored as Mixed. */
  translations: object;
  status: object;
  /** When a published version becomes the "current" one. "current" = latest effectiveFrom <= now. */
  effectiveFrom?: string;
  /** Set when status transitions to `published`. */
  publishedAt?: string;
  /** Optional — name of whoever created/published this version. */
  editedBy?: string;
  createdAt?: string;
  updatedAt?: string;
};
export type JurisdictionDto = {
  level: object;
  country?: string;
  region?: string;
};
export type CreateLegalDraftDto = {
  type: object;
  jurisdiction: JurisdictionDto;
  version: string;
  /** language → rendered translation (DisclosureContent shape). Hashes computed server-side. */
  translations: object;
  editedBy?: string;
};
export type PublishLegalDocumentDto = {
  id: string;
  /** ISO date string. Defaults to now if omitted. */
  effectiveFrom?: string;
};
export const {
  useGetIntercomJwtQuery,
  useLazyGetIntercomJwtQuery,
  useGetConversationV2Query,
  useLazyGetConversationV2Query,
  useGetTagsQuery,
  useLazyGetTagsQuery,
  useGetClientConversationHistoryQuery,
  useLazyGetClientConversationHistoryQuery,
  useReplyToConversationMutation,
  useReplyToConversationImageUploadMutation,
  useCreateConversationMutation,
  useGetUserIdMutation,
  useCreateMonoovaAccountMutation,
  useGetMonoovaAccountDetailsQuery,
  useLazyGetMonoovaAccountDetailsQuery,
  useGetUserIdByMonoovaAccountNumberQuery,
  useLazyGetUserIdByMonoovaAccountNumberQuery,
  useIdentifyUserMutation,
  useRetrieveUserQuery,
  useLazyRetrieveUserQuery,
  useSetPreferencesMutation,
  useGetPreferencesQuery,
  useLazyGetPreferencesQuery,
  useTriggerKnockWorkflowMutation,
  useTriggerKnockWorkflowV2Mutation,
  useSetChannelDataMutation,
  useSetWorkflowPreferenceMutation,
  useVerifyAddressDataZooMutation,
  useVerifyBulkDatazooAddressMutation,
  useGetTaxAccountQuery,
  useLazyGetTaxAccountQuery,
  useUpdateTaxAccountMutation,
  useGetReleasedTaxDocumentsQuery,
  useLazyGetReleasedTaxDocumentsQuery,
  useGetTaxTransactionsQuery,
  useLazyGetTaxTransactionsQuery,
  useCreateTaxTransferLotsMutation,
  useGetTaxTransferLotsQuery,
  useLazyGetTaxTransferLotsQuery,
  useDeleteTaxTransferLotsMutation,
  useGetTaxDocumentationTokenQuery,
  useLazyGetTaxDocumentationTokenQuery,
  useGetTaxDocumentationStatusQuery,
  useLazyGetTaxDocumentationStatusQuery,
  useCreateAccountMutation,
  useLegacyCreateAccountMutation,
  useGetMultiAccountUsersQuery,
  useLazyGetMultiAccountUsersQuery,
  useSetSelectedUserMutation,
  useSetDefaultUserMutation,
  useAcceptTermsMutation,
  useAcceptWelcomeModalMutation,
  useAcceptTrEducationModalMutation,
  useHandleResetPasswordMutation,
  useForgotPasswordMutation,
  useSendSmsotpMutation,
  useVerifySmsotpMutation,
  useLockAccountMutation,
  useCreatePendingAccountMutation,
  useSubmitPhoneNumberMutation,
  useVerifyPhoneNumberMutation,
  useGetLatestContactChangeQuery,
  useLazyGetLatestContactChangeQuery,
  useCreateContactChangeMutation,
  useCheckPasswordMutation,
  useVerifySecondaryAuthCodeMutation,
  useResendSecondaryAuthCodeMutation,
  useProcessRequestedValuesMutation,
  useVerifyRequestedValueCodeMutation,
  useResendRequestedAuthCodeMutation,
  useCheck2FaCodeMutation,
  useInitiateMfaMutation,
  useClearMfaMutation,
  useSubmitContactChangeMutation,
  useCancelContactChangeMutation,
  useUpdateOnfidoStepsMutation,
  useLoginMutation,
  useLoginV2Mutation,
  useLoginAdminPortalMutation,
  useLoginNativeMutation,
  useRefreshSessionMutation,
  useRefreshSessionV1Mutation,
  useEndSessionMutation,
  useTokenExchangeMutation,
  useVerifyActionTokenMutation,
  useVerifyTransactionRiskMutation,
  useLoginRecordMutation,
  useRiskRecordMutation,
  useMagicLinkMutation,
  useChangePasswordMutation,
  useGetWebAuthnCredentialsQuery,
  useLazyGetWebAuthnCredentialsQuery,
  usePostWebAuthnCredentialsMutation,
  useUpdateWebAuthnCredentialsMutation,
  useDeleteWebAuthnCredentialsMutation,
  useWebauthnTokenExchangeMutation,
  useCreateSms2FaQuery,
  useLazyCreateSms2FaQuery,
  useVerifySms2FaMutation,
  useCreate2FaQuery,
  useLazyCreate2FaQuery,
  useVerify2FaMutation,
  useDeactivate2FaMutation,
  useSendEmailCodeMutation,
  useCheck2FaEmailCodeMutation,
  useHandleContactUsFormMutation,
  useCreateApplicantQuery,
  useLazyCreateApplicantQuery,
  useUpdateReKycStepsQuery,
  useLazyUpdateReKycStepsQuery,
  useValidateSecureBiometricsQuery,
  useLazyValidateSecureBiometricsQuery,
  useAddApplicantToOngoingMonitoringMutation,
  useSlackAppActionHandlerMutation,
  useUpdateKycStepsMutation,
  useGetUserDetailsQuery,
  useLazyGetUserDetailsQuery,
  useHandlePotentialPepMutation,
  useLookUpAddressFromInputQuery,
  useLazyLookUpAddressFromInputQuery,
  useGetPlaceDetailMutation,
  useGetSalesforceAccountsQuery,
  useLazyGetSalesforceAccountsQuery,
  useCreateSalesForceAccountMutation,
  useProcessOnboardingQueuesMutation,
  useRekycSalesForceOpportunityMutation,
  useUploadFileMutation,
  useDeleteFileMutation,
  useEncodeMessageMutation,
  useValidateSecureUploadTokenMutation,
  useHandleSecureFileUploadMutation,
  useHandleOnfidoWorkflowMutation,
  useHandleTimelineFileMutation,
  useCheckIndividualTradingAccountByEmailQuery,
  useLazyCheckIndividualTradingAccountByEmailQuery,
  useGetPreviousSubmissionByEmailQuery,
  useLazyGetPreviousSubmissionByEmailQuery,
  useIsKycExpiredByEmailQuery,
  useLazyIsKycExpiredByEmailQuery,
  useIsDocumentExpiredQuery,
  useLazyIsDocumentExpiredQuery,
  useHandleUnsubscribePreferencesMutation,
  useAddContactToMarketingListMutation,
  useExtractWorkflowDocPropQuery,
  useLazyExtractWorkflowDocPropQuery,
  useGetOccupationListQuery,
  useLazyGetOccupationListQuery,
  useGetIndustriesListQuery,
  useLazyGetIndustriesListQuery,
  useCreateDynamicFileUploadLinkQuery,
  useLazyCreateDynamicFileUploadLinkQuery,
  useDvsDisclosureMutation,
  useOnfidoBiometricsConsentMutation,
  useNotifyBrokerCallMutation,
  useUpdateSsnEinMutation,
  useGetRiskScoreConfigQuery,
  useLazyGetRiskScoreConfigQuery,
  useCreateAccessTokenMutation,
  useWebhookMutation,
  useGetApplicantStatusQuery,
  useLazyGetApplicantStatusQuery,
  useGetTrustfullScoreViaReqQuery,
  useLazyGetTrustfullScoreViaReqQuery,
  useGenerateAssessmentLinkMutation,
  useValidateAssessmentTokenMutation,
  useGetPublicAssessmentQuestionsMutation,
  useSubmitPublicAssessmentMutation,
  useGetUkOnboardingStatusQuery,
  useLazyGetUkOnboardingStatusQuery,
  useMarkRiskSummaryViewedMutation,
  useSubmitUkAccountTypeMutation,
  useRestartUkOnboardingMutation,
  useSubmitInvestorTypeMutation,
  useSubmitRestrictedInvestorStatementMutation,
  useSubmitHnwInvestorStatementMutation,
  useGetAssessmentQuestionsQuery,
  useLazyGetAssessmentQuestionsQuery,
  useSubmitAssessmentMutation,
  useGetAssessmentStatusQuery,
  useLazyGetAssessmentStatusQuery,
  useGetCoolingOffStatusQuery,
  useLazyGetCoolingOffStatusQuery,
  useConfirmAccountMutation,
  useDeclineAccountMutation,
  useGetFundTradesQuery,
  useLazyGetFundTradesQuery,
  useGetFundFlowsQuery,
  useLazyGetFundFlowsQuery,
  useGetFundPositionsQuery,
  useLazyGetFundPositionsQuery,
  useGetAllPublicQuery,
  useLazyGetAllPublicQuery,
  useGetAllQuery,
  useLazyGetAllQuery,
  useCreateMutation,
  useUpdateMutation,
  useDeleteAnnouncementsByIdMutation,
  useGetLinkAnalyticsQuery,
  useLazyGetLinkAnalyticsQuery,
  useGetAllPermissionGroupsQuery,
  useLazyGetAllPermissionGroupsQuery,
  useAddAccountPermissionMutation,
  useGetTransmitUserGroupQuery,
  useLazyGetTransmitUserGroupQuery,
  useRemovePermissionMutation,
  useEditUserPermissionsMutation,
  useGetTransmitUserByEmailQuery,
  useLazyGetTransmitUserByEmailQuery,
  useGetUserByCustomerIdQuery,
  useLazyGetUserByCustomerIdQuery,
  useGetPingQuery,
  useLazyGetPingQuery,
  useGetUserCountQuery,
  useLazyGetUserCountQuery,
  useCountActiveUsersQuery,
  useLazyCountActiveUsersQuery,
  useGetUserAccountCountLast30DaysQuery,
  useLazyGetUserAccountCountLast30DaysQuery,
  useGetUserLoginChartQuery,
  useLazyGetUserLoginChartQuery,
  useHandleAccountStatusMutation,
  useDisable2FaMutation,
  useDisablePasskeyMutation,
  useEditAutomatedTradesDisabledMutation,
  useUpdateFeaturesMutation,
  useGetAllFeaturesQuery,
  useLazyGetAllFeaturesQuery,
  useSetIsEmployeeMutation,
  useGetContactChangesQuery,
  useLazyGetContactChangesQuery,
  useUpdateContactChangeStatusMutation,
  useGetCustomerLogsMutation,
  useGetConfigQuery,
  useLazyGetConfigQuery,
  useCreateBatchLogsMutation,
  useListQuery,
  useLazyListQuery,
  useUpsertMutation,
  usePutAdminFeatureFlagsByKeyOverrideMutation,
  useListTransfersQuery,
  useLazyListTransfersQuery,
  useGetTransferDetailQuery,
  useLazyGetTransferDetailQuery,
  useGetAuditChainQuery,
  useLazyGetAuditChainQuery,
  useForceAuthorizeMutation,
  useReleaseHoldMutation,
  useForceDeclineMutation,
  useRescreenMutation,
  useGetCryptoCurrenciesQuery,
  useLazyGetCryptoCurrenciesQuery,
  useGetCryptoAllQuery,
  useLazyGetCryptoAllQuery,
  useGetCryptoAllTickersQuery,
  useLazyGetCryptoAllTickersQuery,
  useGetTrendingCryptoCurrenciesQuery,
  useLazyGetTrendingCryptoCurrenciesQuery,
  useGetCryptoSectorsQuery,
  useLazyGetCryptoSectorsQuery,
  useGetCoinPageDataQuery,
  useLazyGetCoinPageDataQuery,
  useGetCoinPageChartQuery,
  useLazyGetCoinPageChartQuery,
  useGetTokenChartDataQuery,
  useLazyGetTokenChartDataQuery,
  useGetCandleChartDataQuery,
  useLazyGetCandleChartDataQuery,
  useGetTopRankedQuery,
  useLazyGetTopRankedQuery,
  useIncrementCoinVisitMutation,
  useGetFiatCurrenciesQuery,
  useLazyGetFiatCurrenciesQuery,
  useGetLiveForexQuery,
  useLazyGetLiveForexQuery,
  useGetFiatAndStableCoinsQuery,
  useLazyGetFiatAndStableCoinsQuery,
  useGetMarketTokensListQuery,
  useLazyGetMarketTokensListQuery,
  useGetMarketPageCardsQuery,
  useLazyGetMarketPageCardsQuery,
  useGetBiggestMoversQuery,
  useLazyGetBiggestMoversQuery,
  useGetBestPerformingAssetQuery,
  useLazyGetBestPerformingAssetQuery,
  useGetNewlyListedQuery,
  useLazyGetNewlyListedQuery,
  useGetMarketDataQuery,
  useLazyGetMarketDataQuery,
  useGetTreeMapQuery,
  useLazyGetTreeMapQuery,
  useGetTokenCryptoNewsQuery,
  useLazyGetTokenCryptoNewsQuery,
  useGetDashboardCryptoNewsQuery,
  useLazyGetDashboardCryptoNewsQuery,
  useUpdateCoinNoteMutation,
  useGetCoinNoteQuery,
  useLazyGetCoinNoteQuery,
  useGetUserCurrencyTransactionsQuery,
  useLazyGetUserCurrencyTransactionsQuery,
  useGetUserTransactionStatsQuery,
  useLazyGetUserTransactionStatsQuery,
  useGetUserRecentTransactionsQuery,
  useLazyGetUserRecentTransactionsQuery,
  useGetUserTokenPageRecentTransactionsQuery,
  useLazyGetUserTokenPageRecentTransactionsQuery,
  useGetCreatedCtQuery,
  useLazyGetCreatedCtQuery,
  useGetTargetOrderCtQuery,
  useLazyGetTargetOrderCtQuery,
  useGetTargetOrderTokensQuery,
  useLazyGetTargetOrderTokensQuery,
  useExportCsvQuery,
  useLazyExportCsvQuery,
  useExportCsvKoinlyQuery,
  useLazyExportCsvKoinlyQuery,
  useExportCsvAdminQuery,
  useLazyExportCsvAdminQuery,
  useGetOrderSizeRangeQuery,
  useLazyGetOrderSizeRangeQuery,
  useFilterTransactionsMutation,
  useAddNoteToCtMutation,
  useGetPendingWithdrawalsQuery,
  useLazyGetPendingWithdrawalsQuery,
  useSetWithdrawalApprovalStatusMutation,
  useGetUserDepositAddressQuery,
  useLazyGetUserDepositAddressQuery,
  useProcessDepositMutation,
  useCreateStripeVbankTransferQuery,
  useLazyCreateStripeVbankTransferQuery,
  useHasExistingStripeAccountsQuery,
  useLazyHasExistingStripeAccountsQuery,
  useGetWalletPageBalanceQuery,
  useLazyGetWalletPageBalanceQuery,
  useGetWalletPageHoldingsQuery,
  useLazyGetWalletPageHoldingsQuery,
  useGetWalletPageHoldingsNewQuery,
  useLazyGetWalletPageHoldingsNewQuery,
  useGetBestPerformingHoldingsQuery,
  useLazyGetBestPerformingHoldingsQuery,
  useGetUserHeldCurrenciesQuery,
  useLazyGetUserHeldCurrenciesQuery,
  useGetUserRunningBalanceChartQuery,
  useLazyGetUserRunningBalanceChartQuery,
  useGetAllUserRunningBalanceChartsQuery,
  useLazyGetAllUserRunningBalanceChartsQuery,
  useGetUserFiatHoldingsQuery,
  useLazyGetUserFiatHoldingsQuery,
  useGetReferralsQuery,
  useLazyGetReferralsQuery,
  useGetReferralRewardsQuery,
  useLazyGetReferralRewardsQuery,
  useGetReferralMontlyRewardsQuery,
  useLazyGetReferralMontlyRewardsQuery,
  useCreateReferralUrlQuery,
  useLazyCreateReferralUrlQuery,
  useUpdateLinkShareAnalyticsMutation,
  useSubmitReferralCodeMutation,
  useGetReferredByUserQuery,
  useLazyGetReferredByUserQuery,
  useGetUserDatav2Query,
  useLazyGetUserDatav2Query,
  useGetUserSummaryQuery,
  useLazyGetUserSummaryQuery,
  useGetKycStatusQuery,
  useLazyGetKycStatusQuery,
  useGetWatchlistQuery,
  useLazyGetWatchlistQuery,
  useAddWatchlistMutation,
  useRemoveWatchlistMutation,
  useGetWatchlistV2Query,
  useLazyGetWatchlistV2Query,
  useAddWatchlistV2Mutation,
  useRemoveWatchlistV2Mutation,
  useAcceptStateDisclosureMutation,
  useAcceptDepositDisclosureMutation,
  useGetTodayDisclosureAcceptanceQuery,
  useLazyGetTodayDisclosureAcceptanceQuery,
  usePrepareWithdrawalMutation,
  useCheckWithdrawalEmailCodeMutation,
  useResendWithdrawalEmailCodeMutation,
  useCheckIsUserLockedQuery,
  useLazyCheckIsUserLockedQuery,
  useProcessWithdrawalMutation,
  useProcessFiatWithdrawalMutation,
  useGetMinimumWithdrawalAmountMutation,
  useGetUserCryptoAddressesQuery,
  useLazyGetUserCryptoAddressesQuery,
  useGetUserWithdrawAddressQuery,
  useLazyGetUserWithdrawAddressQuery,
  useAddUserWithdrawAddressMutation,
  usePatchAddressTrFieldsMutation,
  useUpdateUserWithdrawAddressMutation,
  useCheckEmailCodeMutation,
  useVerfiyUserWithdrawAddressEmailMutation,
  useVerifyAddressMutation,
  useResendEmailCodeMutation,
  useCreateCurrencyTransactionReportQuery,
  useLazyCreateCurrencyTransactionReportQuery,
  useCreateAccountReportQuery,
  useLazyCreateAccountReportQuery,
  useCreateAccountReportByIdQuery,
  useLazyCreateAccountReportByIdQuery,
  useCreateAccountReportByCustomerIdQuery,
  useLazyCreateAccountReportByCustomerIdQuery,
  useGetTradeSummaryMutation,
  useCreateCtMutation,
  useGetTargetOrderSummaryMutation,
  useCreateTargetOrderCtMutation,
  useCreateGamMutation,
  useRequestCancelMutation,
  useCreatePriceAlertMutation,
  useEditPriceAlertMutation,
  useDeletePriceAlertMutation,
  useGetPriceAlertsQuery,
  useLazyGetPriceAlertsQuery,
  useGetUnreadNotificationsQuery,
  useLazyGetUnreadNotificationsQuery,
  useSetNotificationsToReadMutation,
  useSetAllNotificationsToReadMutation,
  useClearNotificationsMutation,
  useClearAllNotificationsMutation,
  useGetDcaStrategySummaryMutation,
  useCreateDcaStrategyMutation,
  useGetDcaStrategiesQuery,
  useLazyGetDcaStrategiesQuery,
  useCancelDcaStrategyMutation,
  useGetUserDcaTriggersQuery,
  useLazyGetUserDcaTriggersQuery,
  useUpdateBurlingBankDetailsMutation,
  useGetBurlingBankDetailsQuery,
  useLazyGetBurlingBankDetailsQuery,
  useAddBankDetailsMutation,
  useGetBankDetailsByAccDigitsQuery,
  useLazyGetBankDetailsByAccDigitsQuery,
  useGetBankDetailsQuery,
  useLazyGetBankDetailsQuery,
  useGetReferralsCountQuery,
  useLazyGetReferralsCountQuery,
  useGetReferralConversionMetricsQuery,
  useLazyGetReferralConversionMetricsQuery,
  useGetReferralPartnerFeesQuery,
  useLazyGetReferralPartnerFeesQuery,
  useGetReferralHoldingsQuery,
  useLazyGetReferralHoldingsQuery,
  useGetReferralTradeHistoryQuery,
  useLazyGetReferralTradeHistoryQuery,
  useGetReferralGrowthHistoryQuery,
  useLazyGetReferralGrowthHistoryQuery,
  useGetCoinVisitsQuery,
  useLazyGetCoinVisitsQuery,
  useGetReferralCodeQuery,
  useLazyGetReferralCodeQuery,
  useGetDepositsVolumeQuery,
  useLazyGetDepositsVolumeQuery,
  useGetTimeToFirstTradeQuery,
  useLazyGetTimeToFirstTradeQuery,
  useGetAssetsTradedQuery,
  useLazyGetAssetsTradedQuery,
  useGetReferalPartnerDetailsQuery,
  useLazyGetReferalPartnerDetailsQuery,
  useEvalFlagsQuery,
  useLazyEvalFlagsQuery,
  useGetAccessTokenQuery,
  useLazyGetAccessTokenQuery,
  useCreateTransferMutation,
  useGetTransferQuery,
  useLazyGetTransferQuery,
  useCompleteTransferMutation,
  useGetUserTransfersQuery,
  useLazyGetUserTransfersQuery,
  useCancelTransferMutation,
  useCancelActiveTransfersMutation,
  useNotabeneHandleWebhookMutation,
  useGetDidDocumentQuery,
  useLazyGetDidDocumentQuery,
  useCheckTransferAuthorizedQuery,
  useLazyCheckTransferAuthorizedQuery,
  useGetTrConfigQuery,
  useLazyGetTrConfigQuery,
  useSearchVaspsQuery,
  useLazySearchVaspsQuery,
  useHandleDepositConfirmedMutation,
  useSubmitSenderInfoMutation,
  useListLegalDocumentsQuery,
  useLazyListLegalDocumentsQuery,
  useGetCurrentLegalDocumentQuery,
  useLazyGetCurrentLegalDocumentQuery,
  useGetPublicCurrentLegalDocumentQuery,
  useLazyGetPublicCurrentLegalDocumentQuery,
  useGetLegalDocumentVersionQuery,
  useLazyGetLegalDocumentVersionQuery,
  useListLegalDocumentVersionsQuery,
  useLazyListLegalDocumentVersionsQuery,
  useCreateLegalDocumentDraftMutation,
  usePublishLegalDocumentMutation,
  useCheckQuery,
  useLazyCheckQuery,
} = injectedRtkApi;
